// src/enums.ts
var Role = {
  ADMIN: "ADMIN",
  HR: "HR",
  MANAGER: "MANAGER",
  EMPLOYEE: "EMPLOYEE"
};
var UserStatus = {
  PENDING_ACTIVATION: "PENDING_ACTIVATION",
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  LOCKED: "LOCKED"
};
var Gender = {
  MALE: "MALE",
  FEMALE: "FEMALE",
  OTHER: "OTHER",
  UNDISCLOSED: "UNDISCLOSED"
};
var CivilStatus = {
  SINGLE: "SINGLE",
  MARRIED: "MARRIED",
  WIDOWED: "WIDOWED",
  SEPARATED: "SEPARATED",
  DIVORCED: "DIVORCED"
};
var EmploymentStatus = {
  PROBATIONARY: "PROBATIONARY",
  REGULAR: "REGULAR",
  CONTRACTUAL: "CONTRACTUAL",
  PROJECT_BASED: "PROJECT_BASED",
  PART_TIME: "PART_TIME",
  SEASONAL: "SEASONAL",
  CONSULTANT: "CONSULTANT"
};
var EmployeeStatus = {
  ACTIVE: "ACTIVE",
  ON_LEAVE: "ON_LEAVE",
  SUSPENDED: "SUSPENDED",
  RESIGNED: "RESIGNED",
  TERMINATED: "TERMINATED",
  RETIRED: "RETIRED"
};
var PayFrequency = {
  WEEKLY: "WEEKLY",
  SEMI_MONTHLY: "SEMI_MONTHLY",
  MONTHLY: "MONTHLY"
};
var BankAccountType = {
  SAVINGS: "SAVINGS",
  CHECKING: "CHECKING",
  PAYROLL: "PAYROLL"
};
var BANK_ACCOUNT_TYPE_LABELS = {
  SAVINGS: "Savings",
  CHECKING: "Checking / Current",
  PAYROLL: "Payroll account"
};
var AttendanceStatus = {
  PRESENT: "PRESENT",
  LATE: "LATE",
  ABSENT: "ABSENT",
  HALF_DAY: "HALF_DAY",
  ON_LEAVE: "ON_LEAVE",
  REST_DAY: "REST_DAY",
  HOLIDAY: "HOLIDAY",
  HOLIDAY_WORKED: "HOLIDAY_WORKED",
  SUSPENDED_WORK: "SUSPENDED_WORK"
};
var AttendanceSource = {
  BIOMETRIC: "BIOMETRIC",
  WEB: "WEB",
  MOBILE: "MOBILE",
  MANUAL: "MANUAL",
  IMPORT: "IMPORT"
};
var AttendancePhotoKind = {
  TIME_IN: "TIME_IN",
  TIME_OUT: "TIME_OUT"
};
var LocationPingSource = {
  WEB_FOREGROUND: "WEB_FOREGROUND",
  DEVICE: "DEVICE",
  VEHICLE: "VEHICLE"
};
var ThreadSubject = {
  FUND_REQUEST: "FUND_REQUEST",
  EXPENSE_CLAIM: "EXPENSE_CLAIM",
  LEAVE_REQUEST: "LEAVE_REQUEST",
  RESIGNATION: "RESIGNATION"
};
var ChatThreadKind = {
  DIRECT: "DIRECT",
  GROUP: "GROUP"
};
var ChatMessageKind = {
  TEXT: "TEXT",
  SYSTEM: "SYSTEM"
};
var ChatAttachmentKind = {
  IMAGE: "IMAGE",
  VIDEO: "VIDEO",
  FILE: "FILE"
};
var ChatReactionKind = {
  LIKE: "LIKE",
  LOVE: "LOVE",
  HAHA: "HAHA",
  WOW: "WOW",
  SAD: "SAD",
  ANGRY: "ANGRY"
};
var ApprovalStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  CANCELLED: "CANCELLED"
};
var LeaveRequestStatus = {
  DRAFT: "DRAFT",
  PENDING_MANAGER: "PENDING_MANAGER",
  PENDING_HR: "PENDING_HR",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  CANCELLED: "CANCELLED"
};
var ApprovalLevel = {
  MANAGER: "MANAGER",
  HR: "HR"
};
var ApprovalAction = {
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  RETURNED: "RETURNED"
};
var DayPortion = {
  FULL_DAY: "FULL_DAY",
  FIRST_HALF: "FIRST_HALF",
  SECOND_HALF: "SECOND_HALF"
};
var PayrollPeriodStatus = {
  OPEN: "OPEN",
  LOCKED: "LOCKED",
  CLOSED: "CLOSED"
};
var PayrollRunStatus = {
  DRAFT: "DRAFT",
  CALCULATING: "CALCULATING",
  CALCULATED: "CALCULATED",
  FOR_APPROVAL: "FOR_APPROVAL",
  APPROVED: "APPROVED",
  PAID: "PAID",
  CANCELLED: "CANCELLED"
};
var PayComponentType = {
  EARNING: "EARNING",
  DEDUCTION: "DEDUCTION",
  EMPLOYEE_CONTRIBUTION: "EMPLOYEE_CONTRIBUTION",
  EMPLOYER_CONTRIBUTION: "EMPLOYER_CONTRIBUTION"
};
var ContributionType = {
  SSS: "SSS",
  PHILHEALTH: "PHILHEALTH",
  PAGIBIG: "PAGIBIG",
  WITHHOLDING_TAX: "WITHHOLDING_TAX"
};
var InsurancePolicyType = {
  HMO: "HMO",
  LIFE: "LIFE",
  ACCIDENT: "ACCIDENT",
  CRITICAL_ILLNESS: "CRITICAL_ILLNESS",
  DENTAL: "DENTAL",
  OTHER: "OTHER"
};
var CoverageStatus = {
  PENDING: "PENDING",
  ACTIVE: "ACTIVE",
  EXPIRED: "EXPIRED",
  CANCELLED: "CANCELLED",
  SUSPENDED: "SUSPENDED"
};
var ReviewCycleStatus = {
  DRAFT: "DRAFT",
  OPEN: "OPEN",
  IN_REVIEW: "IN_REVIEW",
  CALIBRATION: "CALIBRATION",
  CLOSED: "CLOSED"
};
var ReviewStatus = {
  NOT_STARTED: "NOT_STARTED",
  SELF_ASSESSMENT: "SELF_ASSESSMENT",
  MANAGER_REVIEW: "MANAGER_REVIEW",
  ACKNOWLEDGEMENT: "ACKNOWLEDGEMENT",
  COMPLETED: "COMPLETED"
};
var GoalStatus = {
  NOT_STARTED: "NOT_STARTED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  DEFERRED: "DEFERRED",
  CANCELLED: "CANCELLED"
};
var HolidayType = {
  REGULAR: "REGULAR",
  SPECIAL_NON_WORKING: "SPECIAL_NON_WORKING",
  SPECIAL_WORKING: "SPECIAL_WORKING",
  COMPANY: "COMPANY"
};
var AnnouncementAudience = {
  ALL: "ALL",
  DEPARTMENT: "DEPARTMENT",
  ROLE: "ROLE"
};
var AnnouncementStatus = {
  DRAFT: "DRAFT",
  PUBLISHED: "PUBLISHED",
  ARCHIVED: "ARCHIVED"
};
var DisciplinarySeverity = {
  MINOR: "MINOR",
  MAJOR: "MAJOR",
  GRAVE: "GRAVE"
};
var DisciplinaryStatus = {
  REPORTED: "REPORTED",
  UNDER_INVESTIGATION: "UNDER_INVESTIGATION",
  NOTICE_TO_EXPLAIN: "NOTICE_TO_EXPLAIN",
  RESOLVED: "RESOLVED",
  DISMISSED: "DISMISSED",
  APPEALED: "APPEALED"
};
var DisciplinaryActionType = {
  VERBAL_WARNING: "VERBAL_WARNING",
  WRITTEN_WARNING: "WRITTEN_WARNING",
  FINAL_WARNING: "FINAL_WARNING",
  SUSPENSION: "SUSPENSION",
  DEMOTION: "DEMOTION",
  TERMINATION: "TERMINATION"
};
var AwardCategory = {
  EMPLOYEE_OF_THE_MONTH: "EMPLOYEE_OF_THE_MONTH",
  RECOGNITION: "RECOGNITION",
  SERVICE_AWARD: "SERVICE_AWARD",
  PERFORMANCE: "PERFORMANCE",
  SAFETY: "SAFETY",
  OTHER: "OTHER"
};
var TrainingType = {
  TRAINING: "TRAINING",
  SEMINAR: "SEMINAR",
  WORKSHOP: "WORKSHOP",
  CERTIFICATION: "CERTIFICATION",
  ONBOARDING: "ONBOARDING",
  COMPLIANCE: "COMPLIANCE"
};
var TrainingSessionStatus = {
  SCHEDULED: "SCHEDULED",
  ONGOING: "ONGOING",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED"
};
var EnrollmentStatus = {
  ENROLLED: "ENROLLED",
  ATTENDED: "ATTENDED",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  NO_SHOW: "NO_SHOW",
  CANCELLED: "CANCELLED"
};
var AssetStatus = {
  AVAILABLE: "AVAILABLE",
  ASSIGNED: "ASSIGNED",
  IN_REPAIR: "IN_REPAIR",
  DAMAGED: "DAMAGED",
  LOST: "LOST",
  RETIRED: "RETIRED"
};
var PayComponentBasis = {
  MONTHLY: "MONTHLY",
  PER_RUN: "PER_RUN"
};
var AssetCondition = {
  NEW: "NEW",
  GOOD: "GOOD",
  FAIR: "FAIR",
  POOR: "POOR",
  DAMAGED: "DAMAGED"
};
var AssetAssignmentStatus = {
  ASSIGNED: "ASSIGNED",
  RETURNED: "RETURNED",
  DAMAGED: "DAMAGED",
  LOST: "LOST"
};
var MovementType = {
  PROMOTION: "PROMOTION",
  TRANSFER: "TRANSFER",
  DEPARTMENT_CHANGE: "DEPARTMENT_CHANGE",
  POSITION_CHANGE: "POSITION_CHANGE",
  SALARY_ADJUSTMENT: "SALARY_ADJUSTMENT",
  STATUS_CHANGE: "STATUS_CHANGE",
  REGULARIZATION: "REGULARIZATION",
  MANAGER_CHANGE: "MANAGER_CHANGE"
};
var ResignationStatus = {
  SUBMITTED: "SUBMITTED",
  ACKNOWLEDGED: "ACKNOWLEDGED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  WITHDRAWN: "WITHDRAWN",
  COMPLETED: "COMPLETED"
};
var ClearanceStatus = {
  PENDING: "PENDING",
  CLEARED: "CLEARED",
  WITH_ACCOUNTABILITY: "WITH_ACCOUNTABILITY",
  WAIVED: "WAIVED"
};
var FinalPayStatus = {
  PENDING: "PENDING",
  COMPUTED: "COMPUTED",
  APPROVED: "APPROVED",
  RELEASED: "RELEASED"
};
var RequestStatus = {
  SUBMITTED: "SUBMITTED",
  IN_PROGRESS: "IN_PROGRESS",
  FOR_RELEASE: "FOR_RELEASE",
  COMPLETED: "COMPLETED",
  REJECTED: "REJECTED",
  CANCELLED: "CANCELLED"
};
var RequestPriority = {
  LOW: "LOW",
  NORMAL: "NORMAL",
  HIGH: "HIGH",
  URGENT: "URGENT"
};
var NotificationChannel = {
  IN_APP: "IN_APP",
  EMAIL: "EMAIL"
};
var EmailStatus = {
  QUEUED: "QUEUED",
  SENDING: "SENDING",
  SENT: "SENT",
  FAILED: "FAILED",
  BOUNCED: "BOUNCED"
};
var DocumentVisibility = {
  PRIVATE: "PRIVATE",
  HR_ONLY: "HR_ONLY",
  MANAGER: "MANAGER",
  EMPLOYEE: "EMPLOYEE",
  PUBLIC: "PUBLIC"
};
var AttachableType = {
  EMPLOYEE: "EMPLOYEE",
  LEAVE_REQUEST: "LEAVE_REQUEST",
  DISCIPLINARY_CASE: "DISCIPLINARY_CASE",
  DISCIPLINARY_ACTION: "DISCIPLINARY_ACTION",
  TRAINING_ENROLLMENT: "TRAINING_ENROLLMENT",
  CERTIFICATION: "CERTIFICATION",
  EMPLOYEE_REQUEST: "EMPLOYEE_REQUEST",
  RESIGNATION: "RESIGNATION",
  EMPLOYEE_INSURANCE: "EMPLOYEE_INSURANCE",
  ASSET: "ASSET",
  PAYSLIP: "PAYSLIP",
  ANNOUNCEMENT: "ANNOUNCEMENT",
  PERFORMANCE_REVIEW: "PERFORMANCE_REVIEW"
};
var AuditAction = {
  CREATE: "CREATE",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  LOGIN_FAILED: "LOGIN_FAILED",
  PASSWORD_RESET: "PASSWORD_RESET",
  APPROVE: "APPROVE",
  REJECT: "REJECT",
  EXPORT: "EXPORT",
  IMPORT: "IMPORT",
  PAYROLL_PROCESS: "PAYROLL_PROCESS",
  PERMISSION_CHANGE: "PERMISSION_CHANGE",
  SETTING_CHANGE: "SETTING_CHANGE"
};
var FundRequestStatus = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  MANAGER_REVIEW: "MANAGER_REVIEW",
  HR_REVIEW: "HR_REVIEW",
  MANAGEMENT_REVIEW: "MANAGEMENT_REVIEW",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  FOR_RELEASE: "FOR_RELEASE",
  RELEASED: "RELEASED",
  PARTIALLY_LIQUIDATED: "PARTIALLY_LIQUIDATED",
  FULLY_LIQUIDATED: "FULLY_LIQUIDATED",
  FUND_RETURN_REQUIRED: "FUND_RETURN_REQUIRED",
  REIMBURSEMENT_REQUIRED: "REIMBURSEMENT_REQUIRED",
  CLOSED: "CLOSED",
  CANCELLED: "CANCELLED"
};
var FundApprovalLevel = {
  MANAGER: "MANAGER",
  HR: "HR",
  MANAGEMENT: "MANAGEMENT"
};
var ExpenseClaimStatus = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  MANAGER_REVIEW: "MANAGER_REVIEW",
  HR_REVIEW: "HR_REVIEW",
  MANAGEMENT_REVIEW: "MANAGEMENT_REVIEW",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  PAID: "PAID",
  CANCELLED: "CANCELLED"
};
var FundAttachmentKind = {
  TRANSFER_PROOF: "TRANSFER_PROOF",
  RECEIPT: "RECEIPT",
  PURCHASE_PROOF: "PURCHASE_PROOF"
};
var FundSettlementKind = {
  RETURN: "RETURN",
  REIMBURSEMENT: "REIMBURSEMENT"
};
var LiquidationStatus = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  VERIFIED: "VERIFIED",
  REJECTED: "REJECTED"
};
var FundReleaseMethod = {
  CASH: "CASH",
  BANK_TRANSFER: "BANK_TRANSFER",
  GCASH: "GCASH",
  CHECK: "CHECK"
};
var FuelType = {
  GASOLINE: "GASOLINE",
  DIESEL: "DIESEL",
  ELECTRIC: "ELECTRIC",
  HYBRID: "HYBRID"
};
var VehicleStatus = {
  ACTIVE: "ACTIVE",
  IN_SERVICE: "IN_SERVICE",
  RETIRED: "RETIRED"
};

// src/user-agent.ts
var DESKTOP_PLATFORMS = [/windows nt/i, /macintosh/i, /cros/i, /x11/i];
var MOBILE_MARKERS = [/android/i, /iphone/i, /ipad/i, /ipod/i, /mobile/i, /tablet/i];
function looksLikeDesktopBrowser(userAgent) {
  if (!userAgent) return false;
  if (MOBILE_MARKERS.some((pattern) => pattern.test(userAgent))) return false;
  return DESKTOP_PLATFORMS.some((pattern) => pattern.test(userAgent));
}

// src/permissions.ts
var PERMISSIONS = {
  // --- Dashboard & analytics -------------------------------------------
  DASHBOARD_VIEW: "dashboard:view",
  ANALYTICS_VIEW: "analytics:view",
  // --- Employees --------------------------------------------------------
  EMPLOYEE_READ_OWN: "employee:read:own",
  EMPLOYEE_READ_TEAM: "employee:read:team",
  EMPLOYEE_READ_ALL: "employee:read:all",
  EMPLOYEE_CREATE: "employee:create",
  EMPLOYEE_UPDATE_OWN: "employee:update:own",
  EMPLOYEE_UPDATE_ALL: "employee:update:all",
  EMPLOYEE_DELETE: "employee:delete",
  EMPLOYEE_EXPORT: "employee:export",
  // --- Org structure ----------------------------------------------------
  DEPARTMENT_READ: "department:read",
  DEPARTMENT_MANAGE: "department:manage",
  POSITION_READ: "position:read",
  POSITION_MANAGE: "position:manage",
  SALARY_GRADE_READ: "salary-grade:read",
  SALARY_GRADE_MANAGE: "salary-grade:manage",
  ORG_CHART_VIEW: "org-chart:view",
  // --- Work schedules ---------------------------------------------------
  WORK_SCHEDULE_READ: "work-schedule:read",
  WORK_SCHEDULE_MANAGE: "work-schedule:manage",
  // --- Attendance -------------------------------------------------------
  ATTENDANCE_READ_OWN: "attendance:read:own",
  ATTENDANCE_READ_TEAM: "attendance:read:team",
  ATTENDANCE_READ_ALL: "attendance:read:all",
  ATTENDANCE_PUNCH: "attendance:punch",
  ATTENDANCE_MANAGE: "attendance:manage",
  ATTENDANCE_APPROVE_CORRECTION: "attendance:approve-correction",
  ATTENDANCE_AUTHORISE_REST_DAY: "attendance:authorise-rest-day",
  ATTENDANCE_EXPORT: "attendance:export",
  // --- Leave ------------------------------------------------------------
  LEAVE_READ_OWN: "leave:read:own",
  LEAVE_READ_TEAM: "leave:read:team",
  LEAVE_READ_ALL: "leave:read:all",
  LEAVE_REQUEST: "leave:request",
  // Hyphenated, not `leave:approve:manager`. The third segment is reserved for
  // row scope (`own`/`team`/`all`) everywhere else in this catalogue, and an
  // approval *level* sitting in that slot would be ambiguous to read and to
  // `resolveScope`.
  /** First-level approval, exercised by the reporting manager. */
  LEAVE_APPROVE_MANAGER: "leave:approve-manager",
  /** Final approval, exercised by HR. */
  LEAVE_APPROVE_HR: "leave:approve-hr",
  LEAVE_MANAGE_TYPES: "leave:manage-types",
  LEAVE_MANAGE_BALANCES: "leave:manage-balances",
  LEAVE_EXPORT: "leave:export",
  // --- Payroll ----------------------------------------------------------
  PAYSLIP_READ_OWN: "payslip:read:own",
  PAYSLIP_READ_ALL: "payslip:read:all",
  PAYROLL_PROCESS: "payroll:process",
  PAYROLL_APPROVE: "payroll:approve",
  PAYROLL_MANAGE_COMPONENTS: "payroll:manage-components",
  PAYROLL_MANAGE_CONTRIBUTIONS: "payroll:manage-contributions",
  PAYROLL_EXPORT: "payroll:export",
  // --- Insurance --------------------------------------------------------
  INSURANCE_READ_OWN: "insurance:read:own",
  INSURANCE_READ_ALL: "insurance:read:all",
  INSURANCE_MANAGE: "insurance:manage",
  INSURANCE_EXPORT: "insurance:export",
  // --- Performance ------------------------------------------------------
  PERFORMANCE_READ_OWN: "performance:read:own",
  PERFORMANCE_READ_TEAM: "performance:read:team",
  PERFORMANCE_READ_ALL: "performance:read:all",
  PERFORMANCE_REVIEW: "performance:review",
  PERFORMANCE_MANAGE: "performance:manage",
  GOAL_MANAGE_OWN: "goal:manage:own",
  GOAL_MANAGE_TEAM: "goal:manage:team",
  // --- Documents --------------------------------------------------------
  DOCUMENT_READ_OWN: "document:read:own",
  DOCUMENT_READ_ALL: "document:read:all",
  DOCUMENT_UPLOAD_OWN: "document:upload:own",
  DOCUMENT_MANAGE: "document:manage",
  // --- Company-wide records --------------------------------------------
  HOLIDAY_READ: "holiday:read",
  HOLIDAY_MANAGE: "holiday:manage",
  ANNOUNCEMENT_READ: "announcement:read",
  ANNOUNCEMENT_MANAGE: "announcement:manage",
  DISCIPLINARY_READ_OWN: "disciplinary:read:own",
  DISCIPLINARY_READ_ALL: "disciplinary:read:all",
  DISCIPLINARY_MANAGE: "disciplinary:manage",
  AWARD_READ: "award:read",
  AWARD_MANAGE: "award:manage",
  // --- Training ---------------------------------------------------------
  TRAINING_READ_OWN: "training:read:own",
  TRAINING_READ_ALL: "training:read:all",
  TRAINING_MANAGE: "training:manage",
  TRAINING_EXPORT: "training:export",
  // --- Assets -----------------------------------------------------------
  ASSET_READ_OWN: "asset:read:own",
  ASSET_READ_ALL: "asset:read:all",
  ASSET_MANAGE: "asset:manage",
  ASSET_EXPORT: "asset:export",
  // --- Location ---------------------------------------------------------
  /** Send your own position. Held by everyone who is tracked. */
  LOCATION_SHARE: "location:share",
  LOCATION_READ_TEAM: "location:read:team",
  LOCATION_READ_ALL: "location:read:all",
  // --- Integrations -----------------------------------------------------
  /**
   * See the link out to UISP.
   *
   * Governs a link and nothing more — UISP does its own authentication, and
   * holding this grants no access there. Held by every role: KioBytes decided
   * staff generally work in UISP, and someone without a UISP account simply
   * finds a login page they cannot pass, which costs them nothing.
   */
  UISP_OPEN: "uisp:open",
  // --- Chat -------------------------------------------------------------
  /**
   * Shape the conversations: open a direct thread or a group, and decide who
   * is in a group — add, remove, or leave.
   *
   * The only permission in the chat. Reading, replying and renaming are
   * decided by membership, not by a grant; this governs who may make a
   * conversation exist and who may change its membership. KioBytes chose
   * ADMIN alone, so it is not in EMPLOYEE_PERMISSIONS and reaches ADMIN
   * through ALL_PERMISSIONS. Grantable to HR or a manager from the
   * Permissions screen without a deploy.
   */
  CHAT_MANAGE: "chat:manage",
  // --- History & offboarding -------------------------------------------
  EMPLOYEE_HISTORY_READ_OWN: "employee-history:read:own",
  EMPLOYEE_HISTORY_READ_ALL: "employee-history:read:all",
  EMPLOYEE_HISTORY_MANAGE: "employee-history:manage",
  RESIGNATION_SUBMIT: "resignation:submit",
  RESIGNATION_READ_OWN: "resignation:read:own",
  RESIGNATION_READ_ALL: "resignation:read:all",
  RESIGNATION_MANAGE: "resignation:manage",
  // --- Employee requests ------------------------------------------------
  REQUEST_SUBMIT: "request:submit",
  REQUEST_READ_OWN: "request:read:own",
  REQUEST_READ_TEAM: "request:read:team",
  REQUEST_READ_ALL: "request:read:all",
  REQUEST_PROCESS: "request:process",
  // --- Finance ----------------------------------------------------------
  // Split by verb rather than by screen: releasing money and approving a
  // request are different acts by different people, and a single
  // `finance:manage` would have collapsed the separation of duties the
  // approval ladder exists to create.
  FUND_REQUEST_SUBMIT: "fund-request:submit",
  FUND_REQUEST_READ_OWN: "fund-request:read:own",
  FUND_REQUEST_READ_TEAM: "fund-request:read:team",
  FUND_REQUEST_READ_ALL: "fund-request:read:all",
  FUND_REQUEST_APPROVE_MANAGER: "fund-request:approve-manager",
  FUND_REQUEST_APPROVE_HR: "fund-request:approve-hr",
  FUND_REQUEST_APPROVE_MANAGEMENT: "fund-request:approve-management",
  FUND_RELEASE: "fund:release",
  EXPENSE_SUBMIT: "expense:submit",
  EXPENSE_READ_ALL: "expense:read:all",
  EXPENSE_MANAGE: "expense:manage",
  LIQUIDATION_SUBMIT: "liquidation:submit",
  LIQUIDATION_VERIFY: "liquidation:verify",
  REIMBURSEMENT_SUBMIT: "reimbursement:submit",
  REIMBURSEMENT_PAY: "reimbursement:pay",
  VEHICLE_READ: "vehicle:read",
  VEHICLE_MANAGE: "vehicle:manage",
  FUEL_SUBMIT: "fuel:submit",
  FUEL_READ_ALL: "fuel:read:all",
  BUDGET_READ: "budget:read",
  BUDGET_MANAGE: "budget:manage",
  FINANCE_SETTINGS_MANAGE: "finance-settings:manage",
  FINANCE_REPORT_VIEW: "finance-report:view",
  // --- Reports ----------------------------------------------------------
  REPORT_VIEW: "report:view",
  REPORT_EXPORT: "report:export",
  // --- Administration ---------------------------------------------------
  USER_READ: "user:read",
  USER_MANAGE: "user:manage",
  PERMISSION_MANAGE: "permission:manage",
  AUDIT_LOG_READ: "audit-log:read",
  SETTING_READ: "setting:read",
  SETTING_MANAGE: "setting:manage"
};
var ALL_PERMISSIONS = Object.values(PERMISSIONS);
var EMPLOYEE_PERMISSIONS = [
  PERMISSIONS.DASHBOARD_VIEW,
  PERMISSIONS.EMPLOYEE_READ_OWN,
  PERMISSIONS.EMPLOYEE_UPDATE_OWN,
  PERMISSIONS.ORG_CHART_VIEW,
  PERMISSIONS.DEPARTMENT_READ,
  PERMISSIONS.POSITION_READ,
  PERMISSIONS.WORK_SCHEDULE_READ,
  PERMISSIONS.ATTENDANCE_READ_OWN,
  PERMISSIONS.ATTENDANCE_PUNCH,
  // Sending your own position. Whether anything is actually sent is the
  // `location.tracking` setting's call, not this grant's — revoking it here
  // exempts one role, switching the setting off stops the whole company.
  PERMISSIONS.LOCATION_SHARE,
  // Seeing the sidebar link to UISP. MANAGER and HR spread this list, so they
  // inherit it — there is no version of this where an employee may open UISP
  // and their manager may not.
  PERMISSIONS.UISP_OPEN,
  PERMISSIONS.LEAVE_READ_OWN,
  PERMISSIONS.LEAVE_REQUEST,
  PERMISSIONS.PAYSLIP_READ_OWN,
  PERMISSIONS.INSURANCE_READ_OWN,
  PERMISSIONS.PERFORMANCE_READ_OWN,
  PERMISSIONS.GOAL_MANAGE_OWN,
  PERMISSIONS.DOCUMENT_READ_OWN,
  PERMISSIONS.DOCUMENT_UPLOAD_OWN,
  PERMISSIONS.HOLIDAY_READ,
  PERMISSIONS.ANNOUNCEMENT_READ,
  PERMISSIONS.DISCIPLINARY_READ_OWN,
  PERMISSIONS.AWARD_READ,
  PERMISSIONS.TRAINING_READ_OWN,
  PERMISSIONS.ASSET_READ_OWN,
  PERMISSIONS.EMPLOYEE_HISTORY_READ_OWN,
  PERMISSIONS.RESIGNATION_SUBMIT,
  PERMISSIONS.RESIGNATION_READ_OWN,
  PERMISSIONS.REQUEST_SUBMIT,
  PERMISSIONS.REQUEST_READ_OWN,
  // Everyone spends company money on the company's behalf sooner or later —
  // fuel, parking, a courier. These are the employee's own side of that.
  PERMISSIONS.FUND_REQUEST_SUBMIT,
  PERMISSIONS.FUND_REQUEST_READ_OWN,
  PERMISSIONS.EXPENSE_SUBMIT,
  PERMISSIONS.LIQUIDATION_SUBMIT,
  PERMISSIONS.REIMBURSEMENT_SUBMIT,
  PERMISSIONS.FUEL_SUBMIT,
  PERMISSIONS.VEHICLE_READ
];
var MANAGER_PERMISSIONS = [
  ...EMPLOYEE_PERMISSIONS,
  PERMISSIONS.EMPLOYEE_READ_TEAM,
  PERMISSIONS.ATTENDANCE_READ_TEAM,
  PERMISSIONS.LOCATION_READ_TEAM,
  PERMISSIONS.ATTENDANCE_APPROVE_CORRECTION,
  PERMISSIONS.ATTENDANCE_AUTHORISE_REST_DAY,
  PERMISSIONS.LEAVE_READ_TEAM,
  PERMISSIONS.LEAVE_APPROVE_MANAGER,
  PERMISSIONS.PERFORMANCE_READ_TEAM,
  PERMISSIONS.PERFORMANCE_REVIEW,
  PERMISSIONS.GOAL_MANAGE_TEAM,
  PERMISSIONS.REQUEST_READ_TEAM,
  PERMISSIONS.REPORT_VIEW,
  PERMISSIONS.FUND_REQUEST_READ_TEAM,
  PERMISSIONS.FUND_REQUEST_APPROVE_MANAGER,
  // A manager records spending directly — section 12 — but cannot release
  // funds against it. Approving and paying stay in different hands.
  PERMISSIONS.EXPENSE_MANAGE
];
var HR_PERMISSIONS = [
  ...EMPLOYEE_PERMISSIONS,
  PERMISSIONS.EMPLOYEE_READ_ALL,
  PERMISSIONS.LOCATION_READ_ALL,
  PERMISSIONS.EMPLOYEE_CREATE,
  PERMISSIONS.EMPLOYEE_UPDATE_ALL,
  PERMISSIONS.EMPLOYEE_EXPORT,
  PERMISSIONS.DEPARTMENT_MANAGE,
  PERMISSIONS.POSITION_MANAGE,
  PERMISSIONS.SALARY_GRADE_READ,
  PERMISSIONS.SALARY_GRADE_MANAGE,
  PERMISSIONS.WORK_SCHEDULE_MANAGE,
  PERMISSIONS.ATTENDANCE_READ_ALL,
  PERMISSIONS.ATTENDANCE_MANAGE,
  PERMISSIONS.ATTENDANCE_APPROVE_CORRECTION,
  PERMISSIONS.ATTENDANCE_AUTHORISE_REST_DAY,
  PERMISSIONS.ATTENDANCE_EXPORT,
  PERMISSIONS.LEAVE_READ_ALL,
  PERMISSIONS.LEAVE_APPROVE_HR,
  PERMISSIONS.LEAVE_MANAGE_TYPES,
  PERMISSIONS.LEAVE_MANAGE_BALANCES,
  PERMISSIONS.LEAVE_EXPORT,
  PERMISSIONS.PAYSLIP_READ_ALL,
  PERMISSIONS.PAYROLL_PROCESS,
  PERMISSIONS.PAYROLL_MANAGE_COMPONENTS,
  PERMISSIONS.PAYROLL_EXPORT,
  PERMISSIONS.INSURANCE_READ_ALL,
  PERMISSIONS.INSURANCE_MANAGE,
  PERMISSIONS.INSURANCE_EXPORT,
  PERMISSIONS.PERFORMANCE_READ_ALL,
  PERMISSIONS.PERFORMANCE_MANAGE,
  PERMISSIONS.DOCUMENT_READ_ALL,
  PERMISSIONS.DOCUMENT_MANAGE,
  PERMISSIONS.HOLIDAY_MANAGE,
  PERMISSIONS.ANNOUNCEMENT_MANAGE,
  PERMISSIONS.DISCIPLINARY_READ_ALL,
  PERMISSIONS.DISCIPLINARY_MANAGE,
  PERMISSIONS.AWARD_MANAGE,
  PERMISSIONS.TRAINING_READ_ALL,
  PERMISSIONS.TRAINING_MANAGE,
  PERMISSIONS.TRAINING_EXPORT,
  PERMISSIONS.ASSET_READ_ALL,
  PERMISSIONS.ASSET_MANAGE,
  PERMISSIONS.ASSET_EXPORT,
  PERMISSIONS.EMPLOYEE_HISTORY_READ_ALL,
  PERMISSIONS.EMPLOYEE_HISTORY_MANAGE,
  PERMISSIONS.RESIGNATION_READ_ALL,
  PERMISSIONS.RESIGNATION_MANAGE,
  PERMISSIONS.REQUEST_READ_ALL,
  PERMISSIONS.REQUEST_PROCESS,
  PERMISSIONS.REPORT_VIEW,
  PERMISSIONS.REPORT_EXPORT,
  PERMISSIONS.ANALYTICS_VIEW,
  PERMISSIONS.USER_READ,
  // Finance sits with HR here, as it does in the building. Note what is
  // absent: FUND_REQUEST_APPROVE_MANAGEMENT and BUDGET_MANAGE. HR verifies and
  // pays; it does not authorise the largest amounts or set its own budget,
  // which is the same separation payroll already has between processing a run
  // and approving it.
  PERMISSIONS.FUND_REQUEST_READ_ALL,
  PERMISSIONS.FUND_REQUEST_APPROVE_HR,
  PERMISSIONS.FUND_RELEASE,
  PERMISSIONS.EXPENSE_READ_ALL,
  PERMISSIONS.EXPENSE_MANAGE,
  PERMISSIONS.LIQUIDATION_VERIFY,
  PERMISSIONS.REIMBURSEMENT_PAY,
  PERMISSIONS.VEHICLE_MANAGE,
  PERMISSIONS.FUEL_READ_ALL,
  PERMISSIONS.BUDGET_READ,
  PERMISSIONS.FINANCE_REPORT_VIEW
];
var DEFAULT_ROLE_PERMISSIONS = {
  [Role.ADMIN]: ALL_PERMISSIONS,
  [Role.HR]: HR_PERMISSIONS,
  [Role.MANAGER]: MANAGER_PERMISSIONS,
  [Role.EMPLOYEE]: EMPLOYEE_PERMISSIONS
};
var ACCESS_SCOPES = ["all", "team", "own"];
function resolveScope(granted, resource, action) {
  for (const scope of ACCESS_SCOPES) {
    if (granted.has(`${resource}:${action}:${scope}`)) return scope;
  }
  return null;
}

// src/pagination.ts
import { z } from "zod";
var DEFAULT_PAGE_SIZE = 100;
var MAX_PAGE_SIZE = 100;
var sortOrderSchema = z.enum(["asc", "desc"]);
var paginationQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
  sortBy: z.string().min(1).max(64).optional(),
  sortOrder: sortOrderSchema.default("desc"),
  /** Free-text search; each endpoint documents the fields it covers. */
  search: z.string().trim().max(200).optional()
});
function buildPaginationMeta(page, pageSize, totalItems) {
  const totalPages = pageSize > 0 ? Math.ceil(totalItems / pageSize) : 0;
  return {
    page,
    pageSize,
    totalItems,
    totalPages,
    hasNextPage: page < totalPages,
    hasPreviousPage: page > 1
  };
}
function toPrismaPaging(query) {
  return { skip: (query.page - 1) * query.pageSize, take: query.pageSize };
}

// src/api.ts
var API_ERROR_CODES = {
  VALIDATION_FAILED: "VALIDATION_FAILED",
  UNAUTHENTICATED: "UNAUTHENTICATED",
  INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
  TOKEN_EXPIRED: "TOKEN_EXPIRED",
  ACCOUNT_LOCKED: "ACCOUNT_LOCKED",
  ACCOUNT_INACTIVE: "ACCOUNT_INACTIVE",
  FORBIDDEN: "FORBIDDEN",
  NOT_FOUND: "NOT_FOUND",
  CONFLICT: "CONFLICT",
  DUPLICATE_ENTRY: "DUPLICATE_ENTRY",
  IN_USE: "IN_USE",
  /** The action is invalid for the record's current state (e.g. approving a
   *  cancelled leave request). */
  INVALID_STATE: "INVALID_STATE",
  RATE_LIMITED: "RATE_LIMITED",
  PAYLOAD_TOO_LARGE: "PAYLOAD_TOO_LARGE",
  UNSUPPORTED_FILE_TYPE: "UNSUPPORTED_FILE_TYPE",
  INTERNAL_ERROR: "INTERNAL_ERROR"
};
function isApiErrorResponse(value) {
  if (typeof value !== "object" || value === null) return false;
  const candidate = value;
  return typeof candidate.statusCode === "number" && typeof candidate.code === "string";
}

// src/notifications.ts
import { z as z2 } from "zod";
var NOTIFICATION_TYPES = {
  LEAVE_SUBMITTED: "leave.submitted",
  LEAVE_APPROVED_MANAGER: "leave.approved.manager",
  LEAVE_APPROVED: "leave.approved",
  LEAVE_REJECTED: "leave.rejected",
  LEAVE_CANCELLED: "leave.cancelled",
  PAYSLIP_AVAILABLE: "payroll.payslip.available",
  PAYROLL_FOR_APPROVAL: "payroll.run.for-approval",
  PAYROLL_APPROVED: "payroll.run.approved",
  ATTENDANCE_CORRECTION_SUBMITTED: "attendance.correction.submitted",
  ATTENDANCE_CORRECTION_RESOLVED: "attendance.correction.resolved",
  ANNOUNCEMENT_PUBLISHED: "announcement.published",
  /**
   * Somebody who is not the record's owner asked something on it.
   *
   * In the base catalogue rather than the finance one, because the subjects are
   * no longer only financial — a leave request and a resignation carry these
   * too — and because only this group is in ALL_NOTIFICATION_TYPES, which is
   * what makes an event something a person can switch off.
   *
   * One-directional on purpose: whoever asked is already looking at the record,
   * and the owner is not. Notifying every message in both directions is how a
   * useful thing becomes a noisy one for thirty-nine people.
   */
  RECORD_DISCUSSION_QUESTION: "record.discussion.question",
  /**
   * Somebody wrote to you in the chat, and you had nothing unread there.
   *
   * One per conversation per unread episode, not one per message: the second
   * and third lines of a reply must not each ring the bell. The next
   * notification for that thread comes only after the person has read it.
   * Carries no message text, for the same reason the discussion one does not:
   * a copy in `notifications` would outlive edits and deletions of the line,
   * and is swept on the notification windows (`notifications.retention`)
   * rather than the chat's.
   */
  CHAT_MESSAGE: "chat.message",
  /**
   * Somebody named you, with an "@", in a chat line.
   *
   * Unlike `chat.message` this one is raised every time, unread episode or
   * not: being called by name is the one thing a person asks to be
   * interrupted for. Links to the line itself. Carries no text, for the
   * same reason the message notice does not, and is swept on the chat's
   * clock beside it.
   */
  CHAT_MENTION: "chat.mention",
  INSURANCE_EXPIRING: "insurance.expiring",
  INSURANCE_ENROLLED: "insurance.enrolled",
  TRAINING_SCHEDULED: "training.session.scheduled",
  TRAINING_REMINDER: "training.session.reminder",
  CERTIFICATION_EXPIRING: "certification.expiring",
  PERFORMANCE_REVIEW_ASSIGNED: "performance.review.assigned",
  PERFORMANCE_REVIEW_DUE: "performance.review.due",
  PERFORMANCE_REVIEW_COMPLETED: "performance.review.completed",
  REQUEST_SUBMITTED: "request.submitted",
  REQUEST_STATUS_CHANGED: "request.status-changed",
  REQUEST_READY: "request.ready-for-release",
  ASSET_ASSIGNED: "asset.assigned",
  ASSET_RETURN_DUE: "asset.return-due",
  DISCIPLINARY_ACTION_ISSUED: "disciplinary.action.issued",
  AWARD_GRANTED: "award.granted",
  DOCUMENT_EXPIRING: "document.expiring",
  BIRTHDAY_TODAY: "employee.birthday",
  WORK_ANNIVERSARY: "employee.work-anniversary",
  ACCOUNT_CREATED: "account.created",
  PASSWORD_RESET_REQUESTED: "account.password-reset",
  PASSWORD_CHANGED: "account.password-changed"
};
var ALL_NOTIFICATION_TYPES = Object.values(NOTIFICATION_TYPES);
var MANDATORY_NOTIFICATION_TYPES = [
  NOTIFICATION_TYPES.PAYSLIP_AVAILABLE,
  NOTIFICATION_TYPES.ACCOUNT_CREATED,
  NOTIFICATION_TYPES.PASSWORD_RESET_REQUESTED,
  NOTIFICATION_TYPES.PASSWORD_CHANGED,
  NOTIFICATION_TYPES.DISCIPLINARY_ACTION_ISSUED
];
var QUEUES = {
  EMAIL: "email",
  PAYSLIP_PDF: "payslip-pdf",
  REPORT_EXPORT: "report-export",
  NOTIFICATION: "notification",
  SCHEDULED: "scheduled"
};
var FINANCE_NOTIFICATION_TYPES = {
  FUND_REQUEST_SUBMITTED: "finance.fund-request.submitted",
  FUND_REQUEST_AWAITING_APPROVAL: "finance.fund-request.awaiting-approval",
  FUND_REQUEST_APPROVED: "finance.fund-request.approved",
  FUND_REQUEST_REJECTED: "finance.fund-request.rejected",
  FUND_RELEASED: "finance.fund.released",
  FUND_ACKNOWLEDGED: "finance.fund.acknowledged",
  LIQUIDATION_DUE: "finance.liquidation.due",
  LIQUIDATION_SUBMITTED: "finance.liquidation.submitted",
  LIQUIDATION_REJECTED: "finance.liquidation.rejected",
  FUND_RETURN_REQUIRED: "finance.fund-return.required",
  REIMBURSEMENT_APPROVED: "finance.reimbursement.approved",
  REIMBURSEMENT_PAID: "finance.reimbursement.paid",
  OUTSTANDING_FUND_REMINDER: "finance.outstanding.reminder"
};
var registerPushDeviceSchema = z2.object({
  token: z2.string().trim().min(20, "That does not look like a device token").max(4096),
  platform: z2.enum(["android", "ios", "web"]).default("android")
});

// src/chat-mentions.ts
var WORD_CHAR = /[\p{L}\p{N}]/u;
function boundaryBefore(body, at) {
  return at === 0 || !WORD_CHAR.test(body.charAt(at - 1));
}
function boundaryAfter(body, end) {
  return end >= body.length || !WORD_CHAR.test(body.charAt(end));
}
function overlaps(spans, start, end) {
  return spans.some((span) => start < span.end && end > span.start);
}
function findMentionSpans(body, people) {
  const spans = [];
  const byLength = people.filter((person) => person.name.trim().length > 0).sort((a, b) => b.name.length - a.name.length);
  for (const person of byLength) {
    const needle = `@${person.name}`;
    let from = 0;
    while (from <= body.length - needle.length) {
      const start = body.indexOf(needle, from);
      if (start === -1) break;
      from = start + 1;
      const end = start + needle.length;
      if (!boundaryBefore(body, start) || !boundaryAfter(body, end)) continue;
      if (overlaps(spans, start, end)) continue;
      spans.push({ userId: person.userId, start, end });
    }
  }
  return spans.sort((a, b) => a.start - b.start);
}
function splitMentions(body, mentions) {
  const segments = [];
  let cursor = 0;
  const ordered = [...mentions].sort((a, b) => a.start - b.start);
  for (const mention of ordered) {
    if (mention.start < cursor || mention.end > body.length || mention.end <= mention.start) {
      continue;
    }
    if (mention.start > cursor) {
      segments.push({ text: body.slice(cursor, mention.start), userId: null });
    }
    segments.push({ text: body.slice(mention.start, mention.end), userId: mention.userId });
    cursor = mention.end;
  }
  if (cursor < body.length) segments.push({ text: body.slice(cursor), userId: null });
  return segments;
}

// src/language.ts
function ordinal(value) {
  const abs = Math.abs(Math.trunc(value));
  const suffix = abs % 100 >= 11 && abs % 100 <= 13 ? "th" : abs % 10 === 1 ? "st" : abs % 10 === 2 ? "nd" : abs % 10 === 3 ? "rd" : "th";
  return `${Math.trunc(value)}${suffix}`;
}
function countOf(value, singular, plural = `${singular}s`) {
  return `${value} ${value === 1 ? singular : plural}`;
}
function listOf(items) {
  if (items.length <= 1) return items[0] ?? "";
  if (items.length === 2) return `${items[0]} and ${items[1]}`;
  return `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`;
}

// src/settings.ts
import { z as z3 } from "zod";
var SETTING_GROUPS = {
  PAYROLL: "payroll",
  ATTENDANCE: "attendance",
  LEAVE: "leave",
  EMAIL: "email",
  SECURITY: "security",
  GENERAL: "general"
};
var SETTING_KEYS = {
  PAYROLL_SCHEDULE: "payroll.schedule",
  PAYROLL_RATES: "payroll.rates",
  PAYROLL_THIRTEENTH_MONTH: "payroll.thirteenth_month",
  ATTENDANCE_RULES: "attendance.rules",
  LEAVE_RULES: "leave.rules",
  INTEGRATIONS_UISP: "integrations.uisp",
  LEGAL_TERMS: "legal.terms",
  LOCATION_TRACKING: "location.tracking",
  DISCUSSION: "discussion.threads",
  CHAT: "chat.general",
  NOTIFICATIONS_RETENTION: "notifications.retention",
  SECURITY_POLICY: "security.policy",
  GENERAL_LOCALE: "general.locale",
  MAIL_SMTP: "mail.smtp"
};
var MAIL_PASSWORD_KEY = "mail.smtp_password";
var payrollScheduleSchema = z3.object({
  frequency: z3.enum(["WEEKLY", "SEMI_MONTHLY", "MONTHLY"]).default("WEEKLY"),
  cutoffStartWeekday: z3.number().int().min(1).max(7).default(7),
  cutoffEndWeekday: z3.number().int().min(1).max(7).default(6),
  payoutWeekday: z3.number().int().min(1).max(7).default(6),
  payoutOffsetDays: z3.number().int().min(0).max(14).default(0),
  /** Auto-create the next period when the current one closes. */
  autoGeneratePeriods: z3.boolean().default(true)
});
var payrollRatesSchema = z3.object({
  /** Divisor used to derive the daily rate from the monthly salary. */
  workingDaysPerMonth: z3.number().positive().max(31).default(26),
  workingHoursPerDay: z3.number().positive().max(24).default(8),
  /**
   * Whether minutes past the scheduled end are paid at all.
   *
   * KioBytes pays a fixed daily rate and does not pay overtime. The engine
   * arrived with overtime switched on — it was never asked for — and had paid
   * ₱35,293.94 across weeks 33 to 41 before anybody looked, in amounts as
   * small as the two minutes a flexible-schedule day runs over.
   *
   * A flag rather than a multiplier of zero: the multiplier's floor is 1, and
   * 1 still pays every overtime minute at plain time, on top of a daily rate
   * that has already been paid in full. There was no way to say "not at all".
   *
   * Defaults to true, so deploying this moves nobody's pay on its own —
   * switching it off is a settings change, which is audited and names who did
   * it. Off does NOT stop rest-day, holiday or night-differential premiums:
   * those are paid from their own minutes under their own multipliers. It also
   * does not stop the minutes being RECORDED, so the register still shows who
   * stayed late. It just stops them being money.
   */
  payOvertime: z3.boolean().default(true),
  overtimeMultiplier: z3.number().min(1).default(1.25),
  restDayMultiplier: z3.number().min(1).default(1.3),
  /**
   * Premium for working a REGULAR holiday. 2.0 is what the engine has always
   * applied, to every holiday type — see the special rate below.
   */
  regularHolidayMultiplier: z3.number().min(1).default(2),
  /**
   * Premium for working a SPECIAL non-working holiday.
   *
   * 1.30, set by KioBytes on 2026-08-23. It had defaulted to the regular
   * holiday rate of 2.00, which overpaid every special holiday worked — around
   * ₱441 per employee on Ninoy Aquino Day alone.
   *
   * Changing this changes pay. It is a rate from the DOLE circular, not a
   * preference: check it against the circular before editing, and change it
   * because the circular changed.
   */
  specialHolidayMultiplier: z3.number().min(1).default(1.3),
  nightDifferentialRate: z3.number().min(0).max(1).default(0.1),
  nightDifferentialStart: z3.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/).default("22:00"),
  nightDifferentialEnd: z3.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/).default("06:00"),
  /** Monthly compensation at or below which an employee is tax-exempt. */
  minimumWageMonthly: z3.number().min(0).default(0)
});
var attendanceRulesSchema = z3.object({
  /**
   * Whether HR may load attendance from a file.
   *
   * Off by default. An import writes days nobody observed, straight into the
   * record payroll is computed from, so it stays shut until somebody decides
   * to open it — and can be shut again the moment the backlog is loaded,
   * rather than remaining permanently available because it was needed once.
   */
  attendanceImportEnabled: z3.boolean().default(false),
  gracePeriodMinutes: z3.number().int().min(0).max(120).default(15),
  /** Minutes absent past which a day is counted as a half day. */
  halfDayThresholdMinutes: z3.number().int().min(0).default(240),
  allowWebPunch: z3.boolean().default(true),
  /** Reject web punches from outside these CIDR ranges; empty = no restriction. */
  allowedPunchCidrs: z3.array(z3.string()).default([]),
  /**
   * Refuse a web punch that arrives without a photo.
   *
   * Defaulted on: the capture exists to be relied on, and a control that is
   * optional by default is one nobody notices is off.
   */
  requirePhotoOnPunch: z3.boolean().default(true),
  /**
   * Refuse a punch that arrives without coordinates.
   *
   * Defaulted on, alongside the photo. A photo proves who; the coordinates
   * prove where, and a punch with a picture and no position is exactly the one
   * somebody makes from home.
   *
   * The device decides whether to give a fix, so this is enforced by refusing
   * the punch rather than by forcing anything on the phone — turning location
   * off means being unable to clock in, not being tracked anyway.
   */
  requireLocationOnPunch: z3.boolean().default(true),
  /**
   * Days a punch photo is kept before the purge removes it.
   *
   * Photographs of staff are personal information, and keeping them beyond the
   * period they are useful for is the part of this feature most likely to be
   * questioned. Ninety days covers a payroll dispute and a full cut-off cycle
   * with room to spare.
   */
  photoRetentionDays: z3.number().int().min(1).max(3650).default(90),
  autoMarkAbsentAfterHours: z3.number().int().min(0).max(48).default(12),
  /**
   * Date from which rest-day work must carry an authorisation.
   *
   * Rest-day premium is created by the punch alone, so without this the company
   * pays a premium for work nobody instructed. Payroll refuses to finalise a
   * run containing rest-day punches on or after this date that are neither
   * authorised nor declined.
   *
   * Dated rather than a boolean because switching it on retroactively would
   * drag every historical Sunday punch into the gate and stop the next run
   * dead. Null disables the check, which stays visible on the payroll page
   * reporting that it is not enforced — a control nobody can see is off is
   * worse than one that is on.
   */
  restDayAuthorisationFrom: z3.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable().default(null)
});
var leaveRulesSchema = z3.object({
  requireManagerApproval: z3.boolean().default(true),
  requireHrApproval: z3.boolean().default(true),
  allowNegativeBalance: z3.boolean().default(false),
  /** Reset/carry-over runs on this month/day each year. */
  accrualResetMonth: z3.number().int().min(1).max(12).default(1),
  accrualResetDay: z3.number().int().min(1).max(31).default(1)
});
var uispIntegrationSchema = z3.object({
  /** Empty until somebody sets it; the page then says so rather than 404ing. */
  url: z3.string().trim().url().or(z3.literal("")).default("")
});
var legalTermsSchema = z3.object({
  /**
   * Refuse acceptance from a desktop browser.
   *
   * So the person agreeing to being located is holding the device that will do
   * the locating, rather than reading it at a desk. Off by default: it locks
   * out anybody without a phone, which is a decision a company has to make
   * rather than inherit.
   */
  acceptOnMobileOnly: z3.boolean().default(false),
  /** Off until somebody writes the terms. An empty gate helps nobody. */
  requireAcceptance: z3.boolean().default(false),
  /**
   * Free-form and compared exactly. A date, a semver, anything — it only has to
   * change when the text does.
   */
  version: z3.string().trim().min(1).max(40).default("1"),
  /** The agreement itself, shown verbatim. Empty until the company writes it. */
  body: z3.string().max(6e4).default(""),
  /** Shown above the text, for a one-line summary of what changed. */
  summary: z3.string().max(500).default("")
});
var locationTrackingSchema = z3.object({
  enabled: z3.boolean().default(false),
  /**
   * Minutes between positions.
   *
   * Five is the floor, not a suggestion: the browser can only report while the
   * app is open and on screen, so a tighter interval spends battery to sample a
   * window that is mostly closed anyway.
   */
  pingIntervalMinutes: z3.number().int().min(5).max(120).default(15),
  /**
   * Collect only between clock-in and clock-out.
   *
   * On by default. A position recorded at 9pm on a Sunday answers no question
   * the company has, and is the hardest kind to justify keeping.
   */
  onlyWhileClockedIn: z3.boolean().default(true),
  /** Days a position is kept. Matches the punch photo window by default. */
  retentionDays: z3.number().int().min(1).max(365).default(90)
});
var discussionSchema = z3.object({
  enabled: z3.boolean().default(true),
  onFundRequests: z3.boolean().default(true),
  onExpenseClaims: z3.boolean().default(true),
  onLeaveRequests: z3.boolean().default(true),
  /**
   * Off by default, and the only one that is.
   *
   * A resignation is the most sensitive record here and the one whose
   * conversation a departing employee is least able to argue about afterwards.
   * Somebody should have to decide to switch this on.
   */
  onResignations: z3.boolean().default(false)
});
var chatSchema = z3.object({
  enabled: z3.boolean().default(false),
  retentionDays: z3.number().int().min(30).max(3650).default(365)
});
var notificationRetentionSchema = z3.object({
  /** Days a notice that has been read is kept, counted from its creation. */
  readDays: z3.number().int().min(7).max(3650).default(90),
  /** Days a notice nobody has read is kept, counted from its creation. */
  unreadDays: z3.number().int().min(30).max(3650).default(365)
});
var securityPolicySchema = z3.object({
  passwordMinLength: z3.number().int().min(8).max(128).default(12),
  passwordRequireUppercase: z3.boolean().default(true),
  passwordRequireNumber: z3.boolean().default(true),
  passwordRequireSymbol: z3.boolean().default(true),
  /** Consecutive failures before the account is locked. */
  maxFailedLoginAttempts: z3.number().int().min(3).max(20).default(5),
  lockoutMinutes: z3.number().int().min(1).max(1440).default(15),
  sessionIdleMinutes: z3.number().int().min(5).max(1440).default(60),
  /** 0 disables forced rotation. */
  passwordExpiryDays: z3.number().int().min(0).max(365).default(0)
});
function describePasswordRules(rules) {
  const extras = [];
  if (rules.passwordRequireUppercase) extras.push("an uppercase letter");
  if (rules.passwordRequireNumber) extras.push("a number");
  if (rules.passwordRequireSymbol) extras.push("a symbol");
  const length = `At least ${rules.passwordMinLength} characters`;
  if (extras.length === 0) return `${length}.`;
  const listed = extras.length === 1 ? extras.join("") : `${extras.slice(0, -1).join(", ")} and ${extras.slice(-1).join("")}`;
  return `${length}, with ${listed}.`;
}
var generalLocaleSchema = z3.object({
  timezone: z3.string().default("Asia/Manila"),
  currency: z3.string().length(3).default("PHP"),
  dateFormat: z3.string().default("MMM d, yyyy"),
  locale: z3.string().default("en-PH")
});
var mailSmtpSchema = z3.object({
  host: z3.string().trim().max(200).default(""),
  port: z3.number().int().min(1).max(65535).default(587),
  /** True for implicit TLS on 465; false for STARTTLS on 587. */
  secure: z3.boolean().default(false),
  user: z3.string().trim().max(200).default(""),
  /** What recipients see in the From line. */
  fromAddress: z3.string().trim().max(200).default("KioBytes HR <no-reply@kiobytes.com>")
});
var SETTING_SCHEMAS = {
  [SETTING_KEYS.PAYROLL_SCHEDULE]: payrollScheduleSchema,
  [SETTING_KEYS.PAYROLL_RATES]: payrollRatesSchema,
  [SETTING_KEYS.ATTENDANCE_RULES]: attendanceRulesSchema,
  [SETTING_KEYS.LEAVE_RULES]: leaveRulesSchema,
  [SETTING_KEYS.INTEGRATIONS_UISP]: uispIntegrationSchema,
  [SETTING_KEYS.LEGAL_TERMS]: legalTermsSchema,
  [SETTING_KEYS.LOCATION_TRACKING]: locationTrackingSchema,
  [SETTING_KEYS.DISCUSSION]: discussionSchema,
  [SETTING_KEYS.CHAT]: chatSchema,
  [SETTING_KEYS.NOTIFICATIONS_RETENTION]: notificationRetentionSchema,
  [SETTING_KEYS.SECURITY_POLICY]: securityPolicySchema,
  [SETTING_KEYS.GENERAL_LOCALE]: generalLocaleSchema,
  [SETTING_KEYS.MAIL_SMTP]: mailSmtpSchema
};

// src/setting-catalogue.ts
var SETTING_SECTIONS = [
  {
    key: SETTING_KEYS.PAYROLL_RATES,
    title: "Payroll rates",
    description: "The arithmetic every payslip is built from.",
    fields: [
      {
        name: "workingDaysPerMonth",
        label: "Working days per month",
        kind: "number",
        min: 1,
        max: 31,
        consequential: true,
        hint: "Divisor that turns a monthly salary into a daily rate. Raising it lowers everyone\u2019s daily rate."
      },
      {
        name: "workingHoursPerDay",
        label: "Working hours per day",
        kind: "number",
        min: 1,
        max: 24,
        consequential: true,
        hint: "Divides the daily rate into an hourly rate, which overtime is priced from."
      },
      {
        name: "payOvertime",
        label: "Pay overtime",
        kind: "boolean",
        consequential: true,
        hint: "Off pays the fixed daily rate only \u2014 minutes past the scheduled end are still recorded, but never priced. Rest day, holiday and night differential are unaffected."
      },
      {
        name: "overtimeMultiplier",
        label: "Overtime multiplier",
        kind: "decimal",
        min: 1,
        step: 0.05,
        hint: "1.25 is the statutory minimum for ordinary overtime."
      },
      {
        name: "restDayMultiplier",
        label: "Rest day multiplier",
        kind: "decimal",
        min: 1,
        step: 0.05,
        hint: "1.30 is the statutory minimum for work on a rest day."
      },
      {
        name: "regularHolidayMultiplier",
        label: "Regular holiday multiplier",
        kind: "decimal",
        min: 1,
        step: 0.05,
        consequential: true,
        hint: "Premium for working a regular holiday, e.g. Independence Day."
      },
      {
        name: "specialHolidayMultiplier",
        label: "Special non-working holiday multiplier",
        kind: "decimal",
        min: 1,
        step: 0.05,
        consequential: true,
        hint: "A different rate from a regular holiday under the Labor Code. Set to 1.30. Change it only because the circular changed \u2014 this is what people are paid for working a special non-working holiday."
      },
      {
        name: "nightDifferentialRate",
        label: "Night differential rate",
        kind: "decimal",
        min: 0,
        max: 1,
        step: 0.01,
        hint: "0.10 is the statutory 10% premium. Entered as a fraction, not a percentage."
      },
      {
        name: "nightDifferentialStart",
        label: "Night differential starts",
        kind: "time",
        hint: "Statutory window is 22:00 to 06:00."
      },
      { name: "nightDifferentialEnd", label: "Night differential ends", kind: "time" },
      {
        name: "minimumWageMonthly",
        label: "Minimum wage (monthly)",
        kind: "decimal",
        min: 0,
        consequential: true,
        hint: "Employees at or below this are exempt from withholding tax. 0 disables the exemption."
      }
    ]
  },
  {
    key: SETTING_KEYS.PAYROLL_SCHEDULE,
    title: "Payroll schedule",
    description: "When the cut-off opens and closes, and when people are paid.",
    fields: [
      {
        name: "cutoffStartWeekday",
        label: "Cut-off starts",
        kind: "weekday",
        consequential: true,
        hint: "Moving this shifts which days land in which period."
      },
      { name: "cutoffEndWeekday", label: "Cut-off ends", kind: "weekday", consequential: true },
      { name: "payoutWeekday", label: "Pay day", kind: "weekday" },
      {
        name: "payoutOffsetDays",
        label: "Days after cut-off",
        kind: "number",
        min: 0,
        max: 14,
        hint: "0 pays on the same day the cut-off closes."
      },
      {
        name: "autoGeneratePeriods",
        label: "Create the next period automatically",
        kind: "boolean"
      }
    ]
  },
  {
    key: SETTING_KEYS.INTEGRATIONS_UISP,
    title: "UISP",
    description: "A link out to UISP for the people who work in it. UISP signs them in itself \u2014 nothing here holds a password for it.",
    fields: [
      {
        name: "url",
        label: "UISP address",
        kind: "text",
        hint: 'For example https://uisp.kiobytes.com/crm. Leave empty to hide the link. Who sees it is decided by the "Open UISP from the sidebar" permission, not by this field.'
      }
    ]
  },
  {
    key: SETTING_KEYS.LEGAL_TERMS,
    title: "Terms of use",
    description: "What everyone must agree to before the app will do anything. The words are yours to write \u2014 nothing here supplies them.",
    fields: [
      {
        name: "requireAcceptance",
        label: "Require acceptance before use",
        kind: "boolean",
        consequential: true,
        hint: "Blocks every screen and every endpoint until the signed-in person has accepted the current version. Leave off until the text below is written and reviewed."
      },
      {
        name: "acceptOnMobileOnly",
        label: "Only allow accepting on a phone",
        kind: "boolean",
        consequential: true,
        hint: "Refuses acceptance from a desktop browser, so the person agreeing to being located is holding the device that will do it. Judged from the browser2019s user-agent, which is a hint rather than proof 2014 and it locks out anybody who has no phone, since they then have no way to accept and no way to work."
      },
      {
        name: "version",
        label: "Version",
        kind: "text",
        consequential: true,
        hint: "Acceptance is recorded against this. Changing the text WITHOUT changing this leaves everyone marked as having agreed to words they never saw \u2014 change both, together."
      },
      {
        name: "summary",
        label: "What changed",
        kind: "text",
        hint: "One line shown above the terms. Useful when re-asking people who already agreed to an earlier version."
      },
      {
        name: "body",
        label: "The agreement",
        kind: "multiline",
        hint: "Shown verbatim, exactly as typed. Have it reviewed by whoever is accountable for it before switching acceptance on."
      }
    ]
  },
  {
    key: SETTING_KEYS.DISCUSSION,
    title: "Discussion on records",
    description: "The conversation attached to a fund request, claim, leave request or resignation \u2014 so the reasoning behind a decision survives next to the verdict instead of in a chat app.",
    fields: [
      {
        name: "enabled",
        label: "Allow discussion on records",
        kind: "boolean",
        consequential: true,
        hint: "Off hides every discussion panel and refuses new messages. It does not delete what was already said \u2014 erasing a conversation an approval rests on is not a settings change."
      },
      {
        name: "onFundRequests",
        label: "On fund requests",
        kind: "boolean",
        hint: "Where an approver asks why an amount is what it is, before deciding."
      },
      {
        name: "onExpenseClaims",
        label: "On expense claims",
        kind: "boolean",
        hint: "Visible to the claimant, whoever the claim is awaiting, whoever pays it, and anybody who already decided on it."
      },
      {
        name: "onLeaveRequests",
        label: "On leave requests",
        kind: "boolean",
        hint: "Visible to exactly whoever can already see the leave request itself."
      },
      {
        name: "onResignations",
        label: "On resignations",
        kind: "boolean",
        consequential: true,
        hint: "Off by default, and the only one that is. A resignation is the most sensitive record here, and the one whose conversation a departing employee is least able to argue about afterwards."
      }
    ]
  },
  {
    key: SETTING_KEYS.CHAT,
    title: "Chat",
    description: "Direct messages and named groups between staff, inside this system. A conversation is readable by its members and nobody else \u2014 not HR, not an administrator \u2014 and membership follows the roster: a login that is deactivated is out of every conversation the same minute.",
    fields: [
      {
        name: "enabled",
        label: "Allow chat",
        kind: "boolean",
        consequential: true,
        hint: 'Off by default. On puts a Chat page in front of every signed-in person within a minute. Off hides it again and refuses new messages; nothing is deleted. Who may start conversations and shape groups is the "chat:manage" permission; the names people are shown under are set from the chat page (Names).'
      },
      {
        name: "retentionDays",
        label: "Keep messages for (days)",
        kind: "number",
        min: 30,
        max: 3650,
        hint: "Messages older than this are deleted by the nightly purge (infra/purge-chat-messages.sh) once that job is scheduled on the server. Unlike discussion on a record, a chat message is not part of why a decision was made."
      }
    ]
  },
  {
    key: SETTING_KEYS.NOTIFICATIONS_RETENTION,
    title: "Notifications",
    description: "How long the bell keeps its notices. Each notice points at a record with rules of its own; deleting the notice removes the pointer and the sentence on it, not the leave request, payslip or message it named.",
    fields: [
      {
        name: "readDays",
        label: "Keep read notices for (days)",
        kind: "number",
        min: 7,
        max: 3650,
        consequential: true,
        hint: "Counted from when the notice was created, not from when it was read. Deleted by the nightly purge (infra/purge-notifications.sh) once that job is scheduled on the server."
      },
      {
        name: "unreadDays",
        label: "Keep unread notices for (days)",
        kind: "number",
        min: 30,
        max: 3650,
        consequential: true,
        hint: "Longer than the read window, because an unread notice is still waiting to be seen. Payslip, account-security and disciplinary notices are never deleted while unread, whatever this says \u2014 the same events nobody may switch off."
      }
    ]
  },
  {
    key: SETTING_KEYS.LOCATION_TRACKING,
    title: "Location",
    description: "Whereabouts reporting from staff phones. Separate from attendance: a punch is a claim about a working day, a position is not.",
    fields: [
      {
        name: "enabled",
        label: "Collect staff locations",
        kind: "boolean",
        consequential: true,
        hint: "Off until somebody turns it on. In the Android app positions keep arriving with the screen off; in a browser they stop the moment the page is hidden. Either way expect a trail with gaps, and read a gap as a pocketed phone, lost signal or a flat battery rather than as an answer."
      },
      {
        name: "onlyWhileClockedIn",
        label: "Only between clock-in and clock-out",
        kind: "boolean",
        consequential: true,
        hint: "On by default. A position recorded on a Sunday evening answers no question the company has, and is the hardest kind to justify keeping."
      },
      {
        name: "pingIntervalMinutes",
        label: "Minutes between positions",
        kind: "number",
        min: 5,
        max: 120,
        hint: "Five is the floor. A tighter interval spends battery sampling a window that is closed most of the day anyway."
      },
      {
        name: "retentionDays",
        label: "Keep positions for (days)",
        kind: "number",
        min: 1,
        max: 365,
        consequential: true,
        hint: "Deleted by the same daily sweep that clears punch photos. Set this before collecting, not after a year of positions somebody has started relying on."
      }
    ]
  },
  {
    key: SETTING_KEYS.ATTENDANCE_RULES,
    title: "Attendance",
    description: "How time in and out is judged.",
    fields: [
      {
        name: "attendanceImportEnabled",
        label: "Allow attendance import",
        kind: "boolean",
        consequential: true,
        hint: "Lets HR load attendance from a file. Off by default: an import writes days nobody observed into the record payroll is computed from. Turn it on for the backlog, then turn it off again."
      },
      {
        name: "gracePeriodMinutes",
        label: "Grace period (minutes)",
        kind: "number",
        min: 0,
        max: 120,
        consequential: true,
        hint: "Arriving within this is not late at all. Past it, the whole lateness counts \u2014 not just the excess."
      },
      {
        name: "halfDayThresholdMinutes",
        label: "Half-day threshold (minutes)",
        kind: "number",
        min: 0,
        hint: "Missing more than this much of a day makes it a half day."
      },
      {
        name: "autoMarkAbsentAfterHours",
        label: "Auto-mark absent after (hours)",
        kind: "number",
        min: 0,
        max: 48
      },
      { name: "allowWebPunch", label: "Allow punching in from the browser", kind: "boolean" },
      {
        name: "requirePhotoOnPunch",
        label: "Require a photo when punching",
        kind: "boolean",
        consequential: true,
        hint: "Turning this off lets anyone punch without a photo, and nothing on the record will show which punches were taken unverified."
      },
      {
        name: "requireLocationOnPunch",
        label: "Require location when punching",
        kind: "boolean",
        consequential: true,
        hint: "A punch with no coordinates is refused, so somebody with location switched off cannot clock in until they turn it on. The photo proves who was there; this proves where. Turning it off allows a punch from anywhere with nothing on the record to show it."
      },
      {
        name: "photoRetentionDays",
        label: "Keep punch photos for (days)",
        kind: "number",
        min: 1,
        max: 3650,
        consequential: true,
        hint: "Photos older than this are deleted permanently when the purge runs. Shorter is safer \u2014 these are photographs of staff, and keeping them longer than they are useful is the hardest part of this to justify."
      },
      {
        name: "restDayAuthorisationFrom",
        label: "Rest day work needs authorisation from",
        kind: "date",
        nullable: true,
        consequential: true,
        hint: "Payroll will not finalise a run containing rest-day punches on or after this date that are neither authorised nor declined. Leave empty to record authorisations without blocking payroll."
      }
    ]
  },
  {
    key: SETTING_KEYS.LEAVE_RULES,
    title: "Leave",
    description: "Who approves leave and when balances reset.",
    fields: [
      { name: "requireManagerApproval", label: "Manager must approve", kind: "boolean" },
      { name: "requireHrApproval", label: "HR must approve", kind: "boolean" },
      {
        name: "allowNegativeBalance",
        label: "Allow leave beyond the balance",
        kind: "boolean",
        consequential: true,
        hint: "Lets an employee go into a negative balance, which payroll will deduct against."
      },
      { name: "accrualResetMonth", label: "Balances reset in month", kind: "number", min: 1, max: 12 },
      { name: "accrualResetDay", label: "on day", kind: "number", min: 1, max: 31 }
    ]
  },
  {
    key: SETTING_KEYS.SECURITY_POLICY,
    title: "Security",
    description: "Password rules and lockout. Applies at the next login, not retroactively.",
    fields: [
      { name: "passwordMinLength", label: "Minimum password length", kind: "number", min: 8, max: 128 },
      { name: "passwordRequireUppercase", label: "Require an uppercase letter", kind: "boolean" },
      { name: "passwordRequireNumber", label: "Require a number", kind: "boolean" },
      { name: "passwordRequireSymbol", label: "Require a symbol", kind: "boolean" },
      {
        name: "maxFailedLoginAttempts",
        label: "Failed attempts before lockout",
        kind: "number",
        min: 3,
        max: 20
      },
      { name: "lockoutMinutes", label: "Lockout duration (minutes)", kind: "number", min: 1, max: 1440 },
      {
        name: "sessionIdleMinutes",
        label: "Idle session timeout (minutes)",
        kind: "number",
        min: 5,
        max: 1440
      },
      {
        name: "passwordExpiryDays",
        label: "Force a password change every (days)",
        kind: "number",
        min: 0,
        max: 365,
        hint: "0 disables forced rotation."
      }
    ]
  },
  {
    key: SETTING_KEYS.GENERAL_LOCALE,
    title: "Locale",
    description: "Timezone and currency. Changing the timezone re-interprets stored punch times.",
    fields: [
      { name: "timezone", label: "Timezone", kind: "text", consequential: true },
      { name: "currency", label: "Currency code", kind: "text" },
      { name: "dateFormat", label: "Date format", kind: "text" },
      { name: "locale", label: "Locale", kind: "text" }
    ]
  },
  {
    key: SETTING_KEYS.MAIL_SMTP,
    title: "Email",
    description: "The mail server that sends password resets and payslip notices. Leave the host blank to keep email switched off.",
    fields: [
      {
        name: "host",
        label: "SMTP host",
        kind: "text",
        consequential: true,
        hint: "e.g. smtp.gmail.com. Blank means email stays off: nothing is sent, and password resets are recorded but never delivered."
      },
      {
        name: "port",
        label: "Port",
        kind: "number",
        min: 1,
        max: 65535,
        hint: "587 for STARTTLS, 465 for implicit TLS."
      },
      {
        name: "secure",
        label: "Implicit TLS (port 465)",
        kind: "boolean",
        hint: "On for port 465, off for 587. Pairing the wrong one with the port is the usual cause of a send that hangs."
      },
      {
        name: "user",
        label: "Username",
        kind: "text",
        hint: "Usually the full sending address."
      },
      {
        name: "fromAddress",
        label: "From address",
        kind: "text",
        hint: "What recipients see, e.g. KioBytes HR <no-reply@kiobytes.com>."
      }
    ]
  }
];
var WEEKDAY_OPTIONS = [
  { value: 1, label: "Monday" },
  { value: 2, label: "Tuesday" },
  { value: 3, label: "Wednesday" },
  { value: 4, label: "Thursday" },
  { value: 5, label: "Friday" },
  { value: 6, label: "Saturday" },
  { value: 7, label: "Sunday" }
];

// src/dto/holiday.ts
import { z as z5 } from "zod";

// src/dto/common.ts
import { z as z4 } from "zod";
var uuidSchema = z4.string().uuid("Must be a valid identifier");
var optionalUuid = uuidSchema.nullish().transform((value) => value ?? null);
function requiredString(max, label = "This field") {
  return z4.string().trim().min(1, `${label} is required`).max(max, `${label} must be ${max} characters or fewer`);
}
function optionalString(max) {
  return z4.string().trim().max(max).nullish().transform((value) => value ? value : null);
}
function upperRequired(max, label = "This field") {
  return requiredString(max, label).transform((value) => value.toUpperCase());
}
function upperOptional(max) {
  return optionalString(max).transform((value) => value ? value.toUpperCase() : null);
}
var emailSchema = z4.string().trim().toLowerCase().email("Enter a valid email address").max(255);
var optionalEmail = emailSchema.nullish().transform((value) => value ?? null);
var mobileNumberSchema = z4.string().trim().transform((value) => value.replace(/[\s()-]/g, "")).refine((value) => /^(09\d{9}|\+?639\d{9})$/.test(value), {
  message: "Enter a valid mobile number, e.g. 09171234567"
}).transform((value) => value.startsWith("0") ? value : `0${value.replace(/^\+?63/, "")}`);
var optionalPhone = z4.string().trim().max(32).nullish().transform((value) => value ? value : null);
function moneySchema(label = "Amount") {
  return z4.number({ invalid_type_error: `${label} must be a number` }).nonnegative(`${label} cannot be negative`).max(99999999999e-2).refine(
    (value) => Number.isFinite(value) && Math.abs(value * 100 - Math.round(value * 100)) < 1e-6,
    { message: `${label} can have at most two decimal places` }
  );
}
var dateOnlySchema = z4.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Use the format YYYY-MM-DD").refine((value) => !Number.isNaN(Date.parse(`${value}T00:00:00Z`)), "Not a real date");
var optionalDateOnly = dateOnlySchema.nullish().transform((value) => value ?? null);
var govIdSchema = z4.string().trim().max(32).nullish().transform((value) => value ? value : null);
var uuidListQuery = z4.union([z4.string(), z4.array(z4.string())]).optional().transform((value) => {
  if (!value) return void 0;
  const items = Array.isArray(value) ? value : value.split(",");
  return items.map((item) => item.trim()).filter(Boolean);
});
var booleanQuery = z4.union([z4.boolean(), z4.enum(["true", "false"])]).optional().transform((value) => typeof value === "string" ? value === "true" : value);

// src/dto/holiday.ts
var typeValues = Object.values(HolidayType);
var HOLIDAY_DEFAULT_MULTIPLIERS = {
  REGULAR: {
    worked: 2,
    unworked: 1,
    note: "Paid double when worked, and paid in full when not worked."
  },
  SPECIAL_NON_WORKING: {
    worked: 1.3,
    unworked: 0,
    note: "No work, no pay unless a company policy says otherwise."
  },
  SPECIAL_WORKING: {
    worked: 1,
    unworked: 0,
    note: "Treated as an ordinary working day \u2014 no premium."
  },
  COMPANY: {
    worked: 1,
    unworked: 1,
    note: "A company-declared day off. Set the multipliers to match your policy."
  }
};
var createHolidaySchema = z5.object({
  name: upperRequired(120, "Name"),
  date: dateOnlySchema,
  type: z5.enum(typeValues),
  description: optionalString(500),
  payMultiplier: z5.number().min(0).max(5),
  unworkedPayMultiplier: z5.number().min(0).max(5),
  /** Recurs on the same month and day every year, e.g. Christmas. */
  isRecurring: z5.boolean().default(false),
  isActive: z5.boolean().default(true)
});
var updateHolidaySchema = createHolidaySchema.partial();
var holidayQuerySchema = z5.object({
  /** Calendar year to list. Defaults to the current one. */
  year: z5.coerce.number().int().min(1970).max(2200).optional(),
  type: z5.string().optional(),
  search: z5.string().optional()
});
var HOLIDAY_TYPE_LABELS = {
  REGULAR: "Regular holiday",
  SPECIAL_NON_WORKING: "Special non-working",
  SPECIAL_WORKING: "Special working",
  COMPANY: "Company holiday"
};

// src/ph-holidays.ts
var PH_FIXED_HOLIDAYS = [
  { name: "NEW YEAR'S DAY", monthDay: "01-01", type: "REGULAR" },
  { name: "ARAW NG KAGITINGAN", monthDay: "04-09", type: "REGULAR" },
  { name: "LABOR DAY", monthDay: "05-01", type: "REGULAR" },
  { name: "INDEPENDENCE DAY", monthDay: "06-12", type: "REGULAR" },
  { name: "BONIFACIO DAY", monthDay: "11-30", type: "REGULAR" },
  { name: "CHRISTMAS DAY", monthDay: "12-25", type: "REGULAR" },
  { name: "RIZAL DAY", monthDay: "12-30", type: "REGULAR" },
  { name: "NINOY AQUINO DAY", monthDay: "08-21", type: "SPECIAL_NON_WORKING" },
  { name: "ALL SAINTS' DAY", monthDay: "11-01", type: "SPECIAL_NON_WORKING" },
  {
    name: "FEAST OF THE IMMACULATE CONCEPTION",
    monthDay: "12-08",
    type: "SPECIAL_NON_WORKING"
  },
  { name: "LAST DAY OF THE YEAR", monthDay: "12-31", type: "SPECIAL_NON_WORKING" }
];
var PH_MOVABLE_HOLIDAYS = [
  { name: "Maundy Thursday", reason: "Tied to Easter \u2014 changes every year." },
  { name: "Good Friday", reason: "Tied to Easter \u2014 changes every year." },
  { name: "Black Saturday", reason: "Special day, tied to Easter." },
  {
    name: "National Heroes Day",
    reason: "The last Monday of August, so the date moves."
  },
  { name: "Eid'l Fitr", reason: "Declared on Islamic lunar observation." },
  { name: "Eid'l Adha", reason: "Declared on Islamic lunar observation." }
];
function suggestedHolidaysFor(year) {
  return PH_FIXED_HOLIDAYS.map((holiday) => {
    const defaults = HOLIDAY_DEFAULT_MULTIPLIERS[holiday.type];
    return {
      name: holiday.name,
      date: `${year}-${holiday.monthDay}`,
      type: holiday.type,
      payMultiplier: defaults.worked,
      unworkedPayMultiplier: defaults.unworked,
      // Fixed-date by law, so recurring is right — a proclamation moving one in
      // a particular year is entered as its own row for that year, which the
      // projection logic already prefers over the recurring entry.
      isRecurring: true,
      isActive: true
    };
  });
}

// src/statutory-schedules.ts
var TRAIN_ANNUAL_BRACKETS = [
  { over: 0, notOver: 25e4, baseTax: 0, rateOnExcess: 0 },
  { over: 25e4, notOver: 4e5, baseTax: 0, rateOnExcess: 0.15 },
  { over: 4e5, notOver: 8e5, baseTax: 22500, rateOnExcess: 0.2 },
  { over: 8e5, notOver: 2e6, baseTax: 102500, rateOnExcess: 0.25 },
  { over: 2e6, notOver: 8e6, baseTax: 402500, rateOnExcess: 0.3 },
  { over: 8e6, notOver: null, baseTax: 2202500, rateOnExcess: 0.35 }
];
var PAYROLL_PERIODS_PER_YEAR = {
  DAILY: 313,
  WEEKLY: 52,
  SEMI_MONTHLY: 24,
  MONTHLY: 12
};
function money(value) {
  return Math.round(value * 100) / 100;
}
function withholdingBracketsFor(frequency) {
  const periods = PAYROLL_PERIODS_PER_YEAR[frequency];
  return TRAIN_ANNUAL_BRACKETS.map((bracket, index) => {
    const min = index === 0 ? 0 : money(bracket.over / periods) + 0.01;
    const max = bracket.notOver == null ? null : money(bracket.notOver / periods);
    return {
      minCompensation: index === 0 ? 0 : money(min),
      maxCompensation: max,
      baseTax: money(bracket.baseTax / periods),
      excessRate: bracket.rateOnExcess,
      employeeAmount: null,
      employerAmount: null,
      employeeRate: null,
      employerRate: null
    };
  });
}
var SSS_DEFAULT_PARAMETERS = {
  mscFloor: 5e3,
  mscCeiling: 35e3,
  mscStep: 500,
  employeeRate: 0.05,
  employerRate: 0.1,
  ecLower: 10,
  ecUpper: 30,
  ecThreshold: 15e3
};
function sssBracketsFor(parameters) {
  const { mscFloor, mscCeiling, mscStep, employeeRate, employerRate } = parameters;
  const brackets = [];
  const half = mscStep / 2;
  for (let msc = mscFloor; msc <= mscCeiling; msc += mscStep) {
    const isFirst = msc === mscFloor;
    const isLast = msc + mscStep > mscCeiling;
    const min = isFirst ? 0 : msc - half;
    const max = isLast ? null : msc + half - 0.01;
    const ec = msc >= parameters.ecThreshold ? parameters.ecUpper : parameters.ecLower;
    brackets.push({
      minCompensation: money(min),
      maxCompensation: max == null ? null : money(max),
      employeeAmount: money(msc * employeeRate),
      // EC is employer-only and remitted alongside, so it belongs in the
      // employer figure rather than being tracked separately.
      employerAmount: money(msc * employerRate + ec),
      employeeRate: null,
      employerRate: null,
      baseTax: null,
      excessRate: null
    });
  }
  return brackets;
}
var WITHHOLDING_PROVENANCE = {
  title: "BIR withholding tax",
  basis: "Derived from the annual graduated rates in RA 10963 (TRAIN), \xA724(A)(2)(a), second tranche \u2014 in force since 1 January 2023. The weekly table is those brackets divided by 52, which is how BIR publishes it.",
  confidence: "derived-from-statute",
  verify: "Check the six annual brackets against the current Tax Code before your first remittance. If Congress has amended them, these figures are stale."
};
var SSS_PROVENANCE = {
  title: "SSS contributions",
  basis: "Generated from the rate and MSC range you supply. Defaults are the 2025 schedule \u2014 15% total, 5% employee and 10% employer, MSC \u20B15,000 to \u20B135,000.",
  confidence: "generated-from-parameters",
  verify: "SSS changes these by circular. Confirm the rate, the MSC ceiling and the EC amounts against the circular in force before saving."
};

// src/permission-catalogue.ts
var PERMISSION_CATALOGUE = [
  {
    group: "Overview",
    permissions: [
      { permission: PERMISSIONS.DASHBOARD_VIEW, label: "View the dashboard" },
      { permission: PERMISSIONS.ANALYTICS_VIEW, label: "View analytics and charts" },
      { permission: PERMISSIONS.REPORT_VIEW, label: "View reports" },
      { permission: PERMISSIONS.REPORT_EXPORT, label: "Export reports to PDF, Excel and CSV" }
    ]
  },
  {
    group: "Employees",
    permissions: [
      { permission: PERMISSIONS.EMPLOYEE_READ_OWN, label: "View their own employee record" },
      { permission: PERMISSIONS.EMPLOYEE_READ_TEAM, label: "View their team's records" },
      { permission: PERMISSIONS.EMPLOYEE_READ_ALL, label: "View every employee record" },
      { permission: PERMISSIONS.EMPLOYEE_CREATE, label: "Add a new employee" },
      { permission: PERMISSIONS.EMPLOYEE_UPDATE_OWN, label: "Edit their own contact details" },
      { permission: PERMISSIONS.EMPLOYEE_UPDATE_ALL, label: "Edit any employee record" },
      { permission: PERMISSIONS.EMPLOYEE_DELETE, label: "Archive an employee" },
      { permission: PERMISSIONS.EMPLOYEE_EXPORT, label: "Export the employee list" },
      { permission: PERMISSIONS.EMPLOYEE_HISTORY_READ_OWN, label: "View their own employment history" },
      { permission: PERMISSIONS.EMPLOYEE_HISTORY_READ_ALL, label: "View anyone\u2019s employment history" },
      { permission: PERMISSIONS.EMPLOYEE_HISTORY_MANAGE, label: "Correct employment history" }
    ]
  },
  {
    group: "Organisation",
    permissions: [
      { permission: PERMISSIONS.DEPARTMENT_READ, label: "View departments" },
      { permission: PERMISSIONS.DEPARTMENT_MANAGE, label: "Add, edit and archive departments" },
      { permission: PERMISSIONS.POSITION_READ, label: "View positions" },
      { permission: PERMISSIONS.POSITION_MANAGE, label: "Add, edit and archive positions" },
      { permission: PERMISSIONS.SALARY_GRADE_READ, label: "View salary grades" },
      { permission: PERMISSIONS.SALARY_GRADE_MANAGE, label: "Add and edit salary grades" },
      { permission: PERMISSIONS.ORG_CHART_VIEW, label: "View the org chart" },
      { permission: PERMISSIONS.WORK_SCHEDULE_READ, label: "View work schedules" },
      { permission: PERMISSIONS.WORK_SCHEDULE_MANAGE, label: "Create and edit work schedules" }
    ]
  },
  {
    group: "Integrations",
    permissions: [
      { permission: PERMISSIONS.UISP_OPEN, label: "Open UISP from the sidebar" }
    ]
  },
  {
    group: "Chat",
    permissions: [
      {
        permission: PERMISSIONS.CHAT_MANAGE,
        label: "Start conversations and decide who is in a group"
      }
    ]
  },
  {
    group: "Location",
    permissions: [
      {
        permission: PERMISSIONS.LOCATION_SHARE,
        label: "Share their own location while the app is open"
      },
      { permission: PERMISSIONS.LOCATION_READ_TEAM, label: "See their team's location" },
      { permission: PERMISSIONS.LOCATION_READ_ALL, label: "See everyone's location" }
    ]
  },
  {
    group: "Attendance",
    permissions: [
      { permission: PERMISSIONS.ATTENDANCE_READ_OWN, label: "View their own attendance" },
      { permission: PERMISSIONS.ATTENDANCE_READ_TEAM, label: "View their team's attendance" },
      { permission: PERMISSIONS.ATTENDANCE_READ_ALL, label: "View everyone's attendance" },
      { permission: PERMISSIONS.ATTENDANCE_PUNCH, label: "Clock in and out" },
      { permission: PERMISSIONS.ATTENDANCE_MANAGE, label: "Edit attendance records" },
      { permission: PERMISSIONS.ATTENDANCE_APPROVE_CORRECTION, label: "Approve an attendance correction" },
      {
        permission: PERMISSIONS.ATTENDANCE_AUTHORISE_REST_DAY,
        label: "Authorise work on a rest day"
      },
      { permission: PERMISSIONS.ATTENDANCE_EXPORT, label: "Export attendance" }
    ]
  },
  {
    group: "Leave",
    permissions: [
      { permission: PERMISSIONS.LEAVE_READ_OWN, label: "View their own leave" },
      { permission: PERMISSIONS.LEAVE_READ_TEAM, label: "View their team's leave" },
      { permission: PERMISSIONS.LEAVE_READ_ALL, label: "View everyone's leave" },
      { permission: PERMISSIONS.LEAVE_REQUEST, label: "File a leave request" },
      { permission: PERMISSIONS.LEAVE_APPROVE_MANAGER, label: "Approve leave as the manager (first stage)" },
      { permission: PERMISSIONS.LEAVE_APPROVE_HR, label: "Approve leave as HR (final stage)" },
      { permission: PERMISSIONS.LEAVE_MANAGE_TYPES, label: "Edit leave types" },
      { permission: PERMISSIONS.LEAVE_MANAGE_BALANCES, label: "Adjust leave balances" },
      { permission: PERMISSIONS.LEAVE_EXPORT, label: "Export leave records" }
    ]
  },
  {
    group: "Payroll",
    permissions: [
      { permission: PERMISSIONS.PAYSLIP_READ_OWN, label: "View their own payslips" },
      { permission: PERMISSIONS.PAYSLIP_READ_ALL, label: "View everyone's payslips and salaries" },
      { permission: PERMISSIONS.PAYROLL_PROCESS, label: "Run a payroll" },
      { permission: PERMISSIONS.PAYROLL_APPROVE, label: "Approve and release a payroll" },
      { permission: PERMISSIONS.PAYROLL_MANAGE_COMPONENTS, label: "Edit allowances and deductions" },
      { permission: PERMISSIONS.PAYROLL_MANAGE_CONTRIBUTIONS, label: "Edit SSS, PhilHealth, Pag-IBIG and tax tables" },
      { permission: PERMISSIONS.PAYROLL_EXPORT, label: "Export payroll" }
    ]
  },
  {
    group: "Finance",
    permissions: [
      { permission: PERMISSIONS.FUND_REQUEST_SUBMIT, label: "Request funds" },
      { permission: PERMISSIONS.FUND_REQUEST_READ_OWN, label: "View their own fund requests" },
      { permission: PERMISSIONS.FUND_REQUEST_READ_TEAM, label: "View their team's fund requests" },
      { permission: PERMISSIONS.FUND_REQUEST_READ_ALL, label: "View every fund request" },
      {
        permission: PERMISSIONS.FUND_REQUEST_APPROVE_MANAGER,
        label: "Approve a fund request as the manager"
      },
      { permission: PERMISSIONS.FUND_REQUEST_APPROVE_HR, label: "Approve a fund request as HR" },
      {
        permission: PERMISSIONS.FUND_REQUEST_APPROVE_MANAGEMENT,
        label: "Approve a fund request as management"
      },
      { permission: PERMISSIONS.FUND_RELEASE, label: "Release money against an approved request" },
      { permission: PERMISSIONS.EXPENSE_SUBMIT, label: "Record their own expenses" },
      { permission: PERMISSIONS.EXPENSE_READ_ALL, label: "View everyone's expenses" },
      { permission: PERMISSIONS.EXPENSE_MANAGE, label: "Record expenses on behalf of the company" },
      { permission: PERMISSIONS.LIQUIDATION_SUBMIT, label: "Liquidate money they were given" },
      { permission: PERMISSIONS.LIQUIDATION_VERIFY, label: "Verify and settle a liquidation" },
      { permission: PERMISSIONS.REIMBURSEMENT_SUBMIT, label: "Claim money they spent themselves" },
      { permission: PERMISSIONS.REIMBURSEMENT_PAY, label: "Pay a reimbursement" },
      { permission: PERMISSIONS.VEHICLE_READ, label: "View vehicles" },
      { permission: PERMISSIONS.VEHICLE_MANAGE, label: "Manage vehicles and their servicing" },
      { permission: PERMISSIONS.FUEL_SUBMIT, label: "Record a fuel purchase" },
      { permission: PERMISSIONS.FUEL_READ_ALL, label: "View all fuel records" },
      { permission: PERMISSIONS.BUDGET_READ, label: "View budgets" },
      { permission: PERMISSIONS.BUDGET_MANAGE, label: "Set budgets" },
      {
        permission: PERMISSIONS.FINANCE_SETTINGS_MANAGE,
        label: "Configure approval thresholds and expense categories"
      },
      { permission: PERMISSIONS.FINANCE_REPORT_VIEW, label: "View financial reports" }
    ]
  },
  {
    group: "Insurance",
    permissions: [
      { permission: PERMISSIONS.INSURANCE_READ_OWN, label: "View their own insurance" },
      { permission: PERMISSIONS.INSURANCE_READ_ALL, label: "View everyone's insurance" },
      { permission: PERMISSIONS.INSURANCE_MANAGE, label: "Manage providers, policies and coverage" },
      { permission: PERMISSIONS.INSURANCE_EXPORT, label: "Export insurance records" }
    ]
  },
  {
    group: "Performance and training",
    permissions: [
      { permission: PERMISSIONS.PERFORMANCE_READ_OWN, label: "View their own reviews" },
      { permission: PERMISSIONS.PERFORMANCE_READ_TEAM, label: "View their team's reviews" },
      { permission: PERMISSIONS.PERFORMANCE_READ_ALL, label: "View every review" },
      { permission: PERMISSIONS.PERFORMANCE_REVIEW, label: "Write a performance review" },
      { permission: PERMISSIONS.PERFORMANCE_MANAGE, label: "Manage review cycles and KPIs" },
      { permission: PERMISSIONS.GOAL_MANAGE_OWN, label: "Manage their own goals" },
      { permission: PERMISSIONS.GOAL_MANAGE_TEAM, label: "Manage their team's goals" },
      { permission: PERMISSIONS.TRAINING_READ_OWN, label: "View their own training" },
      { permission: PERMISSIONS.TRAINING_READ_ALL, label: "View all training records" },
      { permission: PERMISSIONS.TRAINING_MANAGE, label: "Manage programmes and enrolments" },
      { permission: PERMISSIONS.TRAINING_EXPORT, label: "Export training records" }
    ]
  },
  {
    group: "Records and conduct",
    permissions: [
      { permission: PERMISSIONS.DOCUMENT_READ_OWN, label: "View their own documents" },
      { permission: PERMISSIONS.DOCUMENT_READ_ALL, label: "View everyone's documents" },
      { permission: PERMISSIONS.DOCUMENT_UPLOAD_OWN, label: "Upload their own documents" },
      { permission: PERMISSIONS.DOCUMENT_MANAGE, label: "Manage all documents and categories" },
      { permission: PERMISSIONS.DISCIPLINARY_READ_OWN, label: "View their own disciplinary records" },
      { permission: PERMISSIONS.DISCIPLINARY_READ_ALL, label: "View all disciplinary records" },
      { permission: PERMISSIONS.DISCIPLINARY_MANAGE, label: "Record violations and issue actions" },
      { permission: PERMISSIONS.AWARD_READ, label: "View awards and recognition" },
      { permission: PERMISSIONS.AWARD_MANAGE, label: "Grant awards" }
    ]
  },
  {
    group: "Workplace",
    permissions: [
      { permission: PERMISSIONS.ASSET_READ_OWN, label: "View assets issued to them" },
      { permission: PERMISSIONS.ASSET_READ_ALL, label: "View all assets" },
      { permission: PERMISSIONS.ASSET_MANAGE, label: "Issue, return and manage assets" },
      { permission: PERMISSIONS.ASSET_EXPORT, label: "Export the asset register" },
      { permission: PERMISSIONS.HOLIDAY_READ, label: "View the holiday calendar" },
      { permission: PERMISSIONS.HOLIDAY_MANAGE, label: "Edit the holiday calendar" },
      { permission: PERMISSIONS.ANNOUNCEMENT_READ, label: "Read announcements" },
      { permission: PERMISSIONS.ANNOUNCEMENT_MANAGE, label: "Publish announcements" },
      { permission: PERMISSIONS.REQUEST_SUBMIT, label: "Submit a request (COE, ID replacement\u2026)" },
      { permission: PERMISSIONS.REQUEST_READ_OWN, label: "View their own requests" },
      { permission: PERMISSIONS.REQUEST_READ_TEAM, label: "View their team's requests" },
      { permission: PERMISSIONS.REQUEST_READ_ALL, label: "View all requests" },
      { permission: PERMISSIONS.REQUEST_PROCESS, label: "Process and release requests" }
    ]
  },
  {
    group: "Offboarding",
    permissions: [
      { permission: PERMISSIONS.RESIGNATION_SUBMIT, label: "Submit their own resignation" },
      { permission: PERMISSIONS.RESIGNATION_READ_OWN, label: "View their own resignation" },
      { permission: PERMISSIONS.RESIGNATION_READ_ALL, label: "View all resignations" },
      { permission: PERMISSIONS.RESIGNATION_MANAGE, label: "Manage clearance, exit interviews and final pay" }
    ]
  },
  {
    group: "Administration",
    permissions: [
      { permission: PERMISSIONS.USER_READ, label: "View user accounts" },
      { permission: PERMISSIONS.USER_MANAGE, label: "Add, edit and deactivate staff accounts", adminOnly: true },
      { permission: PERMISSIONS.PERMISSION_MANAGE, label: "Change these permissions", adminOnly: true },
      { permission: PERMISSIONS.AUDIT_LOG_READ, label: "View the audit log", adminOnly: true },
      { permission: PERMISSIONS.SETTING_READ, label: "View system settings" },
      { permission: PERMISSIONS.SETTING_MANAGE, label: "Change system settings", adminOnly: true }
    ]
  }
];
var ADMIN_ONLY_PERMISSIONS = PERMISSION_CATALOGUE.flatMap(
  (group) => group.permissions.filter((entry) => entry.adminOnly).map((entry) => entry.permission)
);
var PERMISSION_LABELS = Object.fromEntries(
  PERMISSION_CATALOGUE.flatMap(
    (group) => group.permissions.map((entry) => [entry.permission, entry.label])
  )
);
function isAdminOnly(permission) {
  return ADMIN_ONLY_PERMISSIONS.includes(permission);
}

// src/dto/person-name.ts
function personName(parts) {
  const last = parts.lastName?.trim() ?? "";
  const given = [parts.firstName, parts.middleName, parts.suffix].map((part) => part?.trim() ?? "").filter(Boolean).join(" ");
  if (!last) return given;
  if (!given) return last;
  return `${last}, ${given}`;
}
function readableName(value) {
  return value.replace(
    /\S+/g,
    (word) => /\p{Ll}/u.test(word) ? word : word.replace(/\p{L}+/gu, (run) => run[0] + run.slice(1).toLowerCase())
  );
}
function spokenName(parts) {
  return [readableName(parts.firstName), readableName(parts.lastName)].map((part) => part.trim()).filter(Boolean).join(" ");
}

// src/dto/organisation.ts
import { z as z6 } from "zod";
var createDepartmentSchema = z6.object({
  code: requiredString(24, "Code").transform((value) => value.toUpperCase()).refine((value) => /^[A-Z0-9-]+$/.test(value), {
    message: "Code may contain letters, numbers and hyphens only"
  }),
  name: upperRequired(120, "Name"),
  description: optionalString(500),
  parentId: optionalUuid,
  headId: optionalUuid,
  costCenter: optionalString(64)
});
var updateDepartmentSchema = createDepartmentSchema.omit({ code: true }).partial().extend({ isActive: z6.boolean().optional() });
var departmentQuerySchema = paginationQuerySchema.extend({
  parentId: z6.string().uuid().optional(),
  isActive: booleanQuery,
  /** Include the employee count on each row — an extra aggregate, so opt-in. */
  withCounts: booleanQuery
});
var createSalaryGradeSchema = z6.object({
  code: requiredString(24, "Code").transform((value) => value.toUpperCase()),
  name: upperRequired(120, "Name"),
  minSalary: moneySchema("Minimum salary"),
  midSalary: moneySchema("Midpoint salary").nullish(),
  maxSalary: moneySchema("Maximum salary")
}).refine((data) => data.maxSalary >= data.minSalary, {
  path: ["maxSalary"],
  message: "Maximum must be at least the minimum"
}).refine(
  (data) => data.midSalary == null || data.midSalary >= data.minSalary && data.midSalary <= data.maxSalary,
  { path: ["midSalary"], message: "Midpoint must sit between the minimum and maximum" }
);
var updateSalaryGradeSchema = z6.object({
  name: upperRequired(120, "Name").optional(),
  minSalary: moneySchema("Minimum salary").optional(),
  midSalary: moneySchema("Midpoint salary").nullish(),
  maxSalary: moneySchema("Maximum salary").optional(),
  isActive: z6.boolean().optional()
});
var createPositionSchema = z6.object({
  code: requiredString(24, "Code").transform((value) => value.toUpperCase()),
  title: upperRequired(120, "Title"),
  description: optionalString(500),
  departmentId: uuidSchema,
  salaryGradeId: optionalUuid,
  level: z6.number().int().min(0).max(99).default(0),
  headcountCap: z6.number().int().positive().max(9999).nullish()
});
var updatePositionSchema = createPositionSchema.omit({ code: true }).partial().extend({ isActive: z6.boolean().optional() });
var positionQuerySchema = paginationQuerySchema.extend({
  departmentId: z6.string().uuid().optional(),
  salaryGradeId: z6.string().uuid().optional(),
  isActive: booleanQuery
});

// src/dto/employee.ts
import { z as z7 } from "zod";
var genderValues = Object.values(Gender);
var civilStatusValues = Object.values(CivilStatus);
var employmentStatusValues = Object.values(EmploymentStatus);
var employeeStatusValues = Object.values(EmployeeStatus);
var payFrequencyValues = Object.values(PayFrequency);
var bankAccountTypeValues = Object.values(BankAccountType);
var emergencyContactSchema = z7.object({
  id: uuidSchema.optional(),
  name: upperRequired(160, "Name"),
  relationship: upperRequired(64, "Relationship"),
  mobileNumber: mobileNumberSchema,
  phoneNumber: optionalPhone,
  address: optionalString(255),
  isPrimary: z7.boolean().default(false)
});
var createEmployeeSchema = z7.object({
  // --- Personal ---
  employeeNo: requiredString(32, "Employee number").transform((v) => v.toUpperCase()),
  firstName: upperRequired(80, "First name"),
  middleName: upperOptional(80),
  lastName: upperRequired(80, "Last name"),
  suffix: upperOptional(16),
  photoUrl: optionalString(500),
  birthDate: dateOnlySchema,
  gender: z7.enum(genderValues),
  civilStatus: z7.enum(civilStatusValues),
  nationality: upperRequired(64, "Nationality").default("Filipino"),
  // --- Contact ---
  workEmail: emailSchema,
  personalEmail: optionalEmail,
  mobileNumber: mobileNumberSchema,
  phoneNumber: optionalPhone,
  // --- Address ---
  addressLine1: upperRequired(255, "Address"),
  addressLine2: upperOptional(255),
  barangay: upperOptional(120),
  cityMunicipality: upperRequired(120, "City or municipality"),
  province: upperRequired(120, "Province"),
  postalCode: optionalString(16),
  country: upperRequired(64, "Country").default("Philippines"),
  // --- Employment ---
  departmentId: uuidSchema,
  positionId: uuidSchema,
  managerId: optionalUuid,
  workScheduleId: optionalUuid,
  employmentStatus: z7.enum(employmentStatusValues).default(EmploymentStatus.PROBATIONARY),
  dateHired: dateOnlySchema,
  dateRegularized: optionalDateOnly,
  contractEndDate: optionalDateOnly,
  // --- Compensation ---
  baseSalary: moneySchema("Base salary"),
  payFrequency: z7.enum(payFrequencyValues).default(PayFrequency.WEEKLY),
  bankName: optionalString(120),
  bankBranch: optionalString(120),
  bankAccountName: upperOptional(160),
  bankAccountNumber: optionalString(64),
  bankAccountType: z7.enum(bankAccountTypeValues).nullish(),
  isTaxExempt: z7.boolean().default(false),
  /** Credited a full period and never charged lateness, undertime or absence. */
  isAttendanceExempt: z7.boolean().default(false),
  isMinimumWage: z7.boolean().default(false),
  // --- Government IDs ---
  sssNumber: govIdSchema,
  philhealthNumber: govIdSchema,
  pagibigNumber: govIdSchema,
  tin: govIdSchema,
  emergencyContacts: z7.array(emergencyContactSchema).max(5).default([]),
  /** Create a login for this employee and email them an activation link. */
  createUserAccount: z7.boolean().default(false)
}).superRefine((data, ctx) => {
  if (data.dateHired < data.birthDate) {
    ctx.addIssue({
      code: z7.ZodIssueCode.custom,
      path: ["dateHired"],
      message: "Hire date cannot precede the date of birth"
    });
  }
  const ageAtHire = (Date.parse(data.dateHired) - Date.parse(data.birthDate)) / (365.25 * 24 * 3600 * 1e3);
  if (ageAtHire < 15) {
    ctx.addIssue({
      code: z7.ZodIssueCode.custom,
      path: ["birthDate"],
      message: "Employee would be under 15 at the hire date \u2014 check these dates"
    });
  }
  if (data.dateRegularized && data.dateRegularized < data.dateHired) {
    ctx.addIssue({
      code: z7.ZodIssueCode.custom,
      path: ["dateRegularized"],
      message: "Regularisation cannot precede the hire date"
    });
  }
  if (data.contractEndDate && data.contractEndDate < data.dateHired) {
    ctx.addIssue({
      code: z7.ZodIssueCode.custom,
      path: ["contractEndDate"],
      message: "Contract end cannot precede the hire date"
    });
  }
  const primaryContacts = data.emergencyContacts.filter((contact) => contact.isPrimary);
  if (primaryContacts.length > 1) {
    ctx.addIssue({
      code: z7.ZodIssueCode.custom,
      path: ["emergencyContacts"],
      message: "Only one emergency contact can be marked primary"
    });
  }
});
var updateEmployeeSchema = z7.object({
  firstName: upperRequired(80, "First name"),
  middleName: upperOptional(80),
  lastName: upperRequired(80, "Last name"),
  suffix: upperOptional(16),
  photoUrl: optionalString(500),
  birthDate: dateOnlySchema,
  gender: z7.enum(genderValues),
  civilStatus: z7.enum(civilStatusValues),
  nationality: upperRequired(64, "Nationality"),
  workEmail: emailSchema,
  personalEmail: optionalEmail,
  mobileNumber: mobileNumberSchema,
  phoneNumber: optionalPhone,
  addressLine1: upperRequired(255, "Address"),
  addressLine2: upperOptional(255),
  barangay: upperOptional(120),
  cityMunicipality: upperRequired(120, "City or municipality"),
  province: upperRequired(120, "Province"),
  postalCode: optionalString(16),
  country: upperRequired(64, "Country"),
  departmentId: uuidSchema,
  positionId: uuidSchema,
  managerId: optionalUuid,
  workScheduleId: optionalUuid,
  employmentStatus: z7.enum(employmentStatusValues),
  status: z7.enum(employeeStatusValues),
  dateHired: dateOnlySchema,
  dateRegularized: optionalDateOnly,
  contractEndDate: optionalDateOnly,
  baseSalary: moneySchema("Base salary"),
  payFrequency: z7.enum(payFrequencyValues),
  bankName: optionalString(120),
  bankBranch: optionalString(120),
  bankAccountName: upperOptional(160),
  bankAccountNumber: optionalString(64),
  bankAccountType: z7.enum(bankAccountTypeValues).nullish(),
  isTaxExempt: z7.boolean(),
  isAttendanceExempt: z7.boolean(),
  isMinimumWage: z7.boolean(),
  sssNumber: govIdSchema,
  philhealthNumber: govIdSchema,
  pagibigNumber: govIdSchema,
  tin: govIdSchema,
  emergencyContacts: z7.array(emergencyContactSchema).max(5),
  /** Recorded on the movement row when this change alters pay or position. */
  movementReason: optionalString(500)
}).partial();
var updateOwnProfileSchema = z7.object({
  personalEmail: optionalEmail,
  mobileNumber: mobileNumberSchema,
  phoneNumber: optionalPhone,
  addressLine1: upperRequired(255, "Address"),
  addressLine2: upperOptional(255),
  barangay: upperOptional(120),
  cityMunicipality: upperRequired(120, "City or municipality"),
  province: upperRequired(120, "Province"),
  postalCode: optionalString(16),
  civilStatus: z7.enum(civilStatusValues),
  emergencyContacts: z7.array(emergencyContactSchema).max(5)
}).partial();
var employeeQuerySchema = paginationQuerySchema.extend({
  departmentId: uuidListQuery,
  positionId: uuidListQuery,
  managerId: z7.string().uuid().optional(),
  employmentStatus: z7.string().optional(),
  status: z7.string().optional(),
  hiredFrom: z7.string().optional(),
  hiredTo: z7.string().optional(),
  /** Include soft-deleted rows. Requires employee:delete. */
  includeArchived: booleanQuery
});

// src/dto/user.ts
import { z as z8 } from "zod";
var roleValues = Object.values(Role);
var statusValues = Object.values(UserStatus);
var createUserSchema = z8.object({
  email: emailSchema,
  role: z8.enum(roleValues),
  /**
   * Links the login to an employee record. Required in practice for anything
   * scoped to `own` or `team` — without it those permissions have nothing to
   * resolve against and the API refuses the request.
   */
  employeeId: optionalUuid
});
var updateUserSchema = z8.object({
  role: z8.enum(roleValues).optional(),
  status: z8.enum(statusValues).optional(),
  employeeId: optionalUuid.optional()
});
var userQuerySchema = paginationQuerySchema.extend({
  role: z8.string().optional(),
  status: z8.string().optional()
});

// src/dto/work-schedule.ts
import { z as z9 } from "zod";
var timeSchema = z9.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, "Use 24-hour time, e.g. 08:00");
var WEEKDAYS = [
  { value: 1, label: "Monday", short: "Mon" },
  { value: 2, label: "Tuesday", short: "Tue" },
  { value: 3, label: "Wednesday", short: "Wed" },
  { value: 4, label: "Thursday", short: "Thu" },
  { value: 5, label: "Friday", short: "Fri" },
  { value: 6, label: "Saturday", short: "Sat" },
  { value: 7, label: "Sunday", short: "Sun" }
];
var createWorkScheduleSchema = z9.object({
  code: upperRequired(24, "Code").refine((value) => /^[A-Z0-9-]+$/.test(value), {
    message: "Letters, numbers and hyphens only"
  }),
  name: upperRequired(120, "Name"),
  workingDays: z9.array(z9.number().int().min(1).max(7)).min(1, "Choose at least one working day").max(7).transform((days) => [...new Set(days)].sort((a, b) => a - b)),
  timeIn: timeSchema,
  timeOut: timeSchema,
  breakMinutes: z9.coerce.number().int().min(0).max(480),
  gracePeriodMinutes: z9.coerce.number().int().min(0).max(120),
  overtimeThresholdMinutes: z9.coerce.number().int().min(0).max(480),
  isFlexible: z9.boolean().default(false),
  requiredMinutesPerDay: z9.coerce.number().int().min(1).max(1440),
  isDefault: z9.boolean().default(false),
  description: optionalString(255)
}).superRefine((data, ctx) => {
  const toMinutes = (value) => {
    const [hours, minutes] = value.split(":").map(Number);
    return (hours ?? 0) * 60 + (minutes ?? 0);
  };
  const start = toMinutes(data.timeIn);
  const end = toMinutes(data.timeOut);
  const span = end > start ? end - start : 1440 - start + end;
  if (span === 0) {
    ctx.addIssue({
      code: z9.ZodIssueCode.custom,
      path: ["timeOut"],
      message: "Start and end cannot be the same time"
    });
  }
  if (data.breakMinutes >= span) {
    ctx.addIssue({
      code: z9.ZodIssueCode.custom,
      path: ["breakMinutes"],
      message: "Break cannot be as long as the whole shift"
    });
  }
  if (!data.isFlexible && data.requiredMinutesPerDay > span - data.breakMinutes) {
    ctx.addIssue({
      code: z9.ZodIssueCode.custom,
      path: ["requiredMinutesPerDay"],
      message: "Required hours exceed the shift length once the break is deducted"
    });
  }
});
var updateWorkScheduleSchema = z9.object({
  name: upperRequired(120, "Name"),
  workingDays: z9.array(z9.number().int().min(1).max(7)).min(1).max(7),
  timeIn: timeSchema,
  timeOut: timeSchema,
  breakMinutes: z9.coerce.number().int().min(0).max(480),
  gracePeriodMinutes: z9.coerce.number().int().min(0).max(120),
  overtimeThresholdMinutes: z9.coerce.number().int().min(0).max(480),
  isFlexible: z9.boolean(),
  requiredMinutesPerDay: z9.coerce.number().int().min(1).max(1440),
  isDefault: z9.boolean(),
  isActive: z9.boolean(),
  description: optionalString(255)
}).partial();
var workScheduleQuerySchema = paginationQuerySchema.extend({
  isActive: z9.union([z9.boolean(), z9.enum(["true", "false"])]).optional()
});
function describeWorkingDays(days) {
  if (days.length === 0) return "No working days";
  if (days.length === 7) return "Every day";
  const sorted = [...days].sort((a, b) => a - b);
  const isContiguous = sorted.every((day, index) => index === 0 || day === sorted[index - 1] + 1);
  const short = (day) => WEEKDAYS.find((entry) => entry.value === day)?.short ?? "?";
  if (isContiguous && sorted.length > 2) {
    return `${short(sorted[0])}\u2013${short(sorted[sorted.length - 1])}`;
  }
  return sorted.map(short).join(", ");
}

// src/dto/employee-schedule.ts
import { z as z10 } from "zod";
var assignEmployeeScheduleSchema = z10.object({
  workScheduleId: uuidSchema,
  effectiveFrom: dateOnlySchema,
  effectiveTo: optionalDateOnly
}).refine((data) => !data.effectiveTo || data.effectiveTo >= data.effectiveFrom, {
  path: ["effectiveTo"],
  message: "The end date cannot precede the start date"
});
var updateEmployeeScheduleSchema = z10.object({
  effectiveTo: optionalDateOnly
});
function previousDay(date) {
  const instant = /* @__PURE__ */ new Date(`${date}T00:00:00.000Z`);
  instant.setUTCDate(instant.getUTCDate() - 1);
  return instant.toISOString().slice(0, 10);
}
function planScheduleAssignment(existing, proposed) {
  if (proposed.effectiveTo && proposed.effectiveTo < proposed.effectiveFrom) {
    return {
      ok: false,
      conflictId: null,
      message: "The end date cannot precede the start date"
    };
  }
  const overlapping = existing.filter((window2) => {
    const endsBeforeProposed = window2.effectiveTo !== null && window2.effectiveTo < proposed.effectiveFrom;
    const startsAfterProposed = proposed.effectiveTo !== null && window2.effectiveFrom > proposed.effectiveTo;
    return !endsBeforeProposed && !startsAfterProposed;
  });
  if (overlapping.length === 0) return { ok: true, closes: null };
  const clash = overlapping[0];
  if (overlapping.length === 1 && clash.effectiveTo === null && clash.effectiveFrom < proposed.effectiveFrom) {
    return {
      ok: true,
      closes: { id: clash.id, effectiveTo: previousDay(proposed.effectiveFrom) }
    };
  }
  const window = clash.effectiveTo ? `${clash.effectiveFrom} to ${clash.effectiveTo}` : `${clash.effectiveFrom} onwards`;
  return {
    ok: false,
    conflictId: clash.id,
    message: clash.effectiveFrom === proposed.effectiveFrom ? `Another schedule already starts on ${proposed.effectiveFrom}. End that one first, or start this the day after.` : `This overlaps an assignment covering ${window}. End that one first, or start this the day after it stops.`
  };
}

// src/dto/attendance.ts
import { z as z11 } from "zod";
var statusValues2 = Object.values(AttendanceStatus);
var sourceValues = Object.values(AttendanceSource);
var punchTimeSchema = z11.string().regex(/^([01]\d|2[0-3]):[0-5]\d(\+1)?$/, "Use HH:mm, or HH:mm+1 for the next day");
var COMPANY_UTC_OFFSET = "+08:00";
function toPunchInstant(date, value) {
  const nextDay = value.endsWith("+1");
  const time = nextDay ? value.slice(0, -2) : value;
  const instant = /* @__PURE__ */ new Date(`${date}T${time}:00${COMPANY_UTC_OFFSET}`);
  return nextDay ? new Date(instant.getTime() + 864e5) : instant;
}
var punchSchema = z11.object({
  /** Optional note, e.g. a field location. */
  remarks: optionalString(255)
});
var formNumber = (label) => z11.union([z11.string(), z11.number()]).transform((value) => typeof value === "string" && value.trim() === "" ? void 0 : value).optional().pipe(z11.coerce.number({ message: `${label} must be a number` }).optional());
var punchCaptureSchema = z11.object({
  remarks: optionalString(255),
  latitude: formNumber("Latitude").pipe(
    z11.number().min(-90).max(90, { message: "Latitude is out of range" }).optional()
  ),
  longitude: formNumber("Longitude").pipe(
    z11.number().min(-180).max(180, { message: "Longitude is out of range" }).optional()
  ),
  accuracyMeters: formNumber("Accuracy").pipe(
    z11.number().min(0, { message: "Accuracy cannot be negative" }).optional()
  ),
  /**
   * What the device believed the time was, ISO-8601. Recorded so a doctored
   * clock is visible; never used as the time of the punch.
   */
  deviceReportedAt: z11.string().datetime({ message: "Device time must be an ISO-8601 timestamp" }).optional().or(z11.literal("").transform(() => void 0))
});
var reviewPunchSchema = z11.discriminatedUnion("action", [
  z11.object({
    action: z11.literal("DECLINE"),
    reason: requiredString(500, "Reason")
  }),
  z11.object({
    action: z11.literal("RESTORE")
  })
]);
function dispositionFor(facts) {
  if (facts.hasPunch && !facts.punchDeclined) return "PRESENT";
  if (facts.onLeave) return "ON_LEAVE";
  if (facts.attendanceExempt) return "NOT_EXPECTED";
  return facts.isWorkingDay ? "ABSENT" : "NOT_EXPECTED";
}
var upsertAttendanceSchema = z11.object({
  employeeId: uuidSchema,
  date: dateOnlySchema,
  timeIn: punchTimeSchema.nullish(),
  timeOut: punchTimeSchema.nullish(),
  status: z11.enum(statusValues2).optional(),
  remarks: optionalString(255)
}).superRefine((data, ctx) => {
  if (data.timeOut && !data.timeIn) {
    ctx.addIssue({
      code: z11.ZodIssueCode.custom,
      path: ["timeIn"],
      message: "A time out needs a matching time in"
    });
  }
});
var attendanceQuerySchema = paginationQuerySchema.extend({
  employeeId: z11.string().uuid().optional(),
  departmentId: z11.string().uuid().optional(),
  /** Inclusive `YYYY-MM-DD` bounds. */
  from: z11.string().optional(),
  to: z11.string().optional(),
  status: z11.string().optional()
});
var recomputeRangeSchema = z11.object({
  from: dateOnlySchema,
  to: dateOnlySchema
}).refine((data) => data.to >= data.from, {
  path: ["to"],
  message: "The end date cannot precede the start date"
});
var createCorrectionSchema = z11.object({
  date: dateOnlySchema,
  requestedTimeIn: punchTimeSchema.nullish(),
  requestedTimeOut: punchTimeSchema.nullish(),
  reason: z11.string().trim().min(10, "Explain the correction in at least 10 characters").max(500)
}).superRefine((data, ctx) => {
  if (!data.requestedTimeIn && !data.requestedTimeOut) {
    ctx.addIssue({
      code: z11.ZodIssueCode.custom,
      path: ["requestedTimeIn"],
      message: "Give at least one corrected time"
    });
  }
});
var reviewCorrectionSchema = z11.object({
  action: z11.enum(["APPROVED", "REJECTED"]),
  reviewRemarks: optionalString(500)
});
var ATTENDANCE_SOURCE_LABELS = {
  BIOMETRIC: "Biometric",
  WEB: "Web",
  MOBILE: "Mobile",
  MANUAL: "Keyed in by HR",
  IMPORT: "Imported from file"
};
var UNOBSERVED_ATTENDANCE_SOURCES = ["MANUAL", "IMPORT"];
var ATTENDANCE_STATUS_LABELS = {
  PRESENT: "Present",
  LATE: "Late",
  ABSENT: "Absent",
  HALF_DAY: "Half day",
  ON_LEAVE: "On leave",
  REST_DAY: "Rest day",
  HOLIDAY: "Holiday",
  HOLIDAY_WORKED: "Worked holiday",
  SUSPENDED_WORK: "Work suspended"
};
function formatMinutes(minutes) {
  if (minutes <= 0) return "\u2014";
  const hours = Math.floor(minutes / 60);
  const remainder = minutes % 60;
  if (hours === 0) return `${remainder}m`;
  if (remainder === 0) return `${hours}h`;
  return `${hours}h ${remainder}m`;
}

// src/dto/rest-day-authorisation.ts
import { z as z12 } from "zod";
var issueRestDayAuthorisationSchema = z12.object({
  employeeId: uuidSchema,
  date: dateOnlySchema,
  reason: z12.string().trim().min(5, "Say why the work is required \u2014 this is the record of the instruction").max(500),
  /**
   * Optional because the honest answer is often "come in and finish the
   * install", with no hour count attached.
   */
  expectedMinutes: z12.number().int().min(1).max(1440).nullable().default(null)
});
var revokeRestDayAuthorisationSchema = z12.object({
  reason: z12.string().trim().min(5, "Say why the authorisation is being withdrawn").max(500)
});
function canAcknowledgeRestDay(authorisation, viewerEmployeeId) {
  if (!viewerEmployeeId || authorisation.employeeId !== viewerEmployeeId) {
    return { ok: false, reason: "not-yours" };
  }
  if (authorisation.revokedAt) return { ok: false, reason: "revoked" };
  if (authorisation.acknowledgedAt) return { ok: false, reason: "already" };
  return { ok: true };
}
function describeAcknowledgeRefusal(reason) {
  switch (reason) {
    case "not-yours":
      return "Only the person named on a rest day authorisation can confirm they have seen it.";
    case "revoked":
      return "This authorisation has been withdrawn, so there is nothing left to confirm.";
    case "already":
      return "You have already confirmed this one.";
  }
}
var REST_DAY_VARIANCE_TOLERANCE_MINUTES = 30;
function classifyRestDayWork(punch, authorisation, enforcedFrom) {
  if (punch.declinedAt) return { kind: "DECLINED" };
  if (!enforcedFrom || punch.date < enforcedFrom) return { kind: "NOT_ENFORCED" };
  if (!authorisation) return { kind: "UNAUTHORISED", because: "none" };
  if (authorisation.revokedAt) return { kind: "UNAUTHORISED", because: "revoked" };
  if (authorisation.expectedMinutes !== null) {
    const excess = punch.workedMinutes - authorisation.expectedMinutes;
    if (excess > REST_DAY_VARIANCE_TOLERANCE_MINUTES) {
      return {
        kind: "OVER_AUTHORISED",
        expectedMinutes: authorisation.expectedMinutes,
        excessMinutes: excess
      };
    }
  }
  return { kind: "AUTHORISED" };
}
function blocksPayroll(verdict) {
  return verdict.kind === "UNAUTHORISED";
}
function describeRestDayVerdict(verdict) {
  switch (verdict.kind) {
    case "DECLINED":
      return "Punch declined by a reviewer \u2014 not paid";
    case "NOT_ENFORCED":
      return "Before authorisation was required";
    case "AUTHORISED":
      return "Authorised";
    case "OVER_AUTHORISED":
      return `Worked ${verdict.excessMinutes} min past the ${verdict.expectedMinutes} min authorised`;
    case "UNAUTHORISED":
      return verdict.because === "revoked" ? "Authorisation was withdrawn \u2014 decline the punch or issue a new one" : "No authorisation \u2014 nobody recorded asking for this work";
  }
}

// src/dto/fund-approval.ts
import { z as z13 } from "zod";
var FUND_APPROVAL_LEVELS = ["MANAGER", "HR", "MANAGEMENT"];
var fundApprovalTierSchema = z13.object({
  /** Inclusive floor, in pesos. The first tier starts at 0. */
  minAmount: z13.number().nonnegative(),
  /** Inclusive ceiling. Null means "and above" — only the last tier may. */
  maxAmount: z13.number().positive().nullable(),
  /**
   * Levels that must approve, in order.
   *
   * May be empty, which means the tier is auto-approved on submission. That
   * is a deliberate option — a ₱50 parking reimbursement costing three
   * managers' attention is a process nobody follows for long.
   */
  levels: z13.array(z13.enum(FUND_APPROVAL_LEVELS))
}).refine((tier) => tier.maxAmount === null || tier.maxAmount >= tier.minAmount, {
  path: ["maxAmount"],
  message: "The ceiling cannot be below the floor"
});
var fundApprovalPolicySchema = z13.object({
  tiers: z13.array(fundApprovalTierSchema).min(1, "At least one tier is required"),
  /**
   * Skip approval entirely when the requester is the one who would approve.
   *
   * Off by default. Nobody approves their own request — that is rule 31 in
   * the brief and the first thing an auditor checks.
   */
  allowSelfApproval: z13.literal(false).default(false)
}).superRefine((policy, ctx) => {
  const sorted = [...policy.tiers].sort((a, b) => a.minAmount - b.minAmount);
  if (sorted[0].minAmount !== 0) {
    ctx.addIssue({
      code: z13.ZodIssueCode.custom,
      path: ["tiers"],
      message: "The first tier must start at 0, or small amounts fall through every rule"
    });
  }
  sorted.forEach((tier, index) => {
    if (index === 0) return;
    const previous = sorted[index - 1];
    if (previous.maxAmount === null) {
      ctx.addIssue({
        code: z13.ZodIssueCode.custom,
        path: ["tiers"],
        message: "Only the highest tier may be open-ended"
      });
      return;
    }
    if (tier.minAmount <= previous.maxAmount) {
      ctx.addIssue({
        code: z13.ZodIssueCode.custom,
        path: ["tiers"],
        message: `Tiers overlap between ${previous.minAmount} and ${tier.maxAmount ?? "\u221E"}`
      });
    } else if (tier.minAmount > previous.maxAmount + 0.01) {
      ctx.addIssue({
        code: z13.ZodIssueCode.custom,
        path: ["tiers"],
        message: `Nothing covers amounts between ${previous.maxAmount} and ${tier.minAmount}`
      });
    }
  });
  if (sorted.at(-1).maxAmount !== null) {
    ctx.addIssue({
      code: z13.ZodIssueCode.custom,
      path: ["tiers"],
      message: "The highest tier must be open-ended, or a large request has no approver"
    });
  }
});
var DEFAULT_FUND_APPROVAL_POLICY = {
  allowSelfApproval: false,
  tiers: [
    { minAmount: 0, maxAmount: 1e3, levels: ["MANAGER"] },
    { minAmount: 1000.01, maxAmount: 5e3, levels: ["MANAGER", "HR"] },
    { minAmount: 5000.01, maxAmount: 2e4, levels: ["MANAGER", "HR", "MANAGEMENT"] },
    { minAmount: 20000.01, maxAmount: null, levels: ["MANAGEMENT"] }
  ]
};
function approvalLevelsFor(amount, policy) {
  const tier = policy.tiers.find(
    (candidate) => amount >= candidate.minAmount && (candidate.maxAmount === null || amount <= candidate.maxAmount)
  );
  if (!tier) return null;
  return FUND_APPROVAL_LEVELS.filter((level) => tier.levels.includes(level));
}
function approvalProgress(amount, policy, decisions) {
  const required = approvalLevelsFor(amount, policy);
  if (required === null) return { kind: "NO_RULE" };
  for (const level of required) {
    const decision = decisions.find((entry) => entry.level === level);
    if (decision && !decision.approved) return { kind: "REJECTED", level };
    if (!decision) {
      return {
        kind: "AWAITING",
        level,
        remaining: required.slice(required.indexOf(level))
      };
    }
  }
  return { kind: "APPROVED" };
}

// src/dto/legal.ts
import { z as z14 } from "zod";
var acceptTermsSchema = z14.object({
  version: z14.string().trim().min(1).max(40)
});

// src/dto/device-credential.ts
import { z as z15 } from "zod";
var registerDeviceSchema = z15.object({
  label: z15.string().trim().min(1, "Give the phone a name").max(60)
});
var DEVICE_TOKEN_PREFIX = "khrd_";
var DEVICE_TOKEN_VISIBLE_CHARS = 6;

// src/dto/location.ts
import { z as z16 } from "zod";
var createLocationPingSchema = z16.object({
  latitude: z16.number().min(-90).max(90),
  longitude: z16.number().min(-180).max(180),
  /** Metres. The browser always supplies one; it is optional in case it stops. */
  accuracyMeters: z16.number().int().min(0).max(1e5).nullable().default(null),
  /** The device's own clock, recorded and never trusted. */
  deviceReportedAt: z16.string().datetime().nullable().default(null),
  batteryPercent: z16.number().int().min(0).max(100).nullable().default(null)
});
var LOCATION_STALE_AFTER_MINUTES = 240;
var LOCATION_FRESH_WITHIN_MINUTES = 30;
function describeLastSeen(lastSeenAt, now = /* @__PURE__ */ new Date()) {
  if (!lastSeenAt) return "Never reported";
  const minutes = Math.floor((now.getTime() - new Date(lastSeenAt).getTime()) / 6e4);
  if (minutes < 1) return "Just now";
  if (minutes === 1) return "1 minute ago";
  if (minutes < 60) return `${minutes} minutes ago`;
  const hours = Math.floor(minutes / 60);
  if (hours === 1) return "1 hour ago";
  if (hours < 24) return `${hours} hours ago`;
  const days = Math.floor(hours / 24);
  return days === 1 ? "Yesterday" : `${days} days ago`;
}
function isStale(lastSeenAt, now = /* @__PURE__ */ new Date()) {
  if (!lastSeenAt) return true;
  return now.getTime() - new Date(lastSeenAt).getTime() > LOCATION_STALE_AFTER_MINUTES * 6e4;
}
function isFresh(lastSeenAt, now = /* @__PURE__ */ new Date()) {
  if (!lastSeenAt) return false;
  return now.getTime() - new Date(lastSeenAt).getTime() <= LOCATION_FRESH_WITHIN_MINUTES * 6e4;
}
var LOCATION_PRECISE_WITHIN_METRES = 100;
function isPreciseFix(accuracyMeters) {
  if (accuracyMeters === null) return false;
  return accuracyMeters <= LOCATION_PRECISE_WITHIN_METRES;
}
function describeFixSource(accuracyMeters) {
  if (accuracyMeters === null) return "No accuracy reported";
  return isPreciseFix(accuracyMeters) ? "Satellite fix" : "Network fix \u2014 approximate";
}
var LOCATION_BATCH_MAX = 200;
var LOCATION_BATCH_MAX_AGE_HOURS = 48;
var locationPingBatchEntrySchema = createLocationPingSchema.extend({
  recordedAt: z16.string().datetime()
});
var createLocationPingBatchSchema = z16.object({
  pings: z16.array(locationPingBatchEntrySchema).min(1).max(LOCATION_BATCH_MAX)
});

// src/dto/thread.ts
import { z as z17 } from "zod";
var THREAD_BODY_MAX = 2e3;
var THREAD_PAGE_SIZE = 100;
var postThreadMessageSchema = z17.object({
  body: z17.string().trim().min(1, "Write something first").max(THREAD_BODY_MAX),
  /**
   * The sender's own id for this message.
   *
   * Required rather than optional: a field technician on mobile data whose
   * request times out will retry, and without this the retry posts a second
   * copy. Making the client supply it is what lets the server answer the retry
   * with the message it already stored instead of a duplicate or a 409.
   */
  clientId: z17.string().trim().min(8).max(64)
});
var editThreadMessageSchema = z17.object({
  body: z17.string().trim().min(1, "Write something first").max(THREAD_BODY_MAX)
});
var THREAD_DELETED_BODY = "This message was deleted.";

// src/dto/chat.ts
import { z as z18 } from "zod";
var CHAT_BODY_MAX = THREAD_BODY_MAX;
var CHAT_MENTIONS_PER_MESSAGE = 20;
var CHAT_PAGE_SIZE = 50;
var CHAT_TITLE_MAX = 80;
var CHAT_GROUP_MAX_MEMBERS = 200;
var bodySchema = z18.string().trim().min(1, "Write something first").max(CHAT_BODY_MAX);
var clientIdSchema = z18.string().trim().min(8).max(64);
var createDirectThreadSchema = z18.object({
  kind: z18.literal(ChatThreadKind.DIRECT),
  userId: uuidSchema
});
var createGroupThreadSchema = z18.object({
  kind: z18.literal(ChatThreadKind.GROUP),
  title: z18.string().trim().min(1, "Give the group a name").max(CHAT_TITLE_MAX),
  memberIds: z18.array(uuidSchema).min(1, "Add at least one person").max(CHAT_GROUP_MAX_MEMBERS),
  /**
   * One group per tap. A direct thread is idempotent by its pair; a group has
   * no natural key, so without this a "Create group" that times out on mobile
   * data and is tapped again makes two groups and rings every bell twice.
   */
  clientId: clientIdSchema
});
var createChatThreadSchema = z18.discriminatedUnion("kind", [
  createDirectThreadSchema,
  createGroupThreadSchema
]);
var renameChatThreadSchema = z18.object({
  title: z18.string().trim().min(1, "Give the group a name").max(CHAT_TITLE_MAX)
});
var addChatMembersSchema = z18.object({
  userIds: z18.array(uuidSchema).min(1).max(CHAT_GROUP_MAX_MEMBERS)
});
var CHAT_ATTACHMENTS_PER_MESSAGE = 10;
var CHAT_ATTACHMENT_MAX_BYTES = {
  IMAGE: 10 * 1024 * 1024,
  VIDEO: 50 * 1024 * 1024,
  FILE: 20 * 1024 * 1024
};
var CHAT_UPLOAD_MAX_BYTES = Math.max(...Object.values(CHAT_ATTACHMENT_MAX_BYTES));
var CHAT_IMAGE_MIME = ["image/jpeg", "image/png", "image/webp", "image/gif"];
var CHAT_VIDEO_MIME = ["video/mp4", "video/webm", "video/quicktime", "video/3gpp"];
var CHAT_FILE_MIME = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "text/plain",
  "text/csv",
  "application/zip"
];
var CHAT_ATTACHMENT_ACCEPT = [...CHAT_IMAGE_MIME, ...CHAT_VIDEO_MIME, ...CHAT_FILE_MIME].join(
  ","
);
function chatAttachmentKindOf(mimeType) {
  const mime = mimeType.toLowerCase();
  if (CHAT_IMAGE_MIME.includes(mime)) return ChatAttachmentKind.IMAGE;
  if (CHAT_VIDEO_MIME.includes(mime)) return ChatAttachmentKind.VIDEO;
  if (CHAT_FILE_MIME.includes(mime)) return ChatAttachmentKind.FILE;
  return null;
}
var CHAT_ATTACHMENT_LABELS = {
  IMAGE: "Photo",
  VIDEO: "Video",
  FILE: "File"
};
var postChatMessageSchema = z18.object({
  /** May be empty when something is attached; a picture needs no caption. */
  body: z18.string().trim().max(CHAT_BODY_MAX).default(""),
  clientId: clientIdSchema,
  /** Uploads made moments ago through `POST threads/:id/uploads`, in order. */
  attachmentIds: z18.array(uuidSchema).max(CHAT_ATTACHMENTS_PER_MESSAGE).default([]),
  /**
   * Whom the "@Name"s in the body mean, as picked from the member list. The
   * server finds each name in the text; a pick whose name is no longer in
   * the body — the sender deleted it — is simply not a mention.
   */
  mentionIds: z18.array(uuidSchema).max(CHAT_MENTIONS_PER_MESSAGE).default([])
}).refine((dto) => dto.body.length > 0 || dto.attachmentIds.length > 0, {
  message: "Write something or attach something first",
  path: ["body"]
});
var CHAT_REACTIONS = [
  "LIKE",
  "LOVE",
  "HAHA",
  "WOW",
  "SAD",
  "ANGRY"
];
var CHAT_REACTION_EMOJI = {
  LIKE: "\u{1F44D}",
  LOVE: "\u2764\uFE0F",
  HAHA: "\u{1F602}",
  WOW: "\u{1F62E}",
  SAD: "\u{1F622}",
  ANGRY: "\u{1F621}"
};
var CHAT_REACTION_LABELS = {
  LIKE: "Like",
  LOVE: "Love",
  HAHA: "Haha",
  WOW: "Wow",
  SAD: "Sad",
  ANGRY: "Angry"
};
var setChatReactionSchema = z18.object({
  kind: z18.enum(CHAT_REACTIONS)
});
var setChatNameSchema = z18.object({
  nickname: z18.string().trim().max(40, "Keep it under 40 characters").transform((value) => value ? value : null)
});
var editChatMessageSchema = z18.object({
  body: bodySchema,
  /** As on a post. The edit's list replaces the line's mentions outright. */
  mentionIds: z18.array(uuidSchema).max(CHAT_MENTIONS_PER_MESSAGE).default([])
});
var markChatReadSchema = z18.object({
  /** The highest sequence number the reader has seen. */
  seq: z18.number().int().min(0)
});
var chatMessagesQuerySchema = z18.object({
  after: z18.coerce.number().int().min(0).optional(),
  before: z18.coerce.number().int().min(1).optional(),
  changedSince: z18.string().datetime({ offset: true }).optional()
}).refine((query) => !(query.after !== void 0 && query.before !== void 0), {
  message: "Ask for newer or older messages, not both"
});
var CHAT_SEARCH_LIMIT = 50;
var chatSearchQuerySchema = z18.object({
  q: z18.string().trim().min(2, "Type at least two characters").max(100),
  threadId: uuidSchema.optional()
});

// src/dto/leave.ts
import { z as z19 } from "zod";
var statusValues3 = Object.values(LeaveRequestStatus);
var createLeaveRequestSchema = z19.object({
  leaveTypeId: uuidSchema,
  startDate: dateOnlySchema,
  endDate: dateOnlySchema,
  /** Half days only make sense for a single-day request. */
  dayPortion: z19.nativeEnum(DayPortion).default(DayPortion.FULL_DAY),
  reason: z19.string().trim().min(5, "Give a reason of at least 5 characters").max(500)
}).superRefine((data, ctx) => {
  if (data.endDate < data.startDate) {
    ctx.addIssue({
      code: z19.ZodIssueCode.custom,
      path: ["endDate"],
      message: "End date cannot be before the start date"
    });
  }
  if (data.dayPortion !== DayPortion.FULL_DAY && data.startDate !== data.endDate) {
    ctx.addIssue({
      code: z19.ZodIssueCode.custom,
      path: ["dayPortion"],
      message: "A half day applies to a single date only"
    });
  }
});
var reviewLeaveSchema = z19.object({
  action: z19.enum(["APPROVED", "REJECTED"]),
  remarks: optionalString(500)
});
var cancelLeaveSchema = z19.object({
  cancelReason: z19.string().trim().min(5, "Say why this is being cancelled").max(500)
});
var leaveQuerySchema = paginationQuerySchema.extend({
  employeeId: z19.string().uuid().optional(),
  leaveTypeId: z19.string().uuid().optional(),
  status: z19.string().optional(),
  from: z19.string().optional(),
  to: z19.string().optional()
});
var LEAVE_STATUS_LABELS = {
  DRAFT: "Draft",
  PENDING_MANAGER: "Awaiting manager",
  PENDING_HR: "Awaiting HR",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  CANCELLED: "Cancelled"
};
var DAY_PORTION_LABELS = {
  FULL_DAY: "Full day",
  FIRST_HALF: "Morning only",
  SECOND_HALF: "Afternoon only"
};

// src/dto/leave-balance.ts
import { z as z20 } from "zod";
var round2 = (value) => Math.round(value * 100) / 100;
function resolveLeaveBalance(row, defaultDaysPerYear) {
  const base = row ? {
    entitled: Number(row.entitled),
    carriedOver: Number(row.carriedOver),
    used: Number(row.used),
    pending: Number(row.pending)
  } : { entitled: Number(defaultDaysPerYear), carriedOver: 0, used: 0, pending: 0 };
  const available = round2(
    base.entitled + base.carriedOver - base.used - base.pending
  );
  return {
    entitled: round2(base.entitled),
    carriedOver: round2(base.carriedOver),
    used: round2(base.used),
    pending: round2(base.pending),
    // A negative available is arithmetic, not policy. Clamping it here would
    // hide an over-drawn balance from the person whose job is to correct it.
    available,
    materialised: Boolean(row)
  };
}
var daysField = z20.number().min(0, "Days cannot be negative").max(366, "That is more than a year \u2014 check the figure").refine((value) => Math.abs(value * 100 - Math.round(value * 100)) < 1e-6, {
  message: "Days go to at most two decimal places"
});
var setLeaveBalanceSchema = z20.object({
  employeeId: z20.string().uuid(),
  leaveTypeId: z20.string().uuid(),
  year: z20.number().int().min(2e3).max(2100),
  entitled: daysField,
  carriedOver: daysField,
  /**
   * Free text, required. An entitlement that differs from the standing policy
   * is the kind of thing that gets questioned a year later, and "because the
   * previous HR officer typed it" is not an answer anybody can act on.
   */
  reason: z20.string().trim().min(3, "Say why this figure is being set").max(500)
});
var grantLeaveBalancesSchema = z20.object({
  year: z20.number().int().min(2e3).max(2100),
  /**
   * The days to grant per type. Absent types are skipped rather than defaulted,
   * so a grant can never invent an entitlement the operator did not type. The
   * seeded statutory defaults are offered in the UI as the starting figures;
   * company-policy types such as Vacation and Sick Leave ship at zero because
   * no statute sets them, and only KioBytes can say what they are.
   */
  days: z20.array(
    z20.object({
      leaveTypeId: z20.string().uuid(),
      entitled: daysField
    })
  ).min(1, "Choose at least one leave type"),
  /**
   * When false — the default — employees who already have a row for that type
   * and year keep it. A bulk grant is run more than once (new hires, a
   * corrected figure) and it must not silently flatten a hand-set entitlement
   * or, worse, an accrued `used` count.
   */
  overwriteExisting: z20.boolean().default(false),
  /** Restrict to specific employees; empty means every active employee. */
  employeeIds: z20.array(z20.string().uuid()).default([])
});

// src/dto/payroll.ts
import { z as z21 } from "zod";
var createPeriodSchema = z21.object({
  /** Any date inside the intended cut-off; the boundaries are derived. */
  anyDateInPeriod: dateOnlySchema
});
var createRunSchema = z21.object({
  payrollPeriodId: uuidSchema,
  /** Restrict the run to one department. Omit for the whole company. */
  departmentId: uuidSchema.nullish(),
  remarks: optionalString(500)
});
var payrollQuerySchema = paginationQuerySchema.extend({
  status: z21.string().optional(),
  payrollPeriodId: z21.string().uuid().optional()
});
var PAYROLL_RUN_STATUS_LABELS = {
  DRAFT: "Draft",
  CALCULATING: "Calculating",
  CALCULATED: "Calculated",
  FOR_APPROVAL: "For approval",
  APPROVED: "Approved",
  PAID: "Paid",
  CANCELLED: "Cancelled"
};

// src/dto/contribution.ts
import { z as z22 } from "zod";
var typeValues2 = Object.values(ContributionType);
var contributionBracketSchema = z22.object({
  minCompensation: z22.number().nonnegative(),
  maxCompensation: z22.number().positive().nullish(),
  employeeAmount: z22.number().nonnegative().nullish(),
  employerAmount: z22.number().nonnegative().nullish(),
  employeeRate: z22.number().min(0).max(1).nullish(),
  employerRate: z22.number().min(0).max(1).nullish(),
  baseTax: z22.number().nonnegative().nullish(),
  excessRate: z22.number().min(0).max(1).nullish()
}).refine(
  (bracket) => bracket.maxCompensation == null || bracket.maxCompensation >= bracket.minCompensation,
  { path: ["maxCompensation"], message: "Maximum must be at least the minimum" }
);
var importContributionTableSchema = z22.object({
  type: z22.enum(typeValues2),
  name: requiredString(120, "Name"),
  effectiveFrom: dateOnlySchema,
  reference: optionalString(255),
  brackets: z22.array(contributionBracketSchema).min(1, "At least one bracket is required"),
  /** Make this the active table for its type, deactivating the previous one. */
  activate: z22.boolean().default(true)
}).superRefine((data, ctx) => {
  const sorted = [...data.brackets].sort((a, b) => a.minCompensation - b.minCompensation);
  for (let index = 1; index < sorted.length; index += 1) {
    const previous = sorted[index - 1];
    const current = sorted[index];
    if (previous.maxCompensation == null) {
      ctx.addIssue({
        code: z22.ZodIssueCode.custom,
        path: ["brackets"],
        message: "Only the highest bracket may have an open-ended maximum"
      });
      break;
    }
    if (current.minCompensation <= previous.maxCompensation) {
      ctx.addIssue({
        code: z22.ZodIssueCode.custom,
        path: ["brackets"],
        message: `Brackets overlap around ${previous.maxCompensation}`
      });
      break;
    }
  }
  const everyBracketHasValues = data.brackets.every(
    (bracket) => bracket.employeeAmount != null || bracket.employerAmount != null || bracket.employeeRate != null || bracket.employerRate != null || bracket.baseTax != null || bracket.excessRate != null
  );
  if (!everyBracketHasValues) {
    ctx.addIssue({
      code: z22.ZodIssueCode.custom,
      path: ["brackets"],
      message: "Every bracket needs an amount, a rate, or a base tax"
    });
  }
});
var renameContributionTableSchema = z22.object({
  name: requiredString(120, "Name"),
  reference: optionalString(255)
});
var verifyContributionTableSchema = z22.object({
  /** What was checked against: circular number, issue date, or URL. */
  note: requiredString(300, "Reference")
});
var CONTRIBUTION_TYPE_LABELS = {
  SSS: "SSS",
  PHILHEALTH: "PhilHealth",
  PAGIBIG: "Pag-IBIG",
  WITHHOLDING_TAX: "BIR withholding tax"
};
var CONTRIBUTION_COLUMNS = {
  SSS: [
    { key: "minCompensation", label: "Range from" },
    { key: "maxCompensation", label: "Range to", hint: "Blank for the top bracket" },
    { key: "employeeAmount", label: "Employee \u20B1" },
    { key: "employerAmount", label: "Employer \u20B1" }
  ],
  PHILHEALTH: [
    { key: "minCompensation", label: "Salary from" },
    { key: "maxCompensation", label: "Salary to" },
    { key: "employeeRate", label: "Employee rate", hint: "0.025 for 2.5%" },
    { key: "employerRate", label: "Employer rate" },
    { key: "employeeAmount", label: "Employee \u20B1", hint: "For fixed floor/ceiling brackets" },
    { key: "employerAmount", label: "Employer \u20B1" }
  ],
  // Amount columns are not optional decoration here. Pag-IBIG caps at a
  // Maximum Fund Salary, and a cap is a fixed peso amount — a rate on the top
  // bracket keeps climbing with the salary, which is precisely the bug this
  // pair of columns exists to make expressible.
  PAGIBIG: [
    { key: "minCompensation", label: "Salary from" },
    { key: "maxCompensation", label: "Salary to" },
    { key: "employeeRate", label: "Employee rate", hint: "0.02 for 2%" },
    { key: "employerRate", label: "Employer rate" },
    { key: "employeeAmount", label: "Employee \u20B1", hint: "For the capped top bracket" },
    { key: "employerAmount", label: "Employer \u20B1" }
  ],
  WITHHOLDING_TAX: [
    { key: "minCompensation", label: "Income over" },
    { key: "maxCompensation", label: "Up to" },
    { key: "baseTax", label: "Base tax \u20B1" },
    { key: "excessRate", label: "Rate on excess", hint: "0.15 for 15%" }
  ]
};

// src/dto/audit.ts
import { z as z23 } from "zod";
var auditQuerySchema = paginationQuerySchema.extend({
  actorId: z23.string().uuid().optional(),
  action: z23.string().optional(),
  entityType: z23.string().optional(),
  entityId: z23.string().optional(),
  /** Inclusive `YYYY-MM-DD` bounds on `createdAt`. */
  from: z23.string().optional(),
  to: z23.string().optional(),
  search: z23.string().optional()
});
var AUDIT_ACTION_LABELS = {
  CREATE: "Created",
  UPDATE: "Updated",
  DELETE: "Deleted",
  LOGIN: "Signed in",
  LOGOUT: "Signed out",
  LOGIN_FAILED: "Failed sign-in",
  PASSWORD_RESET: "Password reset",
  APPROVE: "Approved",
  REJECT: "Rejected",
  EXPORT: "Exported",
  IMPORT: "Imported",
  PAYROLL_PROCESS: "Payroll processed",
  PERMISSION_CHANGE: "Permissions changed",
  SETTING_CHANGE: "Setting changed"
};

// src/dto/asset.ts
import { z as z24 } from "zod";
var conditionValues = Object.values(AssetCondition);
var statusValues4 = Object.values(AssetStatus);
var createAssetCategorySchema = z24.object({
  code: requiredString(24, "Code").transform((value) => value.toUpperCase()),
  name: upperRequired(120, "Name"),
  description: optionalString(500),
  /** Straight-line horizon; null for non-depreciating items like uniforms. */
  usefulLifeMonths: z24.number().int().min(1).max(600).nullish(),
  isActive: z24.boolean().default(true)
});
var updateAssetCategorySchema = createAssetCategorySchema.partial();
var createAssetSchema = z24.object({
  assetTag: requiredString(48, "Asset tag").transform((value) => value.toUpperCase()),
  categoryId: uuidSchema,
  name: upperRequired(160, "Name"),
  brand: optionalString(80),
  model: optionalString(80),
  serialNumber: optionalString(120),
  description: optionalString(500),
  purchaseDate: optionalDateOnly,
  purchaseCost: moneySchema("Purchase cost").nullish(),
  warrantyUntil: optionalDateOnly,
  condition: z24.enum(conditionValues).default("NEW"),
  location: optionalString(120),
  remarks: optionalString(500)
});
var updateAssetSchema = createAssetSchema.partial();
var assetQuerySchema = paginationQuerySchema.extend({
  categoryId: z24.string().uuid().optional(),
  status: z24.string().optional(),
  condition: z24.string().optional(),
  search: z24.string().optional()
});
var assignAssetSchema = z24.object({
  employeeId: uuidSchema,
  assignedOn: dateOnlySchema,
  conditionOut: z24.enum(conditionValues),
  remarks: optionalString(500)
});
var returnAssetSchema = z24.object({
  returnedOn: dateOnlySchema,
  conditionIn: z24.enum(conditionValues),
  /** LOST and DAMAGED keep the asset off the available pool. */
  outcome: z24.enum(["RETURNED", "DAMAGED", "LOST"]).default("RETURNED"),
  /** Charged to the employee; payroll picks this up as a deduction. */
  accountability: moneySchema("Accountability").nullish(),
  remarks: optionalString(500)
});
var ASSET_STATUS_LABELS = {
  AVAILABLE: "Available",
  ASSIGNED: "Issued",
  IN_REPAIR: "In repair",
  DAMAGED: "Damaged",
  LOST: "Lost",
  RETIRED: "Retired"
};
var ASSET_CONDITION_LABELS = {
  NEW: "New",
  GOOD: "Good",
  FAIR: "Fair",
  POOR: "Poor",
  DAMAGED: "Damaged"
};

// src/dto/announcement.ts
import { z as z25 } from "zod";
var audienceValues = Object.values(AnnouncementAudience);
var statusValues5 = Object.values(AnnouncementStatus);
var roleValues2 = Object.values(Role);
var createAnnouncementSchema = z25.object({
  // Not upper-cased: this is prose people read, and the All-Caps convention
  // applies to reference data, not to a paragraph.
  title: requiredString(200, "Title"),
  body: requiredString(1e4, "Body"),
  audience: z25.enum(audienceValues).default("ALL"),
  departmentId: uuidSchema.nullish(),
  targetRole: z25.enum(roleValues2).nullish(),
  isPinned: z25.boolean().default(false),
  /** ISO timestamp; the announcement drops off the feed after this. */
  expiresAt: z25.string().datetime().nullish()
}).superRefine((data, ctx) => {
  if (data.audience === "DEPARTMENT" && !data.departmentId) {
    ctx.addIssue({
      code: z25.ZodIssueCode.custom,
      path: ["departmentId"],
      message: "Pick the department this is for"
    });
  }
  if (data.audience === "ROLE" && !data.targetRole) {
    ctx.addIssue({
      code: z25.ZodIssueCode.custom,
      path: ["targetRole"],
      message: "Pick the role this is for"
    });
  }
});
var updateAnnouncementSchema = z25.object({
  title: requiredString(200, "Title").optional(),
  body: requiredString(1e4, "Body").optional(),
  audience: z25.enum(audienceValues).optional(),
  departmentId: uuidSchema.nullish(),
  targetRole: z25.enum(roleValues2).nullish(),
  isPinned: z25.boolean().optional(),
  expiresAt: z25.string().datetime().nullish()
});
var announcementQuerySchema = paginationQuerySchema.extend({
  status: z25.enum(statusValues5).optional(),
  search: z25.string().optional()
});
var ANNOUNCEMENT_STATUS_LABELS = {
  DRAFT: "Draft",
  PUBLISHED: "Published",
  ARCHIVED: "Archived"
};
var ANNOUNCEMENT_AUDIENCE_LABELS = {
  ALL: "Everyone",
  DEPARTMENT: "One department",
  ROLE: "One role"
};

// src/dto/employee-history.ts
import { z as z26 } from "zod";
var employeeHistoryQuerySchema = paginationQuerySchema.extend({
  employeeId: z26.string().uuid().optional(),
  departmentId: z26.string().uuid().optional(),
  type: z26.string().optional(),
  /** Inclusive `YYYY-MM-DD` bounds on the effective date. */
  from: z26.string().optional(),
  to: z26.string().optional(),
  search: z26.string().optional()
});
var MOVEMENT_TYPE_LABELS = {
  PROMOTION: "Promotion",
  TRANSFER: "Transfer",
  DEPARTMENT_CHANGE: "Department change",
  POSITION_CHANGE: "Position change",
  SALARY_ADJUSTMENT: "Salary adjustment",
  STATUS_CHANGE: "Status change",
  REGULARIZATION: "Regularisation",
  MANAGER_CHANGE: "Manager change"
};

// src/dto/request.ts
import { z as z27 } from "zod";
var statusValues6 = Object.values(RequestStatus);
var priorityValues = Object.values(RequestPriority);
var createRequestTypeSchema = z27.object({
  code: requiredString(24, "Code").transform((value) => value.toUpperCase()),
  name: upperRequired(120, "Name"),
  description: optionalString(500),
  /** Target turnaround in working days; drives the overdue flag. */
  slaDays: z27.number().int().min(0).max(365).default(3),
  requiresApproval: z27.boolean().default(false),
  fee: moneySchema("Fee").nullish(),
  isActive: z27.boolean().default(true)
});
var updateRequestTypeSchema = createRequestTypeSchema.partial();
var createRequestSchema = z27.object({
  /** Omitted means "for myself" — the server fills it from the caller. */
  employeeId: uuidSchema.optional(),
  requestTypeId: uuidSchema,
  purpose: optionalString(500),
  priority: z27.enum(priorityValues).default("NORMAL")
});
var updateRequestSchema = z27.object({
  purpose: optionalString(500),
  priority: z27.enum(priorityValues).optional(),
  assignedToId: uuidSchema.nullish(),
  dueDate: z27.string().optional(),
  remarks: optionalString(1e3)
});
var transitionRequestSchema = z27.object({
  to: z27.enum(["IN_PROGRESS", "FOR_RELEASE", "COMPLETED", "REJECTED", "CANCELLED"]),
  remarks: optionalString(1e3)
});
var requestQuerySchema = paginationQuerySchema.extend({
  status: z27.enum(statusValues6).optional(),
  requestTypeId: z27.string().uuid().optional(),
  employeeId: z27.string().uuid().optional(),
  assignedToId: z27.string().uuid().optional(),
  /** Past its due date and not yet resolved. */
  overdue: z27.coerce.boolean().optional(),
  search: z27.string().optional()
});
var REQUEST_STATUS_LABELS = {
  SUBMITTED: "Submitted",
  IN_PROGRESS: "In progress",
  FOR_RELEASE: "For release",
  COMPLETED: "Completed",
  REJECTED: "Rejected",
  CANCELLED: "Cancelled"
};
var REQUEST_PRIORITY_LABELS = {
  LOW: "Low",
  NORMAL: "Normal",
  HIGH: "High",
  URGENT: "Urgent"
};
var REQUEST_TRANSITIONS = {
  SUBMITTED: ["IN_PROGRESS", "REJECTED", "CANCELLED"],
  IN_PROGRESS: ["FOR_RELEASE", "COMPLETED", "REJECTED", "CANCELLED"],
  FOR_RELEASE: ["COMPLETED", "CANCELLED"],
  COMPLETED: [],
  REJECTED: [],
  CANCELLED: []
};

// src/dto/disciplinary.ts
import { z as z28 } from "zod";
var severityValues = Object.values(DisciplinarySeverity);
var statusValues7 = Object.values(DisciplinaryStatus);
var actionTypeValues = Object.values(DisciplinaryActionType);
var createCaseSchema = z28.object({
  employeeId: uuidSchema,
  violationType: requiredString(160, "Violation"),
  // Not upper-cased: this is a narrative someone will read back in a hearing.
  description: requiredString(5e3, "Description"),
  incidentDate: dateOnlySchema,
  severity: z28.enum(severityValues)
});
var updateCaseSchema = z28.object({
  violationType: requiredString(160, "Violation").optional(),
  description: requiredString(5e3, "Description").optional(),
  incidentDate: dateOnlySchema.optional(),
  severity: z28.enum(severityValues).optional(),
  resolution: optionalString(5e3)
});
var transitionCaseSchema = z28.object({
  to: z28.enum(statusValues7),
  /** Required when closing — a case cannot be resolved without saying how. */
  resolution: optionalString(5e3)
});
var createActionSchema = z28.object({
  type: z28.enum(actionTypeValues),
  description: requiredString(2e3, "Description"),
  effectiveDate: dateOnlySchema,
  /** Calendar days; only meaningful for a suspension. */
  durationDays: z28.number().int().min(1).max(365).nullish(),
  isUnpaid: z28.boolean().default(false)
}).superRefine((data, ctx) => {
  if (data.type === "SUSPENSION" && !data.durationDays) {
    ctx.addIssue({
      code: z28.ZodIssueCode.custom,
      path: ["durationDays"],
      message: "A suspension needs a length in days"
    });
  }
  if (data.type !== "SUSPENSION" && data.isUnpaid) {
    ctx.addIssue({
      code: z28.ZodIssueCode.custom,
      path: ["isUnpaid"],
      message: "Only a suspension can be unpaid"
    });
  }
});
var caseQuerySchema = paginationQuerySchema.extend({
  employeeId: z28.string().uuid().optional(),
  status: z28.enum(statusValues7).optional(),
  severity: z28.enum(severityValues).optional(),
  search: z28.string().optional()
});
var respondToCaseSchema = z28.object({
  response: z28.string().trim().min(20, "Explain in at least 20 characters").max(4e3, "Keep the explanation under 4000 characters")
});
var DISCIPLINARY_STATUS_LABELS = {
  REPORTED: "Reported",
  UNDER_INVESTIGATION: "Under investigation",
  NOTICE_TO_EXPLAIN: "Notice to explain",
  RESOLVED: "Resolved",
  DISMISSED: "Dismissed",
  APPEALED: "Appealed"
};
var DISCIPLINARY_SEVERITY_LABELS = {
  MINOR: "Minor",
  MAJOR: "Major",
  GRAVE: "Grave"
};
var DISCIPLINARY_ACTION_LABELS = {
  VERBAL_WARNING: "Verbal warning",
  WRITTEN_WARNING: "Written warning",
  FINAL_WARNING: "Final warning",
  SUSPENSION: "Suspension",
  DEMOTION: "Demotion",
  TERMINATION: "Termination"
};
var CASE_TRANSITIONS = {
  REPORTED: ["UNDER_INVESTIGATION", "NOTICE_TO_EXPLAIN", "DISMISSED"],
  UNDER_INVESTIGATION: ["NOTICE_TO_EXPLAIN", "RESOLVED", "DISMISSED"],
  NOTICE_TO_EXPLAIN: ["UNDER_INVESTIGATION", "RESOLVED", "DISMISSED"],
  RESOLVED: ["APPEALED"],
  DISMISSED: ["APPEALED"],
  APPEALED: ["UNDER_INVESTIGATION", "RESOLVED", "DISMISSED"]
};
var CLOSING_STATUSES = ["RESOLVED", "DISMISSED"];

// src/dto/award.ts
import { z as z29 } from "zod";
var categoryValues = Object.values(AwardCategory);
var createAwardTypeSchema = z29.object({
  code: requiredString(24, "Code").transform((value) => value.toUpperCase()),
  name: upperRequired(120, "Name"),
  category: z29.enum(categoryValues),
  description: optionalString(500),
  cashValue: moneySchema("Cash value").nullish(),
  isActive: z29.boolean().default(true)
});
var updateAwardTypeSchema = createAwardTypeSchema.partial();
var grantAwardSchema = z29.object({
  employeeId: uuidSchema,
  awardTypeId: uuidSchema,
  /**
   * Period the award covers, e.g. `2026-07` for Employee of the Month.
   *
   * Empty for a one-off. Not nullable: the uniqueness rule is on
   * (type, employee, period), and a null would let the same service award be
   * granted to the same person twice.
   */
  periodLabel: z29.string().trim().max(32).default(""),
  awardedOn: dateOnlySchema,
  citation: optionalString(2e3)
});
var awardQuerySchema = paginationQuerySchema.extend({
  employeeId: z29.string().uuid().optional(),
  awardTypeId: z29.string().uuid().optional(),
  category: z29.string().optional(),
  year: z29.coerce.number().int().min(1970).max(2200).optional(),
  search: z29.string().optional()
});
var AWARD_CATEGORY_LABELS = {
  EMPLOYEE_OF_THE_MONTH: "Employee of the month",
  RECOGNITION: "Recognition",
  SERVICE_AWARD: "Service award",
  PERFORMANCE: "Performance",
  SAFETY: "Safety",
  OTHER: "Other"
};

// src/dto/document.ts
import { z as z30 } from "zod";
var visibilityValues = Object.values(DocumentVisibility);
var createDocumentCategorySchema = z30.object({
  code: requiredString(24, "Code").transform((value) => value.toUpperCase()),
  name: upperRequired(120, "Name"),
  description: optionalString(500),
  /** Every employee is expected to have one; drives the missing-documents view. */
  isRequired: z30.boolean().default(false),
  isActive: z30.boolean().default(true)
});
var uploadDocumentSchema = z30.object({
  title: requiredString(200, "Title"),
  description: optionalString(1e3),
  categoryId: uuidSchema.optional(),
  /** Absent means a company-wide document rather than a personnel file entry. */
  employeeId: uuidSchema.optional(),
  visibility: z30.enum(visibilityValues).default("HR_ONLY"),
  /** `YYYY-MM-DD`; for documents that lapse, such as a licence or a contract. */
  expiresAt: z30.string().optional()
});
var updateDocumentSchema = z30.object({
  title: requiredString(200, "Title").optional(),
  description: optionalString(1e3),
  categoryId: uuidSchema.nullish(),
  visibility: z30.enum(visibilityValues).optional(),
  expiresAt: z30.string().nullish()
});
var documentQuerySchema = paginationQuerySchema.extend({
  employeeId: z30.string().uuid().optional(),
  categoryId: z30.string().uuid().optional(),
  visibility: z30.string().optional(),
  /** Only documents that have lapsed or lapse within 30 days. */
  expiring: z30.coerce.boolean().optional(),
  search: z30.string().optional()
});
var DOCUMENT_VISIBILITY_LABELS = {
  PRIVATE: "Uploader only",
  HR_ONLY: "HR only",
  MANAGER: "HR and the manager",
  EMPLOYEE: "HR and the employee",
  PUBLIC: "Everyone"
};
function formatBytes(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

// src/dto/resignation.ts
import { z as z31 } from "zod";
var statusValues8 = Object.values(ResignationStatus);
var clearanceValues = Object.values(ClearanceStatus);
var submitResignationSchema = z31.object({
  /** Omitted means "my own" — the server fills it from the caller. */
  employeeId: uuidSchema.optional(),
  noticeDate: dateOnlySchema,
  lastWorkingDay: dateOnlySchema,
  reason: requiredString(200, "Reason"),
  detailedReason: optionalString(5e3)
}).refine((data) => data.lastWorkingDay >= data.noticeDate, {
  path: ["lastWorkingDay"],
  message: "The last working day cannot precede the notice date"
});
var updateResignationSchema = z31.object({
  lastWorkingDay: dateOnlySchema.optional(),
  isRehireable: z31.boolean().optional(),
  remarks: optionalString(2e3)
});
var transitionResignationSchema = z31.object({
  to: z31.enum(["ACKNOWLEDGED", "APPROVED", "REJECTED", "WITHDRAWN", "COMPLETED"]),
  remarks: optionalString(2e3)
});
var createClearanceItemSchema = z31.object({
  departmentName: requiredString(80, "Department"),
  description: requiredString(500, "Description")
});
var updateClearanceItemSchema = z31.object({
  status: z31.enum(clearanceValues),
  /** Owed by the employee; carried into the final pay computation. */
  accountability: moneySchema("Accountability").nullish(),
  remarks: optionalString(1e3)
});
var resignationQuerySchema = paginationQuerySchema.extend({
  status: z31.enum(statusValues8).optional(),
  search: z31.string().optional()
});
var computeFinalPaySchema = z31.object({
  /** Unpaid salary for days already worked in the final period. */
  lastSalary: moneySchema("Last salary").default(0),
  /** Leave days the company converts to cash. */
  convertibleLeaveDays: z31.number().min(0).max(365).default(0),
  /**
   * Zero unless an authorised cause or policy applies — voluntary resignation
   * carries none, so this is never defaulted to anything else.
   */
  separationPay: moneySchema("Separation pay").default(0),
  otherEarnings: moneySchema("Other earnings").default(0),
  /** Signed: negative refunds over-withheld tax. */
  taxAdjustment: z31.number().min(-9999999).max(9999999).default(0),
  remarks: optionalString(2e3)
});
var transitionFinalPaySchema = z31.object({
  to: z31.enum(["APPROVED", "RELEASED"])
});
var FINAL_PAY_STATUS_LABELS = {
  PENDING: "Pending",
  COMPUTED: "Computed",
  APPROVED: "Approved",
  RELEASED: "Released"
};
var FINAL_PAY_TRANSITIONS = {
  PENDING: [],
  COMPUTED: ["APPROVED"],
  APPROVED: ["RELEASED"],
  RELEASED: []
};
var RESIGNATION_STATUS_LABELS = {
  SUBMITTED: "Submitted",
  ACKNOWLEDGED: "Acknowledged",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  WITHDRAWN: "Withdrawn",
  COMPLETED: "Completed"
};
var CLEARANCE_STATUS_LABELS = {
  PENDING: "Pending",
  CLEARED: "Cleared",
  WITH_ACCOUNTABILITY: "With accountability",
  WAIVED: "Waived"
};
var RESIGNATION_TRANSITIONS = {
  SUBMITTED: ["ACKNOWLEDGED", "REJECTED", "WITHDRAWN"],
  ACKNOWLEDGED: ["APPROVED", "REJECTED", "WITHDRAWN"],
  APPROVED: ["COMPLETED", "WITHDRAWN"],
  REJECTED: [],
  WITHDRAWN: [],
  COMPLETED: []
};
var OUTSTANDING_CLEARANCE = ["PENDING"];
var MINIMUM_NOTICE_DAYS = 30;

// src/dto/insurance.ts
import { z as z32 } from "zod";
var typeValues3 = Object.values(InsurancePolicyType);
var statusValues9 = Object.values(CoverageStatus);
var createProviderSchema = z32.object({
  code: requiredString(24, "Code").transform((value) => value.toUpperCase()),
  name: upperRequired(160, "Name"),
  contactPerson: optionalString(120),
  contactNumber: optionalString(40),
  email: optionalString(160),
  address: optionalString(400),
  website: optionalString(200),
  isActive: z32.boolean().default(true)
});
var createPolicySchema = z32.object({
  providerId: uuidSchema,
  code: requiredString(32, "Code").transform((value) => value.toUpperCase()),
  name: upperRequired(160, "Name"),
  type: z32.enum(typeValues3),
  description: optionalString(1e3),
  coverageAmount: moneySchema("Coverage amount"),
  premiumAmount: moneySchema("Premium"),
  employeeShare: moneySchema("Employee share").default(0),
  employerShare: moneySchema("Employer share").default(0),
  allowsDependents: z32.boolean().default(false),
  isActive: z32.boolean().default(true)
}).refine(
  (data) => Math.abs(data.employeeShare + data.employerShare - data.premiumAmount) < 0.01,
  {
    path: ["employerShare"],
    // A split that does not reconcile means somebody is paying an amount the
    // record does not account for — usually the company, silently.
    message: "The employee and employer shares must add up to the premium"
  }
);
var updateProviderSchema = createProviderSchema.omit({ code: true }).partial();
var updatePolicySchema = z32.object({
  name: upperRequired(160, "Name").optional(),
  description: optionalString(1e3),
  coverageAmount: moneySchema("Coverage amount").optional(),
  premiumAmount: moneySchema("Premium").optional(),
  employeeShare: moneySchema("Employee share").optional(),
  employerShare: moneySchema("Employer share").optional(),
  allowsDependents: z32.boolean().optional(),
  isActive: z32.boolean().optional()
});
var beneficiarySchema = z32.object({
  id: uuidSchema.optional(),
  name: upperRequired(160, "Name"),
  relationship: upperRequired(60, "Relationship"),
  birthDate: optionalDateOnly,
  contactNumber: optionalString(40),
  /** Where the insurer reaches them at a claim. */
  address: optionalString(255),
  percentage: z32.number().min(0).max(100),
  isPrimary: z32.boolean().default(true)
});
var enrolSchema = z32.object({
  employeeId: uuidSchema,
  policyId: uuidSchema,
  memberNumber: optionalString(64),
  effectiveDate: dateOnlySchema,
  expiryDate: optionalDateOnly,
  remarks: optionalString(500),
  /** Must total exactly 100%; the server re-checks. */
  beneficiaries: z32.array(beneficiarySchema).default([])
});
var updateCoverageSchema = z32.object({
  memberNumber: optionalString(64),
  status: z32.enum(statusValues9).optional(),
  expiryDate: optionalDateOnly,
  remarks: optionalString(500),
  beneficiaries: z32.array(beneficiarySchema).optional()
});
var coverageQuerySchema = paginationQuerySchema.extend({
  employeeId: z32.string().uuid().optional(),
  policyId: z32.string().uuid().optional(),
  status: z32.enum(statusValues9).optional(),
  type: z32.string().optional(),
  /** Lapsed, or lapsing within 60 days. */
  expiring: z32.coerce.boolean().optional(),
  search: z32.string().optional()
});
var POLICY_TYPE_LABELS = {
  HMO: "HMO",
  LIFE: "Life",
  ACCIDENT: "Accident",
  CRITICAL_ILLNESS: "Critical illness",
  DENTAL: "Dental",
  OTHER: "Other"
};
var COVERAGE_STATUS_LABELS = {
  PENDING: "Pending",
  ACTIVE: "Active",
  EXPIRED: "Expired",
  CANCELLED: "Cancelled",
  SUSPENDED: "Suspended"
};

// src/dto/pay-component.ts
import { z as z33 } from "zod";
var PAY_COMPONENT_BASIS = Object.values(PayComponentBasis);
var PAY_COMPONENT_BASIS_LABELS = {
  MONTHLY: "Per month",
  PER_RUN: "Per payroll run"
};
var createAllowanceTypeSchema = z33.object({
  code: requiredString(24, "Code").transform((value) => value.toUpperCase()),
  name: upperRequired(120, "Name"),
  description: optionalString(500),
  /** De minimis benefits are not taxed; ordinary allowances are. */
  isTaxable: z33.boolean().default(true),
  /** Only some allowances enter the SSS/PhilHealth/Pag-IBIG base. */
  isContributionBase: z33.boolean().default(false),
  /**
   * Earned by turning up: an absent day loses its share.
   *
   * True by default, because that is the rule for every allowance here. Untick
   * it only for something genuinely paid regardless of attendance.
   */
  isAttendanceBased: z33.boolean().default(true),
  defaultAmount: moneySchema("Default amount").nullish(),
  defaultBasis: z33.enum(PAY_COMPONENT_BASIS).default("MONTHLY"),
  isActive: z33.boolean().default(true)
});
var updateAllowanceTypeSchema = createAllowanceTypeSchema.omit({ code: true }).partial();
var createDeductionTypeSchema = z33.object({
  code: requiredString(24, "Code").transform((value) => value.toUpperCase()),
  name: upperRequired(120, "Name"),
  description: optionalString(500),
  isRecurring: z33.boolean().default(true),
  defaultBasis: z33.enum(PAY_COMPONENT_BASIS).default("MONTHLY"),
  isActive: z33.boolean().default(true)
});
var updateDeductionTypeSchema = createDeductionTypeSchema.omit({ code: true }).partial();
var assignmentBase = {
  amount: moneySchema("Amount"),
  basis: z33.enum(PAY_COMPONENT_BASIS),
  effectiveFrom: dateOnlySchema,
  effectiveTo: optionalDateOnly
};
var assignAllowanceSchema = z33.object({ allowanceTypeId: uuidSchema, ...assignmentBase }).refine((data) => !data.effectiveTo || data.effectiveTo >= data.effectiveFrom, {
  path: ["effectiveTo"],
  message: "The end date cannot precede the start date"
});
var assignDeductionSchema = z33.object({
  deductionTypeId: uuidSchema,
  ...assignmentBase,
  /** For an amortised loan: the original principal. */
  totalAmount: moneySchema("Total amount").nullish(),
  remarks: optionalString(500)
}).refine((data) => !data.effectiveTo || data.effectiveTo >= data.effectiveFrom, {
  path: ["effectiveTo"],
  message: "The end date cannot precede the start date"
});
var updateAssignmentSchema = z33.object({
  amount: moneySchema("Amount").optional(),
  basis: z33.enum(PAY_COMPONENT_BASIS).optional(),
  effectiveTo: optionalDateOnly,
  isActive: z33.boolean().optional(),
  remarks: optionalString(500)
});
var assignmentQuerySchema = paginationQuerySchema.extend({
  includeInactive: z33.coerce.boolean().optional()
});

// src/dto/training.ts
import { z as z34 } from "zod";
var typeValues4 = Object.values(TrainingType);
var sessionStatusValues = Object.values(TrainingSessionStatus);
var enrollmentStatusValues = Object.values(EnrollmentStatus);
var createProgramSchema = z34.object({
  code: requiredString(24, "Code").transform((value) => value.toUpperCase()),
  title: upperRequired(200, "Title"),
  description: optionalString(2e3),
  type: z34.enum(typeValues4),
  providerName: optionalString(160),
  /** Credited hours on completion — feeds compliance reporting. */
  hours: z34.number().min(0).max(9999).default(0),
  costPerHead: moneySchema("Cost per head").nullish(),
  isMandatory: z34.boolean().default(false),
  isActive: z34.boolean().default(true)
});
var updateProgramSchema = createProgramSchema.omit({ code: true }).partial();
var createSessionSchema = z34.object({
  programId: uuidSchema,
  /** ISO timestamps — a session is a time of day, not just a date. */
  startDate: z34.string().datetime(),
  endDate: z34.string().datetime(),
  venue: optionalString(200),
  trainerName: optionalString(160),
  capacity: z34.number().int().min(1).max(1e4).nullish(),
  remarks: optionalString(1e3)
}).refine((data) => new Date(data.endDate) > new Date(data.startDate), {
  path: ["endDate"],
  message: "The session must end after it starts"
});
var updateSessionSchema = z34.object({
  startDate: z34.string().datetime().optional(),
  endDate: z34.string().datetime().optional(),
  venue: optionalString(200),
  trainerName: optionalString(160),
  capacity: z34.number().int().min(1).max(1e4).nullish(),
  status: z34.enum(sessionStatusValues).optional(),
  remarks: optionalString(1e3)
});
var sessionQuerySchema = paginationQuerySchema.extend({
  programId: z34.string().uuid().optional(),
  status: z34.enum(sessionStatusValues).optional(),
  type: z34.string().optional(),
  /** Only sessions that have not finished. */
  upcoming: z34.coerce.boolean().optional(),
  search: z34.string().optional()
});
var enrolEmployeesSchema = z34.object({
  /** Enrolling a group at once is the normal case for a scheduled session. */
  employeeIds: z34.array(uuidSchema).min(1, "Pick at least one employee")
});
var updateEnrollmentSchema = z34.object({
  status: z34.enum(enrollmentStatusValues),
  /** 0–100; only meaningful once attended. */
  score: z34.number().min(0).max(100).nullish(),
  feedback: optionalString(2e3)
});
var TRAINING_TYPE_LABELS = {
  TRAINING: "Training",
  SEMINAR: "Seminar",
  WORKSHOP: "Workshop",
  CERTIFICATION: "Certification",
  ONBOARDING: "Onboarding",
  COMPLIANCE: "Compliance"
};
var SESSION_STATUS_LABELS = {
  SCHEDULED: "Scheduled",
  ONGOING: "Ongoing",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled"
};
var ENROLLMENT_STATUS_LABELS = {
  ENROLLED: "Enrolled",
  ATTENDED: "Attended",
  COMPLETED: "Completed",
  FAILED: "Failed",
  NO_SHOW: "No show",
  CANCELLED: "Cancelled"
};
var ATTENDED_STATUSES = ["ATTENDED", "COMPLETED", "FAILED"];

// src/dto/performance.ts
import { z as z35 } from "zod";
var cycleStatusValues = Object.values(ReviewCycleStatus);
var reviewStatusValues = Object.values(ReviewStatus);
var goalStatusValues = Object.values(GoalStatus);
var createKpiSchema = z35.object({
  code: requiredString(24, "Code").transform((value) => value.toUpperCase()),
  name: upperRequired(160, "Name"),
  description: optionalString(1e3),
  /** Null applies the KPI company-wide. */
  departmentId: uuidSchema.nullish(),
  weight: z35.number().min(0).max(100),
  maxRating: z35.number().int().min(1).max(10).default(5),
  isActive: z35.boolean().default(true)
});
var updateKpiSchema = createKpiSchema.omit({ code: true }).partial();
var createCycleSchema = z35.object({
  name: upperRequired(160, "Name"),
  periodStart: dateOnlySchema,
  periodEnd: dateOnlySchema,
  dueDate: optionalDateOnly,
  description: optionalString(1e3)
}).refine((data) => data.periodEnd >= data.periodStart, {
  path: ["periodEnd"],
  message: "The period must end on or after it starts"
});
var transitionCycleSchema = z35.object({
  to: z35.enum(cycleStatusValues)
});
var updateCycleSchema = z35.object({
  name: upperRequired(160, "Name").optional(),
  periodStart: dateOnlySchema.optional(),
  periodEnd: dateOnlySchema.optional(),
  dueDate: optionalDateOnly,
  description: optionalString(1e3)
});
var openReviewsSchema = z35.object({
  employeeIds: z35.array(uuidSchema).min(1, "Pick at least one employee")
});
var scoreSchema = z35.object({
  kpiId: uuidSchema,
  selfRating: z35.number().min(0).max(10).nullish(),
  managerRating: z35.number().min(0).max(10).nullish(),
  comments: optionalString(2e3)
});
var saveReviewSchema = z35.object({
  scores: z35.array(scoreSchema).default([]),
  selfComments: optionalString(4e3),
  managerComments: optionalString(4e3)
});
var transitionReviewSchema = z35.object({
  to: z35.enum(reviewStatusValues)
});
var reviewQuerySchema = paginationQuerySchema.extend({
  reviewCycleId: z35.string().uuid().optional(),
  employeeId: z35.string().uuid().optional(),
  status: z35.enum(reviewStatusValues).optional(),
  search: z35.string().optional()
});
var createGoalSchema = z35.object({
  employeeId: uuidSchema.optional(),
  title: requiredString(200, "Title"),
  description: optionalString(2e3),
  targetDate: optionalDateOnly
});
var updateGoalSchema = z35.object({
  title: requiredString(200, "Title").optional(),
  description: optionalString(2e3),
  targetDate: optionalDateOnly,
  status: z35.enum(goalStatusValues).optional(),
  progress: z35.number().int().min(0).max(100).optional()
});
var CYCLE_STATUS_LABELS = {
  DRAFT: "Draft",
  OPEN: "Open",
  IN_REVIEW: "In review",
  CALIBRATION: "Calibration",
  CLOSED: "Closed"
};
var REVIEW_STATUS_LABELS = {
  NOT_STARTED: "Not started",
  SELF_ASSESSMENT: "Self-assessment",
  MANAGER_REVIEW: "Manager review",
  ACKNOWLEDGEMENT: "Awaiting acknowledgement",
  COMPLETED: "Completed"
};
var GOAL_STATUS_LABELS = {
  NOT_STARTED: "Not started",
  IN_PROGRESS: "In progress",
  COMPLETED: "Completed",
  DEFERRED: "Deferred",
  CANCELLED: "Cancelled"
};
var CYCLE_TRANSITIONS = {
  DRAFT: ["OPEN"],
  OPEN: ["IN_REVIEW", "CLOSED"],
  IN_REVIEW: ["CALIBRATION", "CLOSED"],
  CALIBRATION: ["CLOSED"],
  CLOSED: []
};
var REVIEW_TRANSITIONS = {
  NOT_STARTED: ["SELF_ASSESSMENT"],
  SELF_ASSESSMENT: ["MANAGER_REVIEW"],
  MANAGER_REVIEW: ["ACKNOWLEDGEMENT"],
  ACKNOWLEDGEMENT: ["COMPLETED"],
  COMPLETED: []
};

// src/dto/analytics.ts
import { z as z36 } from "zod";
var analyticsQuerySchema = z36.object({
  /** How many months of history to return. */
  months: z36.coerce.number().int().min(1).max(36).default(12)
});

// src/dto/finance-reference.ts
import { z as z37 } from "zod";
var codeSchema = z37.string().trim().min(2).max(32).regex(/^[A-Z0-9_]+$/, "Use capitals, digits and underscores \u2014 this is a stable key, not a label");
var createExpenseCategorySchema = z37.object({
  code: codeSchema,
  name: requiredString(80, "Name"),
  hint: optionalString(200),
  /** Reveals the vehicle, odometer and destination fields on the request form. */
  isVehicleRelated: z37.boolean().default(false),
  requiresReceipt: z37.boolean().default(true),
  sortOrder: z37.number().int().min(0).max(9999).default(0)
});
var updateExpenseCategorySchema = createExpenseCategorySchema.omit({ code: true }).extend({ isActive: z37.boolean() }).partial();
var fuelTypes = Object.values(FuelType);
var vehicleStatuses = Object.values(VehicleStatus);
var createVehicleSchema = z37.object({
  /**
   * The asset this vehicle already is, when it is tracked as equipment too.
   *
   * Optional: a vehicle nobody has issued to anybody is ordinary. When given,
   * the name, brand and model are taken from the asset rather than retyped.
   */
  assetId: uuidSchema.nullish(),
  plateNumber: requiredString(20, "Plate number"),
  name: requiredString(80, "Name"),
  make: optionalString(40),
  model: optionalString(40),
  year: z37.number().int().min(1950).max(2100).nullish(),
  fuelType: z37.enum(fuelTypes).default(FuelType.GASOLINE),
  departmentId: uuidSchema.nullish(),
  /** Where the odometer stands now, so later readings can be sanity-checked. */
  lastOdometer: z37.number().int().min(0).max(9999999).nullish(),
  /** OR/CR number, as printed on the registration papers. */
  registrationNo: optionalString(40),
  /**
   * When registration lapses.
   *
   * A calendar date, never an instant — `dateOnlySchema` refuses an ISO
   * timestamp for exactly this reason, since parsing one would shift the day
   * by the reader's offset.
   */
  registrationExpiresOn: dateOnlySchema.nullish(),
  /**
   * Kilometres between preventive maintenance services.
   *
   * Floored at 100 rather than 0: an interval of a handful of kilometres is
   * always a typo, and accepting it would report the whole fleet overdue.
   */
  pmsIntervalKm: z37.number().int().min(100).max(1e5).nullish(),
  /** Odometer at the last service; the next falls due this plus the interval. */
  lastServiceOdometerKm: z37.number().int().min(0).max(9999999).nullish(),
  lastServiceOn: dateOnlySchema.nullish(),
  remarks: optionalString(300)
});
var updateVehicleSchema = createVehicleSchema.partial().extend({ status: z37.enum(vehicleStatuses).optional() });
var FUEL_TYPE_LABELS = {
  GASOLINE: "Gasoline",
  DIESEL: "Diesel",
  ELECTRIC: "Electric",
  HYBRID: "Hybrid"
};
var VEHICLE_STATUS_LABELS = {
  ACTIVE: "Active",
  IN_SERVICE: "In service",
  RETIRED: "Retired"
};
function odometerProblem(previous, next) {
  if (!Number.isInteger(next) || next < 0) return "Give the reading in whole kilometres";
  if (previous === null) return null;
  if (next < previous) {
    return `The last reading was ${previous.toLocaleString()} km \u2014 an odometer does not go backwards`;
  }
  if (next - previous > 1e6) {
    return `That is ${(next - previous).toLocaleString()} km since the last reading \u2014 check the digits`;
  }
  return null;
}

// src/dto/vehicle-registration.ts
var REGISTRATION_DUE_SOON_DAYS = 30;
var DAY_MS = 864e5;
function daysBetween(from, to) {
  const a = Date.UTC(
    Number(from.slice(0, 4)),
    Number(from.slice(5, 7)) - 1,
    Number(from.slice(8, 10))
  );
  const b = Date.UTC(Number(to.slice(0, 4)), Number(to.slice(5, 7)) - 1, Number(to.slice(8, 10)));
  return Math.round((b - a) / DAY_MS);
}
function registrationStatus(expiresOn, today) {
  if (!expiresOn) return { state: "UNKNOWN", daysRemaining: null };
  const daysRemaining = daysBetween(today, expiresOn);
  if (daysRemaining < 0) return { state: "EXPIRED", daysRemaining };
  if (daysRemaining <= REGISTRATION_DUE_SOON_DAYS) return { state: "DUE_SOON", daysRemaining };
  return { state: "VALID", daysRemaining };
}
var REGISTRATION_STATE_LABELS = {
  UNKNOWN: "No expiry on file",
  VALID: "Registered",
  DUE_SOON: "Renewal due",
  EXPIRED: "Expired"
};
function registrationSummary(status) {
  if (status.state === "UNKNOWN" || status.daysRemaining === null) {
    return "No expiry recorded";
  }
  if (status.state === "EXPIRED") {
    const overdue = Math.abs(status.daysRemaining);
    return overdue === 1 ? "Expired yesterday" : `Expired ${overdue} days ago`;
  }
  if (status.daysRemaining === 0) return "Expires today";
  if (status.daysRemaining === 1) return "Expires tomorrow";
  return `Expires in ${status.daysRemaining} days`;
}
function registrationSortKey(status) {
  if (status.state === "UNKNOWN" || status.daysRemaining === null) return Number.MAX_SAFE_INTEGER;
  return status.daysRemaining;
}

// src/dto/vehicle-service.ts
var SERVICE_DUE_SOON_KM = 500;
function serviceStatus(input) {
  const { intervalKm, lastServiceOdometerKm, currentOdometerKm } = input;
  if (intervalKm == null || intervalKm <= 0) {
    return { state: "UNKNOWN", kmRemaining: null, dueAtKm: null };
  }
  if (lastServiceOdometerKm == null) {
    return { state: "UNKNOWN", kmRemaining: null, dueAtKm: null };
  }
  const dueAtKm = lastServiceOdometerKm + intervalKm;
  if (currentOdometerKm == null) {
    return { state: "UNKNOWN", kmRemaining: null, dueAtKm };
  }
  const kmRemaining = dueAtKm - currentOdometerKm;
  if (kmRemaining < 0) return { state: "OVERDUE", kmRemaining, dueAtKm };
  if (kmRemaining <= SERVICE_DUE_SOON_KM) return { state: "DUE_SOON", kmRemaining, dueAtKm };
  return { state: "OK", kmRemaining, dueAtKm };
}
var SERVICE_STATE_LABELS = {
  UNKNOWN: "No schedule set",
  OK: "Serviced",
  DUE_SOON: "Service due",
  OVERDUE: "Overdue"
};

// src/dto/payroll-period-gate.ts
function payrollPeriodGate(periodEnd, today) {
  if (periodEnd < today) return { runnable: true, reason: null, endsToday: false };
  if (periodEnd === today) return { runnable: true, reason: null, endsToday: true };
  return {
    runnable: false,
    endsToday: false,
    reason: `This period runs to ${periodEnd}, which has not happened yet. Nobody has clocked into those days, so they carry no attendance at all and everyone would be short the days still to come. Run it on the cut-off day or after it.`
  };
}
var CUTOFF_DAY_NOTICE = "This period ends today. Anyone still clocked in is paid a whole day, as intended \u2014 but overtime for today comes from the clock-out, which has not happened, so no overtime is credited for the cut-off day itself.";

// src/dto/fund-request.ts
import { z as z38 } from "zod";
var moneySchema2 = z38.number().positive("Ask for more than zero").max(9999999999e-2).refine((value) => Math.abs(value * 100 - Math.round(value * 100)) < 1e-6, {
  message: "Amounts are to the centavo"
});
var createFundRequestSchema = z38.object({
  categoryId: uuidSchema,
  purpose: requiredString(200, "Purpose"),
  description: optionalString(1e3),
  amount: moneySchema2,
  neededBy: dateOnlySchema,
  /** Only meaningful for a vehicle-related category; the API enforces that. */
  vehicleId: uuidSchema.nullish(),
  odometerReading: z38.number().int().min(0).max(9999999).nullish(),
  destination: optionalString(200)
}).refine((data) => !data.odometerReading || data.vehicleId, {
  path: ["vehicleId"],
  message: "Say which vehicle the reading is from"
});
var updateFundRequestSchema = createFundRequestSchema;
var decideFundRequestSchema = z38.object({
  approved: z38.boolean(),
  /** Required on a refusal: "no" without a reason is not a decision anyone can act on. */
  remarks: optionalString(500)
});
var FUND_REQUEST_STATUS_LABELS = {
  DRAFT: "Draft",
  SUBMITTED: "Submitted",
  MANAGER_REVIEW: "With the manager",
  HR_REVIEW: "With HR",
  MANAGEMENT_REVIEW: "With management",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  FOR_RELEASE: "For release",
  RELEASED: "Released",
  PARTIALLY_LIQUIDATED: "Partly liquidated",
  FULLY_LIQUIDATED: "Liquidated",
  FUND_RETURN_REQUIRED: "Return due",
  REIMBURSEMENT_REQUIRED: "Reimbursement due",
  CLOSED: "Closed",
  CANCELLED: "Cancelled"
};
function statusForProgress(progress) {
  if (progress.kind === "APPROVED") return FundRequestStatus.FOR_RELEASE;
  if (progress.kind === "REJECTED") return FundRequestStatus.REJECTED;
  if (progress.kind === "AWAITING") {
    const level = progress.level;
    if (level === "MANAGER") return FundRequestStatus.MANAGER_REVIEW;
    if (level === "HR") return FundRequestStatus.HR_REVIEW;
    if (level === "MANAGEMENT") return FundRequestStatus.MANAGEMENT_REVIEW;
  }
  return FundRequestStatus.SUBMITTED;
}
function fundRequestNo(year, sequence) {
  return `FR-${year}-${String(sequence).padStart(6, "0")}`;
}

// src/dto/fund-release.ts
import { z as z39 } from "zod";
var FUND_RELEASE_METHODS = [
  "CASH",
  "BANK_TRANSFER",
  "GCASH",
  "CHECK"
];
var FUND_RELEASE_METHOD_LABELS = {
  CASH: "Cash",
  BANK_TRANSFER: "Bank transfer",
  GCASH: "GCash",
  CHECK: "Check"
};
function releaseRequiresReference(method) {
  return method !== "CASH";
}
var releaseAmountSchema = z39.number().positive("Release more than zero").max(9999999999e-2).refine((value) => Math.abs(value * 100 - Math.round(value * 100)) < 1e-6, {
  message: "Amounts are to the centavo"
});
var createFundReleaseSchema = z39.object({
  amount: releaseAmountSchema,
  method: z39.enum(FUND_RELEASE_METHODS),
  referenceNo: optionalString(100),
  remarks: optionalString(500),
  /**
   * When the holder must account for the money. Optional because the
   * liquidation phase does not exist yet — stamping a date the system cannot
   * chase would be a promise nothing keeps. It is stored when given so the
   * ledger has it the day liquidation lands.
   */
  liquidationDueOn: dateOnlySchema.nullish()
}).refine((data) => !releaseRequiresReference(data.method) || Boolean(data.referenceNo?.trim()), {
  path: ["referenceNo"],
  message: "A non-cash release needs its reference number"
}).refine((data) => releaseRequiresReference(data.method) || !data.referenceNo?.trim(), {
  path: ["referenceNo"],
  message: "Cash has no reference number \u2014 record the detail in remarks instead"
});
var acknowledgeFundReleaseSchema = z39.object({
  /** Optional: "received, ₱200 short" is worth capturing, silence is fine too. */
  note: optionalString(500)
});
var round22 = (value) => Math.round(value * 100) / 100;
function fundAccountability(input) {
  const released = round22(input.released);
  const liquidated = round22(input.liquidated);
  const returned = round22(input.returned);
  const returnsReceived = round22(input.returnsReceived ?? 0);
  const reimbursementsPaid = round22(input.reimbursementsPaid ?? 0);
  const outstanding = round22(
    released - liquidated - returned - returnsReceived + reimbursementsPaid
  );
  return {
    released,
    liquidated,
    returned,
    returnsReceived,
    reimbursementsPaid,
    outstanding,
    state: outstanding === 0 ? "SETTLED" : outstanding > 0 ? "OUTSTANDING" : "REIMBURSEMENT_DUE"
  };
}

// src/dto/liquidation.ts
import { z as z40 } from "zod";
var LIQUIDATION_STATUS_LABELS = {
  DRAFT: "Draft",
  SUBMITTED: "Awaiting verification",
  VERIFIED: "Verified",
  REJECTED: "Sent back"
};
var spentAmountSchema = z40.number().positive("An expense line must be more than zero").max(9999999999e-2).refine((value) => Math.abs(value * 100 - Math.round(value * 100)) < 1e-6, {
  message: "Amounts are to the centavo"
});
var returnedAmountSchema = z40.number().nonnegative("Cash returned cannot be negative").max(9999999999e-2).refine((value) => Math.abs(value * 100 - Math.round(value * 100)) < 1e-6, {
  message: "Amounts are to the centavo"
});
var liquidationLineSchema = z40.object({
  categoryId: uuidSchema,
  description: requiredString(200, "What it was for"),
  amount: spentAmountSchema,
  spentOn: dateOnlySchema,
  /**
   * The OR number or receipt reference. Optional because sundry spending —
   * a jeepney fare, a parking attendant — genuinely has no receipt, and
   * forcing a number produces invented ones rather than honest records.
   */
  receiptNo: optionalString(100)
});
var saveLiquidationSchema = z40.object({
  /**
   * The whole set, every time. A liquidation is edited as a unit — send the
   * lines you want it to have, and the server replaces what is there. Patching
   * individual lines would need line ids the client has no reason to hold, and
   * a half-applied edit is a total that does not match its own rows.
   */
  lines: z40.array(liquidationLineSchema).min(1, "Add at least one expense"),
  /** Unspent cash being handed back with the receipts. */
  cashReturned: returnedAmountSchema.default(0),
  remarks: optionalString(500)
});
var verifyLiquidationSchema = z40.object({
  approved: z40.boolean(),
  /**
   * Required on a rejection. Sending a liquidation back without saying which
   * line is wrong makes the holder guess, and they will resubmit the same
   * thing.
   */
  remarks: optionalString(500),
  /**
   * What HR actually received in cash, when that differs from what the holder
   * declared. Absent means "the declared figure is right".
   */
  cashReturnedActual: returnedAmountSchema.nullish()
}).refine((data) => data.approved || Boolean(data.remarks?.trim()), {
  path: ["remarks"],
  message: "Say what needs correcting \u2014 a rejection with no reason cannot be acted on"
});
var round23 = (value) => Math.round(value * 100) / 100;
var peso = (value) => `\u20B1${Math.abs(value).toFixed(2)}`;
function liquidationOutcome(input) {
  const ledger = fundAccountability({
    released: input.released,
    liquidated: input.spent,
    returned: input.returned
  });
  const variance = ledger.outstanding;
  const spent = round23(input.spent);
  const released = round23(input.released);
  if (spent > released) {
    return {
      released,
      spent,
      returned: ledger.returned,
      variance,
      requestStatus: FundRequestStatus.REIMBURSEMENT_REQUIRED,
      summary: `Spent ${peso(spent - released)} more than was released \u2014 the company owes ${peso(spent - released)}.`
    };
  }
  if (variance > 0) {
    return {
      released,
      spent,
      returned: ledger.returned,
      variance,
      requestStatus: FundRequestStatus.FUND_RETURN_REQUIRED,
      summary: `${peso(variance)} of company cash is still unaccounted for.`
    };
  }
  return {
    released,
    spent,
    returned: ledger.returned,
    variance,
    requestStatus: FundRequestStatus.FULLY_LIQUIDATED,
    summary: "Fully accounted for \u2014 nothing outstanding."
  };
}
function totalOfLines(lines) {
  return round23(lines.reduce((sum, line) => sum + line.amount, 0));
}

// src/dto/fund-settlement.ts
import { z as z41 } from "zod";
var FUND_SETTLEMENT_KINDS = [
  "RETURN",
  "REIMBURSEMENT"
];
var FUND_SETTLEMENT_KIND_LABELS = {
  RETURN: "Cash returned",
  REIMBURSEMENT: "Reimbursement paid"
};
var settlementAmountSchema = z41.number().positive("Settle more than zero").max(9999999999e-2).refine((value) => Math.abs(value * 100 - Math.round(value * 100)) < 1e-6, {
  message: "Amounts are to the centavo"
});
var recordFundSettlementSchema = z41.object({
  amount: settlementAmountSchema,
  method: z41.enum(FUND_RELEASE_METHODS),
  referenceNo: optionalString(100),
  remarks: optionalString(500)
}).refine((data) => !releaseRequiresReference(data.method) || Boolean(data.referenceNo?.trim()), {
  path: ["referenceNo"],
  message: "A non-cash settlement needs its reference number"
}).refine((data) => releaseRequiresReference(data.method) || !data.referenceNo?.trim(), {
  path: ["referenceNo"],
  message: "Cash has no reference number \u2014 record the detail in remarks instead"
});

// src/dto/fund-attachment.ts
import { z as z42 } from "zod";
var FUND_ATTACHMENT_KINDS = [
  "TRANSFER_PROOF",
  "RECEIPT",
  "PURCHASE_PROOF"
];
var FUND_ATTACHMENT_KIND_LABELS = {
  TRANSFER_PROOF: "Proof of transfer",
  RECEIPT: "Receipt",
  PURCHASE_PROOF: "Proof of purchase"
};
var FUND_ATTACHMENT_KIND_HINTS = {
  TRANSFER_PROOF: "The screenshot of the transfer, from the bank or GCash app.",
  RECEIPT: "The official receipt or sales invoice.",
  PURCHASE_PROOF: "A photograph of what was bought, or the delivery."
};
var FUND_ATTACHMENT_MAX_BYTES = 5242880;
var FUND_ATTACHMENT_MIME = ["image/jpeg", "image/png", "image/webp"];
var FUND_ATTACHMENT_MIME_LABEL = "JPG, PNG or WebP";
var uploadFundAttachmentSchema = z42.object({
  kind: z42.enum(FUND_ATTACHMENT_KINDS),
  caption: optionalString(200),
  /**
   * The expense line this evidences, when it evidences one.
   *
   * Optional because a single photograph often covers several lines — one
   * receipt for four items entered separately — and forcing a choice would
   * make somebody upload the same picture four times.
   */
  liquidationLineId: uuidSchema.nullish()
});

// src/dto/expense-report.ts
import { z as z43 } from "zod";
var expenseReportQuerySchema = z43.object({
  from: dateOnlySchema,
  to: dateOnlySchema
}).refine((data) => data.to >= data.from, {
  path: ["to"],
  message: "The end of the period cannot be before its start"
});

// src/dto/attendance-allowance.ts
function workingDaysPerRun(workingDaysPerMonth, runsPerYear = 52) {
  if (!Number.isFinite(workingDaysPerMonth) || workingDaysPerMonth <= 0) return 0;
  if (!Number.isFinite(runsPerYear) || runsPerYear <= 0) return 0;
  return workingDaysPerMonth * 12 / runsPerYear;
}
function attendanceAdjustedAllowance(perRunAmount, attendance, daysPerRun) {
  const { daysWorked, leaveDaysPaid, paidHolidayDays, holidayDaysWorked, restDaysWorked } = attendance;
  const earnedDays = daysWorked + leaveDaysPaid + paidHolidayDays + holidayDaysWorked + restDaysWorked;
  if (earnedDays <= 0) return 0;
  if (daysPerRun <= 0) return perRunAmount;
  const earned = perRunAmount / daysPerRun * earnedDays;
  const capped = Math.min(perRunAmount, earned);
  return Math.round(capped * 100) / 100;
}

// src/dto/attendance-import.ts
var ATTENDANCE_IMPORT_HEADERS = [
  "employee_no",
  "date",
  "time_in",
  "time_out",
  "remarks"
];
function splitCsvLine(line) {
  const out = [];
  let field = "";
  let quoted = false;
  for (let i = 0; i < line.length; i += 1) {
    const char = line[i];
    if (quoted) {
      if (char === '"') {
        if (line[i + 1] === '"') {
          field += '"';
          i += 1;
        } else {
          quoted = false;
        }
      } else {
        field += char;
      }
      continue;
    }
    if (char === '"') quoted = true;
    else if (char === ",") {
      out.push(field);
      field = "";
    } else field += char;
  }
  out.push(field);
  return out.map((value) => value.trim());
}
var DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
function isRealDate(value) {
  if (!DATE_PATTERN.test(value)) return false;
  const parsed = /* @__PURE__ */ new Date(`${value}T00:00:00.000Z`);
  return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
}
function normaliseTime(raw) {
  const value = raw.trim().toUpperCase();
  if (value === "") return null;
  const match = /^(\d{1,2}):(\d{2})\s*(AM|PM)?$/.exec(value);
  if (!match) return false;
  let hour = Number(match[1]);
  const minute = Number(match[2]);
  const meridiem = match[3];
  if (minute > 59) return false;
  if (meridiem === "AM") {
    if (hour < 1 || hour > 12) return false;
    if (hour === 12) hour = 0;
  } else if (meridiem === "PM") {
    if (hour < 1 || hour > 12) return false;
    if (hour !== 12) hour += 12;
  } else if (hour > 23) return false;
  return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
}
function parseAttendanceCsv(text) {
  const rows = [];
  const errors = [];
  const lines = text.replace(/^﻿/, "").split(/\r?\n/);
  const headerLine = lines[0];
  if (!headerLine || headerLine.trim() === "") {
    return { rows, errors: [{ line: 1, message: "The file is empty." }] };
  }
  const headers = splitCsvLine(headerLine).map((value) => value.toLowerCase());
  const index = (name) => headers.indexOf(name);
  for (const required of ["employee_no", "date"]) {
    if (index(required) === -1) {
      errors.push({ line: 1, message: `Missing the "${required}" column.` });
    }
  }
  if (errors.length > 0) return { rows, errors };
  const seen = /* @__PURE__ */ new Set();
  for (let i = 1; i < lines.length; i += 1) {
    const raw = lines[i];
    if (raw === void 0 || raw.trim() === "") continue;
    const line = i + 1;
    const cells = splitCsvLine(raw);
    const at = (name) => {
      const position = index(name);
      return position === -1 ? "" : cells[position] ?? "";
    };
    const employeeNo = at("employee_no").toUpperCase();
    const date = at("date");
    if (!employeeNo) {
      errors.push({ line, message: "No employee number." });
      continue;
    }
    if (!isRealDate(date)) {
      errors.push({ line, message: `"${date}" is not a date in YYYY-MM-DD form.` });
      continue;
    }
    const timeIn = normaliseTime(at("time_in"));
    if (timeIn === false) {
      errors.push({ line, message: `"${at("time_in")}" is not a time. Use 24-hour HH:MM.` });
      continue;
    }
    const timeOut = normaliseTime(at("time_out"));
    if (timeOut === false) {
      errors.push({ line, message: `"${at("time_out")}" is not a time. Use 24-hour HH:MM.` });
      continue;
    }
    if (timeIn === null && timeOut !== null) {
      errors.push({ line, message: "There is a clock-out with no clock-in." });
      continue;
    }
    const key = `${employeeNo}|${date}`;
    if (seen.has(key)) {
      errors.push({ line, message: `${employeeNo} already has a row for ${date}.` });
      continue;
    }
    seen.add(key);
    rows.push({
      line,
      employeeNo,
      date,
      timeIn,
      timeOut,
      remarks: at("remarks") || null
    });
  }
  return { rows, errors };
}

// src/dto/contribution-import.ts
var CONTRIBUTION_AMOUNT_COLUMNS = [
  "sss_employee",
  "philhealth_employee",
  "pagibig_employee",
  "withholding_tax",
  "sss_employer",
  "philhealth_employer",
  "pagibig_employer"
];
function parseAmount(raw) {
  const value = raw.trim().replace(/^₱\s*/, "");
  if (value === "") return 0;
  if (!/^\d+(\.\d{1,2})?$/.test(value)) return false;
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : false;
}
function parseContributionsCsv(text) {
  const rows = [];
  const errors = [];
  const lines = text.replace(/^﻿/, "").split(/\r?\n/);
  const headerLine = lines[0];
  if (!headerLine || headerLine.trim() === "") {
    return { rows, errors: [{ line: 1, message: "The file is empty." }] };
  }
  const headers = splitCsvLine(headerLine).map((value) => value.toLowerCase());
  const index = (name) => headers.indexOf(name);
  for (const required of ["employee_no", "period_start", "period_end"]) {
    if (index(required) === -1) {
      errors.push({ line: 1, message: `Missing the "${required}" column.` });
    }
  }
  if (errors.length > 0) return { rows, errors };
  const seen = /* @__PURE__ */ new Set();
  for (let i = 1; i < lines.length; i += 1) {
    const raw = lines[i];
    if (raw === void 0 || raw.trim() === "") continue;
    const line = i + 1;
    const cells = splitCsvLine(raw);
    const at = (name) => {
      const position = index(name);
      return position === -1 ? "" : cells[position] ?? "";
    };
    const employeeNo = at("employee_no").toUpperCase();
    const periodStart = at("period_start");
    const periodEnd = at("period_end");
    if (!employeeNo) {
      errors.push({ line, message: "No employee number." });
      continue;
    }
    if (!isRealDate(periodStart) || !isRealDate(periodEnd)) {
      errors.push({ line, message: "Both period dates must be real dates in YYYY-MM-DD form." });
      continue;
    }
    if (periodEnd < periodStart) {
      errors.push({ line, message: `The period ends (${periodEnd}) before it starts.` });
      continue;
    }
    const amounts = {};
    let bad = false;
    for (const column of CONTRIBUTION_AMOUNT_COLUMNS) {
      const parsed = parseAmount(at(column));
      if (parsed === false) {
        errors.push({
          line,
          message: `"${at(column)}" in ${column} is not an amount. Use plain numbers like 178.85 \u2014 no commas.`
        });
        bad = true;
        break;
      }
      amounts[column] = parsed;
    }
    if (bad) continue;
    const key = `${employeeNo}|${periodStart}|${periodEnd}`;
    if (seen.has(key)) {
      errors.push({
        line,
        message: `${employeeNo} already has a row for ${periodStart} to ${periodEnd}.`
      });
      continue;
    }
    seen.add(key);
    rows.push({
      line,
      employeeNo,
      periodStart,
      periodEnd,
      sssEmployee: amounts.sss_employee ?? 0,
      philhealthEmployee: amounts.philhealth_employee ?? 0,
      pagibigEmployee: amounts.pagibig_employee ?? 0,
      withholdingTax: amounts.withholding_tax ?? 0,
      sssEmployer: amounts.sss_employer ?? 0,
      philhealthEmployer: amounts.philhealth_employer ?? 0,
      pagibigEmployer: amounts.pagibig_employer ?? 0
    });
  }
  return { rows, errors };
}

// src/dto/thirteenth-month.ts
function thirteenthMonthPay(basicEarnedThisYear) {
  if (!Number.isFinite(basicEarnedThisYear) || basicEarnedThisYear <= 0) return 0;
  return Math.round(basicEarnedThisYear / 12 * 100) / 100;
}

// src/dto/attendance-week.ts
function toUtc(date) {
  return /* @__PURE__ */ new Date(`${date}T00:00:00.000Z`);
}
function toIso(date) {
  return date.toISOString().slice(0, 10);
}
function addDays(date, days) {
  const shifted = toUtc(date);
  shifted.setUTCDate(shifted.getUTCDate() + days);
  return toIso(shifted);
}
function payWeekOf(date) {
  const start = addDays(date, -toUtc(date).getUTCDay());
  return { start, end: addDays(start, 6) };
}
function shiftPayWeek(week, shift) {
  const start = addDays(week.start, shift * 7);
  return { start, end: addDays(start, 6) };
}
function formatPayWeek(week, locale = "en-PH") {
  const start = toUtc(week.start);
  const end = toUtc(week.end);
  const day = (value, withYear) => value.toLocaleDateString(locale, {
    month: "short",
    day: "numeric",
    ...withYear ? { year: "numeric" } : {},
    timeZone: "UTC"
  });
  const sameYear = start.getUTCFullYear() === end.getUTCFullYear();
  return sameYear ? `${day(start, false)} \u2013 ${day(end, true)}` : `${day(start, true)} \u2013 ${day(end, true)}`;
}

// src/dto/evidence-lock.ts
function holderEvidenceLock(liquidationStatus) {
  if (liquidationStatus === "SUBMITTED") return "FILED";
  if (liquidationStatus === "VERIFIED") return "VERIFIED";
  return "OPEN";
}
function canEditHolderEvidence(liquidationStatus) {
  return holderEvidenceLock(liquidationStatus) === "OPEN";
}
var EVIDENCE_LOCK_MESSAGES = {
  FILED: "This liquidation has been filed and is being checked. Ask HR to send it back if something needs changing.",
  VERIFIED: "This liquidation has been verified. Ask HR to send it back before adding more evidence."
};

// src/dto/pending-counts.ts
var EMPTY_PENDING_COUNTS = {
  fundApprovals: 0,
  fundReleases: 0,
  liquidationsToVerify: 0,
  expenseClaimApprovals: 0
};

// src/dto/fuel-log.ts
import { z as z44 } from "zod";
var litresSchema = z44.number().positive("Litres must be more than zero").max(1e3, "That is more than any tank on the road \u2014 check the figure").refine((value) => Math.abs(value * 1e3 - Math.round(value * 1e3)) < 1e-6, {
  message: "Litres go to at most three decimal places"
});
var pesoSchema = z44.number().positive("Cost must be more than zero").max(999999.99).refine((value) => Math.abs(value * 100 - Math.round(value * 100)) < 1e-6, {
  message: "Amounts are to the centavo"
});
var createFuelLogSchema = z44.object({
  vehicleId: uuidSchema,
  loggedOn: dateOnlySchema,
  odometerKm: z44.number().int("Give the reading in whole kilometres").min(0).max(9999999),
  litres: litresSchema,
  totalCost: pesoSchema,
  /**
   * Whether the tank was filled to full.
   *
   * The single most important field here and the one nobody wants to tick. Only
   * a full-to-full pair yields a real consumption figure; a partial fill still
   * counts toward the next full one, so nothing is lost by being honest.
   */
  isFullTank: z44.boolean(),
  station: optionalString(120),
  receiptNo: optionalString(100),
  /** The advance this was paid from, when it was paid from one. */
  fundRequestId: uuidSchema.nullish(),
  remarks: optionalString(500)
});
var round = (value, places) => {
  const factor = 10 ** places;
  return Math.round(value * factor) / factor;
};
function fuelEconomy(logs) {
  const ordered = [...logs].sort(
    (a, b) => a.odometerKm - b.odometerKm || a.loggedOn.localeCompare(b.loggedOn)
  );
  return ordered.map((log, index) => {
    const previous = index > 0 ? ordered[index - 1] : void 0;
    const distanceKm = previous ? log.odometerKm - previous.odometerKm : null;
    const base = {
      ...log,
      distanceKm,
      kmPerLitre: null,
      costPerKm: null,
      economyNote: null
    };
    if (index === 0) {
      return { ...base, economyNote: "First reading \u2014 there is nothing to measure from yet." };
    }
    if (!log.isFullTank) {
      return {
        ...base,
        economyNote: "Partial fill \u2014 these litres count toward the next full tank."
      };
    }
    let start = -1;
    for (let candidate = index - 1; candidate >= 0; candidate -= 1) {
      if (ordered[candidate]?.isFullTank) {
        start = candidate;
        break;
      }
    }
    if (start === -1) {
      return {
        ...base,
        economyNote: "No earlier full tank to measure from."
      };
    }
    const from = ordered[start];
    if (!from) return base;
    const stretchKm = log.odometerKm - from.odometerKm;
    if (stretchKm <= 0) {
      return {
        ...base,
        economyNote: "The odometer did not move between full tanks."
      };
    }
    let litresUsed = 0;
    let costUsed = 0;
    for (let position = start + 1; position <= index; position += 1) {
      const entry = ordered[position];
      if (!entry) continue;
      litresUsed += entry.litres;
      costUsed += entry.totalCost;
    }
    if (litresUsed <= 0) return base;
    return {
      ...base,
      kmPerLitre: round(stretchKm / litresUsed, 2),
      costPerKm: round(costUsed / stretchKm, 2),
      economyNote: null
    };
  });
}
function summariseFuel(logs) {
  const ordered = [...logs].sort(
    (a, b) => a.odometerKm - b.odometerKm || a.loggedOn.localeCompare(b.loggedOn)
  );
  const totalLitres = round(
    ordered.reduce((sum, log) => sum + log.litres, 0),
    3
  );
  const totalCost = round(
    ordered.reduce((sum, log) => sum + log.totalCost, 0),
    2
  );
  const first = ordered[0];
  const last = ordered[ordered.length - 1];
  const distanceKm = first && last ? last.odometerKm - first.odometerKm : 0;
  const fullTanks = ordered.filter((log) => log.isFullTank);
  const firstFull = fullTanks[0];
  const lastFull = fullTanks[fullTanks.length - 1];
  let kmPerLitre = null;
  let costPerKm = null;
  if (firstFull && lastFull && fullTanks.length >= 2) {
    const stretchKm = lastFull.odometerKm - firstFull.odometerKm;
    const consumed = ordered.filter(
      (log) => log.odometerKm > firstFull.odometerKm && log.odometerKm <= lastFull.odometerKm
    );
    const litres = consumed.reduce((sum, log) => sum + log.litres, 0);
    const cost = consumed.reduce((sum, log) => sum + log.totalCost, 0);
    if (stretchKm > 0 && litres > 0) {
      kmPerLitre = round(stretchKm / litres, 2);
      costPerKm = round(cost / stretchKm, 2);
    }
  }
  return {
    totalLitres,
    totalCost,
    distanceKm,
    kmPerLitre,
    costPerKm,
    fillCount: ordered.length,
    fullTankCount: fullTanks.length
  };
}

// src/dto/expense-claim.ts
import { z as z45 } from "zod";
var lineAmountSchema = z45.number().positive("An expense line must be more than zero").max(9999999999e-2).refine((value) => Math.abs(value * 100 - Math.round(value * 100)) < 1e-6, {
  message: "Amounts are to the centavo"
});
var expenseClaimLineSchema = z45.object({
  categoryId: uuidSchema,
  description: requiredString(200, "What it was for"),
  amount: lineAmountSchema,
  spentOn: dateOnlySchema,
  /** Optional for the same reason liquidation's is: a fare has no receipt. */
  receiptNo: optionalString(100)
});
var saveExpenseClaimSchema = z45.object({
  purpose: requiredString(200, "Purpose"),
  /**
   * The whole set, every time — the same rule liquidation follows. A
   * half-applied edit leaves a stored total that disagrees with its own rows,
   * and the total is what chooses the approvers.
   */
  lines: z45.array(expenseClaimLineSchema).min(1, "Add at least one expense"),
  remarks: optionalString(500)
});
var decideExpenseClaimSchema = z45.object({
  approved: z45.boolean(),
  /** Required on a refusal: "no" with no reason is not a decision anyone can act on. */
  remarks: optionalString(500)
});
var payExpenseClaimSchema = z45.object({
  amount: lineAmountSchema,
  method: z45.enum(["CASH", "BANK_TRANSFER", "GCASH", "CHECK"]),
  referenceNo: optionalString(100),
  remarks: optionalString(500)
}).refine((data) => data.method === "CASH" || Boolean(data.referenceNo?.trim()), {
  path: ["referenceNo"],
  message: "A non-cash payment needs its reference number"
}).refine((data) => data.method !== "CASH" || !data.referenceNo?.trim(), {
  path: ["referenceNo"],
  message: "Cash has no reference number \u2014 record the detail in remarks instead"
});
var EXPENSE_CLAIM_STATUS_LABELS = {
  DRAFT: "Draft",
  SUBMITTED: "Submitted",
  MANAGER_REVIEW: "With the manager",
  HR_REVIEW: "With HR",
  MANAGEMENT_REVIEW: "With management",
  APPROVED: "Approved \u2014 awaiting payment",
  REJECTED: "Rejected",
  PAID: "Paid",
  CANCELLED: "Cancelled"
};
function expenseClaimNo(year, sequence) {
  return `EC-${year}-${String(sequence).padStart(6, "0")}`;
}
function claimStatusForProgress(progress) {
  if (progress.kind === "APPROVED") return ExpenseClaimStatus.APPROVED;
  if (progress.kind === "REJECTED") return ExpenseClaimStatus.REJECTED;
  if (progress.kind === "AWAITING") {
    const level = progress.level;
    if (level === "MANAGER") return ExpenseClaimStatus.MANAGER_REVIEW;
    if (level === "HR") return ExpenseClaimStatus.HR_REVIEW;
    if (level === "MANAGEMENT") return ExpenseClaimStatus.MANAGEMENT_REVIEW;
  }
  return ExpenseClaimStatus.SUBMITTED;
}
function totalOfClaimLines(lines) {
  return Math.round(lines.reduce((sum, line) => sum + line.amount, 0) * 100) / 100;
}

// src/dto/budget.ts
import { z as z46 } from "zod";
var createBudgetSchema = z46.object({
  name: requiredString(120, "Name"),
  /** Null means every category — a department-wide or company-wide budget. */
  categoryId: uuidSchema.nullish(),
  /** Null means the whole company. */
  departmentId: uuidSchema.nullish(),
  periodStart: dateOnlySchema,
  periodEnd: dateOnlySchema,
  amount: moneySchema("Budget"),
  /**
   * Percentage of the budget at which the screen starts warning. Not a
   * blocker — a budget that stops work is a budget people route around.
   */
  warnAtPercent: z46.number().int().min(1).max(100).default(80),
  remarks: optionalString(500)
}).refine((data) => data.periodEnd >= data.periodStart, {
  path: ["periodEnd"],
  message: "The end of the period cannot be before its start"
});
var updateBudgetSchema = createBudgetSchema;
var round24 = (value) => Math.round(value * 100) / 100;
function budgetPosition(input) {
  const budgeted = round24(input.budgeted);
  const committed = round24(input.committed);
  const actual = round24(input.actual);
  const used = round24(actual + committed);
  const remaining = round24(budgeted - used);
  const exact = budgeted > 0 ? used / budgeted * 100 : used > 0 ? 100 : 0;
  const utilisation = Math.round(exact * 10) / 10;
  const state = remaining < 0 ? "EXCEEDED" : exact >= input.warnAtPercent ? "WARNING" : "WITHIN";
  return { budgeted, committed, actual, used, remaining, utilisation, state };
}
export {
  ACCESS_SCOPES,
  ADMIN_ONLY_PERMISSIONS,
  ALL_NOTIFICATION_TYPES,
  ALL_PERMISSIONS,
  ANNOUNCEMENT_AUDIENCE_LABELS,
  ANNOUNCEMENT_STATUS_LABELS,
  API_ERROR_CODES,
  ASSET_CONDITION_LABELS,
  ASSET_STATUS_LABELS,
  ATTENDANCE_IMPORT_HEADERS,
  ATTENDANCE_SOURCE_LABELS,
  ATTENDANCE_STATUS_LABELS,
  ATTENDED_STATUSES,
  AUDIT_ACTION_LABELS,
  AWARD_CATEGORY_LABELS,
  AnnouncementAudience,
  AnnouncementStatus,
  ApprovalAction,
  ApprovalLevel,
  ApprovalStatus,
  AssetAssignmentStatus,
  AssetCondition,
  AssetStatus,
  AttachableType,
  AttendancePhotoKind,
  AttendanceSource,
  AttendanceStatus,
  AuditAction,
  AwardCategory,
  BANK_ACCOUNT_TYPE_LABELS,
  BankAccountType,
  CASE_TRANSITIONS,
  CHAT_ATTACHMENTS_PER_MESSAGE,
  CHAT_ATTACHMENT_ACCEPT,
  CHAT_ATTACHMENT_LABELS,
  CHAT_ATTACHMENT_MAX_BYTES,
  CHAT_BODY_MAX,
  CHAT_FILE_MIME,
  CHAT_GROUP_MAX_MEMBERS,
  CHAT_IMAGE_MIME,
  CHAT_MENTIONS_PER_MESSAGE,
  CHAT_PAGE_SIZE,
  CHAT_REACTIONS,
  CHAT_REACTION_EMOJI,
  CHAT_REACTION_LABELS,
  CHAT_SEARCH_LIMIT,
  CHAT_TITLE_MAX,
  CHAT_UPLOAD_MAX_BYTES,
  CHAT_VIDEO_MIME,
  CLEARANCE_STATUS_LABELS,
  CLOSING_STATUSES,
  COMPANY_UTC_OFFSET,
  CONTRIBUTION_AMOUNT_COLUMNS,
  CONTRIBUTION_COLUMNS,
  CONTRIBUTION_TYPE_LABELS,
  COVERAGE_STATUS_LABELS,
  CUTOFF_DAY_NOTICE,
  CYCLE_STATUS_LABELS,
  CYCLE_TRANSITIONS,
  ChatAttachmentKind,
  ChatMessageKind,
  ChatReactionKind,
  ChatThreadKind,
  CivilStatus,
  ClearanceStatus,
  ContributionType,
  CoverageStatus,
  DAY_PORTION_LABELS,
  DEFAULT_FUND_APPROVAL_POLICY,
  DEFAULT_PAGE_SIZE,
  DEFAULT_ROLE_PERMISSIONS,
  DEVICE_TOKEN_PREFIX,
  DEVICE_TOKEN_VISIBLE_CHARS,
  DISCIPLINARY_ACTION_LABELS,
  DISCIPLINARY_SEVERITY_LABELS,
  DISCIPLINARY_STATUS_LABELS,
  DOCUMENT_VISIBILITY_LABELS,
  DayPortion,
  DisciplinaryActionType,
  DisciplinarySeverity,
  DisciplinaryStatus,
  DocumentVisibility,
  EMPTY_PENDING_COUNTS,
  ENROLLMENT_STATUS_LABELS,
  EVIDENCE_LOCK_MESSAGES,
  EXPENSE_CLAIM_STATUS_LABELS,
  EmailStatus,
  EmployeeStatus,
  EmploymentStatus,
  EnrollmentStatus,
  ExpenseClaimStatus,
  FINAL_PAY_STATUS_LABELS,
  FINAL_PAY_TRANSITIONS,
  FINANCE_NOTIFICATION_TYPES,
  FUEL_TYPE_LABELS,
  FUND_APPROVAL_LEVELS,
  FUND_ATTACHMENT_KINDS,
  FUND_ATTACHMENT_KIND_HINTS,
  FUND_ATTACHMENT_KIND_LABELS,
  FUND_ATTACHMENT_MAX_BYTES,
  FUND_ATTACHMENT_MIME,
  FUND_ATTACHMENT_MIME_LABEL,
  FUND_RELEASE_METHODS,
  FUND_RELEASE_METHOD_LABELS,
  FUND_REQUEST_STATUS_LABELS,
  FUND_SETTLEMENT_KINDS,
  FUND_SETTLEMENT_KIND_LABELS,
  FinalPayStatus,
  FuelType,
  FundApprovalLevel,
  FundAttachmentKind,
  FundReleaseMethod,
  FundRequestStatus,
  FundSettlementKind,
  GOAL_STATUS_LABELS,
  Gender,
  GoalStatus,
  HOLIDAY_DEFAULT_MULTIPLIERS,
  HOLIDAY_TYPE_LABELS,
  HolidayType,
  InsurancePolicyType,
  LEAVE_STATUS_LABELS,
  statusValues3 as LEAVE_STATUS_VALUES,
  LIQUIDATION_STATUS_LABELS,
  LOCATION_BATCH_MAX,
  LOCATION_BATCH_MAX_AGE_HOURS,
  LOCATION_FRESH_WITHIN_MINUTES,
  LOCATION_PRECISE_WITHIN_METRES,
  LOCATION_STALE_AFTER_MINUTES,
  LeaveRequestStatus,
  LiquidationStatus,
  LocationPingSource,
  MAIL_PASSWORD_KEY,
  MANDATORY_NOTIFICATION_TYPES,
  MAX_PAGE_SIZE,
  MINIMUM_NOTICE_DAYS,
  MOVEMENT_TYPE_LABELS,
  MovementType,
  NOTIFICATION_TYPES,
  NotificationChannel,
  OUTSTANDING_CLEARANCE,
  PAYROLL_PERIODS_PER_YEAR,
  PAYROLL_RUN_STATUS_LABELS,
  PAY_COMPONENT_BASIS,
  PAY_COMPONENT_BASIS_LABELS,
  PERMISSIONS,
  PERMISSION_CATALOGUE,
  PERMISSION_LABELS,
  PH_FIXED_HOLIDAYS,
  PH_MOVABLE_HOLIDAYS,
  POLICY_TYPE_LABELS,
  PayComponentBasis,
  PayComponentType,
  PayFrequency,
  PayrollPeriodStatus,
  PayrollRunStatus,
  QUEUES,
  REGISTRATION_DUE_SOON_DAYS,
  REGISTRATION_STATE_LABELS,
  REQUEST_PRIORITY_LABELS,
  REQUEST_STATUS_LABELS,
  REQUEST_TRANSITIONS,
  RESIGNATION_STATUS_LABELS,
  RESIGNATION_TRANSITIONS,
  REST_DAY_VARIANCE_TOLERANCE_MINUTES,
  REVIEW_STATUS_LABELS,
  REVIEW_TRANSITIONS,
  RequestPriority,
  RequestStatus,
  ResignationStatus,
  ReviewCycleStatus,
  ReviewStatus,
  Role,
  SERVICE_DUE_SOON_KM,
  SERVICE_STATE_LABELS,
  SESSION_STATUS_LABELS,
  SETTING_GROUPS,
  SETTING_KEYS,
  SETTING_SCHEMAS,
  SETTING_SECTIONS,
  SSS_DEFAULT_PARAMETERS,
  SSS_PROVENANCE,
  THREAD_BODY_MAX,
  THREAD_DELETED_BODY,
  THREAD_PAGE_SIZE,
  TRAINING_TYPE_LABELS,
  TRAIN_ANNUAL_BRACKETS,
  ThreadSubject,
  TrainingSessionStatus,
  TrainingType,
  UNOBSERVED_ATTENDANCE_SOURCES,
  UserStatus,
  VEHICLE_STATUS_LABELS,
  VehicleStatus,
  WEEKDAYS,
  WEEKDAY_OPTIONS,
  WITHHOLDING_PROVENANCE,
  acceptTermsSchema,
  acknowledgeFundReleaseSchema,
  addChatMembersSchema,
  analyticsQuerySchema,
  announcementQuerySchema,
  approvalLevelsFor,
  approvalProgress,
  assetQuerySchema,
  assignAllowanceSchema,
  assignAssetSchema,
  assignDeductionSchema,
  assignEmployeeScheduleSchema,
  assignmentQuerySchema,
  attendanceAdjustedAllowance,
  attendanceQuerySchema,
  attendanceRulesSchema,
  auditQuerySchema,
  awardQuerySchema,
  beneficiarySchema,
  blocksPayroll,
  booleanQuery,
  budgetPosition,
  buildPaginationMeta,
  canAcknowledgeRestDay,
  canEditHolderEvidence,
  cancelLeaveSchema,
  caseQuerySchema,
  chatAttachmentKindOf,
  chatMessagesQuerySchema,
  chatSchema,
  chatSearchQuerySchema,
  claimStatusForProgress,
  classifyRestDayWork,
  computeFinalPaySchema,
  contributionBracketSchema,
  countOf,
  coverageQuerySchema,
  createActionSchema,
  createAllowanceTypeSchema,
  createAnnouncementSchema,
  createAssetCategorySchema,
  createAssetSchema,
  createAwardTypeSchema,
  createBudgetSchema,
  createCaseSchema,
  createChatThreadSchema,
  createClearanceItemSchema,
  createCorrectionSchema,
  createCycleSchema,
  createDeductionTypeSchema,
  createDepartmentSchema,
  createDirectThreadSchema,
  createDocumentCategorySchema,
  createEmployeeSchema,
  createExpenseCategorySchema,
  createFuelLogSchema,
  createFundReleaseSchema,
  createFundRequestSchema,
  createGoalSchema,
  createGroupThreadSchema,
  createHolidaySchema,
  createKpiSchema,
  createLeaveRequestSchema,
  createLocationPingBatchSchema,
  createLocationPingSchema,
  createPeriodSchema,
  createPolicySchema,
  createPositionSchema,
  createProgramSchema,
  createProviderSchema,
  createRequestSchema,
  createRequestTypeSchema,
  createRunSchema,
  createSalaryGradeSchema,
  createSessionSchema,
  createUserSchema,
  createVehicleSchema,
  createWorkScheduleSchema,
  dateOnlySchema,
  decideExpenseClaimSchema,
  decideFundRequestSchema,
  departmentQuerySchema,
  describeAcknowledgeRefusal,
  describeFixSource,
  describeLastSeen,
  describePasswordRules,
  describeRestDayVerdict,
  describeWorkingDays,
  discussionSchema,
  dispositionFor,
  documentQuerySchema,
  editChatMessageSchema,
  editThreadMessageSchema,
  emailSchema,
  emergencyContactSchema,
  employeeHistoryQuerySchema,
  employeeQuerySchema,
  enrolEmployeesSchema,
  enrolSchema,
  expenseClaimLineSchema,
  expenseClaimNo,
  expenseReportQuerySchema,
  findMentionSpans,
  formatBytes,
  formatMinutes,
  formatPayWeek,
  fuelEconomy,
  fundAccountability,
  fundApprovalPolicySchema,
  fundApprovalTierSchema,
  fundRequestNo,
  generalLocaleSchema,
  govIdSchema,
  grantAwardSchema,
  grantLeaveBalancesSchema,
  holderEvidenceLock,
  holidayQuerySchema,
  importContributionTableSchema,
  isAdminOnly,
  isApiErrorResponse,
  isFresh,
  isPreciseFix,
  isRealDate,
  isStale,
  issueRestDayAuthorisationSchema,
  leaveQuerySchema,
  leaveRulesSchema,
  legalTermsSchema,
  liquidationLineSchema,
  liquidationOutcome,
  listOf,
  locationPingBatchEntrySchema,
  locationTrackingSchema,
  looksLikeDesktopBrowser,
  mailSmtpSchema,
  markChatReadSchema,
  mobileNumberSchema,
  moneySchema,
  normaliseTime,
  notificationRetentionSchema,
  odometerProblem,
  openReviewsSchema,
  optionalDateOnly,
  optionalEmail,
  optionalPhone,
  optionalString,
  optionalUuid,
  ordinal,
  paginationQuerySchema,
  parseAmount,
  parseAttendanceCsv,
  parseContributionsCsv,
  payExpenseClaimSchema,
  payWeekOf,
  payrollPeriodGate,
  payrollQuerySchema,
  payrollRatesSchema,
  payrollScheduleSchema,
  personName,
  planScheduleAssignment,
  positionQuerySchema,
  postChatMessageSchema,
  postThreadMessageSchema,
  previousDay,
  punchCaptureSchema,
  punchSchema,
  readableName,
  recomputeRangeSchema,
  recordFundSettlementSchema,
  registerDeviceSchema,
  registerPushDeviceSchema,
  registrationSortKey,
  registrationStatus,
  registrationSummary,
  releaseRequiresReference,
  renameChatThreadSchema,
  renameContributionTableSchema,
  requestQuerySchema,
  requiredString,
  resignationQuerySchema,
  resolveLeaveBalance,
  resolveScope,
  respondToCaseSchema,
  returnAssetSchema,
  reviewCorrectionSchema,
  reviewLeaveSchema,
  reviewPunchSchema,
  reviewQuerySchema,
  revokeRestDayAuthorisationSchema,
  saveExpenseClaimSchema,
  saveLiquidationSchema,
  saveReviewSchema,
  scoreSchema,
  securityPolicySchema,
  serviceStatus,
  sessionQuerySchema,
  setChatNameSchema,
  setChatReactionSchema,
  setLeaveBalanceSchema,
  shiftPayWeek,
  sortOrderSchema,
  splitCsvLine,
  splitMentions,
  spokenName,
  sssBracketsFor,
  statusForProgress,
  submitResignationSchema,
  suggestedHolidaysFor,
  summariseFuel,
  thirteenthMonthPay,
  toPrismaPaging,
  toPunchInstant,
  totalOfClaimLines,
  totalOfLines,
  transitionCaseSchema,
  transitionCycleSchema,
  transitionFinalPaySchema,
  transitionRequestSchema,
  transitionResignationSchema,
  transitionReviewSchema,
  uispIntegrationSchema,
  updateAllowanceTypeSchema,
  updateAnnouncementSchema,
  updateAssetCategorySchema,
  updateAssetSchema,
  updateAssignmentSchema,
  updateAwardTypeSchema,
  updateBudgetSchema,
  updateCaseSchema,
  updateClearanceItemSchema,
  updateCoverageSchema,
  updateCycleSchema,
  updateDeductionTypeSchema,
  updateDepartmentSchema,
  updateDocumentSchema,
  updateEmployeeScheduleSchema,
  updateEmployeeSchema,
  updateEnrollmentSchema,
  updateExpenseCategorySchema,
  updateFundRequestSchema,
  updateGoalSchema,
  updateHolidaySchema,
  updateKpiSchema,
  updateOwnProfileSchema,
  updatePolicySchema,
  updatePositionSchema,
  updateProgramSchema,
  updateProviderSchema,
  updateRequestSchema,
  updateRequestTypeSchema,
  updateResignationSchema,
  updateSalaryGradeSchema,
  updateSessionSchema,
  updateUserSchema,
  updateVehicleSchema,
  updateWorkScheduleSchema,
  uploadDocumentSchema,
  uploadFundAttachmentSchema,
  upperOptional,
  upperRequired,
  upsertAttendanceSchema,
  userQuerySchema,
  uuidListQuery,
  uuidSchema,
  verifyContributionTableSchema,
  verifyLiquidationSchema,
  withholdingBracketsFor,
  workScheduleQuerySchema,
  workingDaysPerRun
};
